import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AddressId: Api.AddressId;
  CaseInstructionId: Api.CaseInstructionId;
  ConditionId: Api.ConditionId;
  Date: any;
  DateString: Api.DateString;
  DateTimeString: Api.DateTimeString;
  DocumentAnalysisId: Api.DocumentAnalysisId;
  DocumentId: Api.DocumentId;
  EventLogId: Api.EventLogId;
  FaxId: Api.FaxId;
  LabRequirementId: Api.LabRequirementId;
  MedicationId: Api.MedicationId;
  MedicationInstructionId: Api.MedicationInstructionId;
  MessageId: Api.MessageId;
  ObservationId: Api.ObservationId;
  OrganizationId: Api.OrganizationId;
  PatientId: Api.PatientId;
  PayerId: Api.PayerId;
  PhoneNumber: Api.PhoneNumber;
  PlatformThreadId: Api.PlatformThreadId;
  RoleAssignmentId: Api.RoleAssignmentId;
  SignedS3DownloadUrl: Api.SignedS3DownloadUrl;
  SignedS3UploadUrl: Api.SignedS3UploadUrl;
  SurgeryId: Api.SurgeryId;
  TaskId: Api.TaskId;
  UserId: Api.UserId;
  VisitId: Api.VisitId;
};

export type Acknowledgement = {
  __typename?: 'Acknowledgement';
  acknowledgedAt: Scalars['Date'];
  docType: AcknowledgementDocType;
  id: Scalars['ID'];
  mfaCode?: Maybe<Scalars['String']>;
  patient?: Maybe<Patient>;
  patientId: Scalars['PatientId'];
  signature?: Maybe<Scalars['String']>;
};

export enum AcknowledgementDocType {
  AssignmentOfBenefits = 'ASSIGNMENT_OF_BENEFITS',
  Privacy = 'PRIVACY',
  TelehealthInformedConsent = 'TELEHEALTH_INFORMED_CONSENT',
  TermsOfUse = 'TERMS_OF_USE'
}

export type AcknowledgementInput = {
  acknowledgedAt: Scalars['Date'];
  docType: AcknowledgementDocType;
  mfaCode?: InputMaybe<Scalars['String']>;
  patientId: Scalars['PatientId'];
  signature?: InputMaybe<Scalars['String']>;
};

export type AddFacilityInput = {
  name: Scalars['String'];
  network?: InputMaybe<Scalars['String']>;
};

export type AddOrganizationInput = {
  name: Scalars['String'];
  specialty: OrganizationSpecialty;
  viewableOrganizations?: InputMaybe<Array<Scalars['OrganizationId']>>;
};

export type AddUserForOrganizationInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  organizationId: Scalars['OrganizationId'];
  phone?: InputMaybe<Scalars['PhoneNumber']>;
  role: UserRole;
};

export type Address = {
  __typename?: 'Address';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  id: Scalars['ID'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type AiAssessment = {
  __typename?: 'AiAssessment';
  allAssessmentDocIds?: Maybe<Array<Scalars['DocumentId']>>;
  patientId: Scalars['PatientId'];
  preChart?: Maybe<Scalars['String']>;
  redFlags?: Maybe<Array<RedFlag>>;
  risk?: Maybe<AiRiskAssessment>;
};


export type AiAssessmentAllAssessmentDocIdsArgs = {
  preChartDocumentId?: InputMaybe<Scalars['DocumentId']>;
  riskDocumentId?: InputMaybe<Scalars['DocumentId']>;
};


export type AiAssessmentPreChartArgs = {
  documentId?: InputMaybe<Scalars['DocumentId']>;
};


export type AiAssessmentRiskArgs = {
  documentId?: InputMaybe<Scalars['DocumentId']>;
};

export type AiRiskAssessment = {
  __typename?: 'AiRiskAssessment';
  analysis?: Maybe<Scalars['String']>;
  documentIds?: Maybe<Array<Scalars['String']>>;
  signalDocumentIds?: Maybe<Array<Scalars['String']>>;
  synthesis?: Maybe<Scalars['String']>;
};

export type AltPayerName = {
  __typename?: 'AltPayerName';
  alt_payer_name?: Maybe<Scalars['String']>;
};

export enum AnalysisType {
  AnesthesiaHistorySignalAgent = 'ANESTHESIA_HISTORY_SIGNAL_AGENT',
  CardiacSignal = 'CARDIAC_SIGNAL',
  EndocrineSignalAgent = 'ENDOCRINE_SIGNAL_AGENT',
  FaxResponseVerification = 'FAX_RESPONSE_VERIFICATION',
  FunctionalStatusSignalAgent = 'FUNCTIONAL_STATUS_SIGNAL_AGENT',
  HematologyCoagulationSignalAgent = 'HEMATOLOGY_COAGULATION_SIGNAL_AGENT',
  HepaticSignalAgent = 'HEPATIC_SIGNAL_AGENT',
  InfectiousDiseaseSignalAgent = 'INFECTIOUS_DISEASE_SIGNAL_AGENT',
  LabSignalAgent = 'LAB_SIGNAL_AGENT',
  Medication = 'MEDICATION',
  MedicationSignalAgent = 'MEDICATION_SIGNAL_AGENT',
  MusculoskeletalSignalAgent = 'MUSCULOSKELETAL_SIGNAL_AGENT',
  NeuroSignalAgent = 'NEURO_SIGNAL_AGENT',
  Ocr = 'OCR',
  OncologySignalAgent = 'ONCOLOGY_SIGNAL_AGENT',
  PreChart = 'PRE_CHART',
  PulmonarySignalAgent = 'PULMONARY_SIGNAL_AGENT',
  RedFlag = 'RED_FLAG',
  RenalSignalAgent = 'RENAL_SIGNAL_AGENT',
  RiskAssessment = 'RISK_ASSESSMENT'
}

export type Anesthesia = {
  __typename?: 'Anesthesia';
  answer: Scalars['Boolean'];
  issuesIntubating: Scalars['Boolean'];
  malignantHyperthermia: Scalars['Boolean'];
  pastProblems: Scalars['String'];
  spineProblems: Scalars['Boolean'];
  whatType: Scalars['String'];
};

export type AnesthesiaInput = {
  answer: Scalars['Boolean'];
  issuesIntubating: Scalars['Boolean'];
  malignantHyperthermia: Scalars['Boolean'];
  pastProblems: Scalars['String'];
  spineProblems: Scalars['Boolean'];
  whatType: Scalars['String'];
};

export type AssociateFaxWithSurgeryInput = {
  faxId: Scalars['FaxId'];
  fileName: Scalars['String'];
  fileType: FileType;
  surgeryId: Scalars['SurgeryId'];
};

export type AuthMutations = {
  __typename?: 'AuthMutations';
  login?: Maybe<Scalars['String']>;
};


export type AuthMutationsLoginArgs = {
  loginDetails: LoginDetails;
};

export type AuthorizedPatientMutations = {
  __typename?: 'AuthorizedPatientMutations';
  addAddress?: Maybe<Scalars['String']>;
  addCoverage?: Maybe<Scalars['String']>;
  addCoverageFromName?: Maybe<PatientCoverage>;
  generateS3Files?: Maybe<Array<Document>>;
  intakeQuestionaire?: Maybe<Query>;
  registerCareTeam?: Maybe<Array<Contact>>;
  requestRecordFromCareTeamMember?: Maybe<Scalars['String']>;
  setPreferredTimeZone?: Maybe<Scalars['Boolean']>;
  updateCoverage?: Maybe<Query>;
  uploadS3Content?: Maybe<Document>;
  validateAuth?: Maybe<Scalars['Boolean']>;
};


export type AuthorizedPatientMutationsAddAddressArgs = {
  address: AddressInput;
  patientId: Scalars['PatientId'];
};


export type AuthorizedPatientMutationsAddCoverageArgs = {
  coverage: CoverageInput;
  patientId: Scalars['PatientId'];
};


export type AuthorizedPatientMutationsAddCoverageFromNameArgs = {
  address?: InputMaybe<AddressInput>;
  patientId: Scalars['PatientId'];
  payerName: Scalars['String'];
  subscriberNumber: Scalars['String'];
};


export type AuthorizedPatientMutationsGenerateS3FilesArgs = {
  files: Array<FileCandidate>;
};


export type AuthorizedPatientMutationsIntakeQuestionaireArgs = {
  intake: PatientIntakeQuestionaire;
};


export type AuthorizedPatientMutationsRegisterCareTeamArgs = {
  careTeam: Array<ContactInput>;
};


export type AuthorizedPatientMutationsRequestRecordFromCareTeamMemberArgs = {
  careTeamMemberId: Scalars['String'];
};


export type AuthorizedPatientMutationsSetPreferredTimeZoneArgs = {
  preferredTimeZone: Scalars['String'];
};


export type AuthorizedPatientMutationsUpdateCoverageArgs = {
  address: AddressInput;
  coverage: CoverageInput;
  patientId: Scalars['ID'];
};


export type AuthorizedPatientMutationsUploadS3ContentArgs = {
  file: SignaturesAoBandTicFileRequest;
  patientId: Scalars['PatientId'];
};


export type AuthorizedPatientMutationsValidateAuthArgs = {
  surgeryId: Scalars['SurgeryId'];
};

export type BodilyMedicalDevies = {
  __typename?: 'BodilyMedicalDevies';
  deviceCheckedInLastYear: Scalars['Boolean'];
  deviceName: Scalars['String'];
  informationCard: Scalars['Boolean'];
  informationCardDetails?: Maybe<Scalars['String']>;
};

export type BodilyMedicalDeviesInput = {
  deviceCheckedInLastYear: Scalars['Boolean'];
  deviceName: Scalars['String'];
  informationCard: Scalars['Boolean'];
  informationCardDetails?: InputMaybe<Scalars['String']>;
};

export type BooleanAnswer = {
  __typename?: 'BooleanAnswer';
  answer: Scalars['Boolean'];
  description: Scalars['String'];
};

export type BooleanAnswerInput = {
  answer: Scalars['Boolean'];
  description: Scalars['String'];
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height: Scalars['Float'];
  left: Scalars['Float'];
  top: Scalars['Float'];
  width: Scalars['Float'];
};

export type BrowserNotification = {
  __typename?: 'BrowserNotification';
  body: Scalars['String'];
  date: Scalars['DateTimeString'];
  id: Scalars['ID'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type BulkUploadMutations = {
  __typename?: 'BulkUploadMutations';
  commitIngestionTransform: UploadIngestionFileResponse;
  requestIngestionUploadUrl: IngestionUploadUrl;
  transformIngestionUpload: TransformIngestionResult;
  /** Skips AI mapping: validates the uploaded file's header row exactly matches Orchestra's expected schedule format (CSV or Excel only) and, if valid, ingests it directly with no review step. */
  validateAndIngestUpload: UploadIngestionFileResponse;
};


export type BulkUploadMutationsCommitIngestionTransformArgs = {
  input: CommitIngestionTransformInput;
};


export type BulkUploadMutationsRequestIngestionUploadUrlArgs = {
  filename?: InputMaybe<Scalars['String']>;
};


export type BulkUploadMutationsTransformIngestionUploadArgs = {
  input: TransformIngestionUploadInput;
};


export type BulkUploadMutationsValidateAndIngestUploadArgs = {
  input: ValidateAndIngestUploadInput;
};

export type CanvasHpIngestResult = {
  __typename?: 'CanvasHpIngestResult';
  document?: Maybe<Document>;
  status: CanvasHpIngestStatus;
};

export enum CanvasHpIngestStatus {
  DocumentPending = 'DOCUMENT_PENDING',
  NoteNotFinalized = 'NOTE_NOT_FINALIZED',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type CareTeamMember = {
  __typename?: 'CareTeamMember';
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  patientId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  specialty: Scalars['String'];
};

export type CaseInstruction = {
  __typename?: 'CaseInstruction';
  description: Scalars['String'];
  id: Scalars['CaseInstructionId'];
  name: Scalars['String'];
  source: CaseInstructionSource;
  type: CaseInstructionType;
};

export enum CaseInstructionSource {
  Case = 'CASE',
  Medication = 'MEDICATION'
}

export enum CaseInstructionType {
  Adjust = 'ADJUST',
  Continue = 'CONTINUE',
  Hold = 'HOLD',
  Start = 'START'
}

export type ClearanceLevelInput = {
  clearanceRiskLevel: ClearanceRiskLevel;
  id: Scalars['ID'];
};

export enum ClearanceRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Unknown = 'UNKNOWN'
}

export enum ClearanceStatus {
  AnesthesiaReview = 'ANESTHESIA_REVIEW',
  Cleared = 'CLEARED',
  DocumentsReady = 'DOCUMENTS_READY',
  InvestigationDone = 'INVESTIGATION_DONE',
  MedicalRecordsNeeded = 'MEDICAL_RECORDS_NEEDED',
  NotApplicable = 'NOT_APPLICABLE',
  NotCleared = 'NOT_CLEARED',
  OnHold = 'ON_HOLD',
  PatientCancelled = 'PATIENT_CANCELLED',
  PatientRefused = 'PATIENT_REFUSED',
  PatientUnreachable = 'PATIENT_UNREACHABLE',
  Pending = 'PENDING',
  PendingChartReview = 'PENDING_CHART_REVIEW',
  PhysicianReview = 'PHYSICIAN_REVIEW',
  RetrievingDocuments = 'RETRIEVING_DOCUMENTS',
  StudiesNeeded = 'STUDIES_NEEDED',
  StudiesOrdered = 'STUDIES_ORDERED',
  UpdateStudies = 'UPDATE_STUDIES',
  VisitPrepped = 'VISIT_PREPPED'
}

export type CommitIngestionTransformInput = {
  resultBucket: Scalars['String'];
  resultKey: Scalars['String'];
};

export type Condition = {
  __typename?: 'Condition';
  deletedAt?: Maybe<Scalars['DateTimeString']>;
  displayName: Scalars['String'];
  foreignId: Scalars['String'];
  id: Scalars['ConditionId'];
  lastReconciled?: Maybe<Scalars['DateString']>;
  notes?: Maybe<Scalars['String']>;
  onsetDate?: Maybe<Scalars['DateString']>;
  patientId: Scalars['PatientId'];
  primaryCode: Scalars['String'];
  primarySystem: Scalars['String'];
  recordedDate?: Maybe<Scalars['DateString']>;
  secondaryCode?: Maybe<Scalars['String']>;
  secondarySystem?: Maybe<Scalars['String']>;
  status: ConditionStatus;
  surgicalRisk: ConditionSurgicalRisk;
  surgicalRiskReason?: Maybe<Scalars['String']>;
};

export type ConditionMutations = {
  __typename?: 'ConditionMutations';
  conditionTriageAnalysis?: Maybe<Array<Maybe<Condition>>>;
  deleteCondition?: Maybe<Condition>;
  updateCondition?: Maybe<Condition>;
};


export type ConditionMutationsConditionTriageAnalysisArgs = {
  patientId: Scalars['PatientId'];
};


export type ConditionMutationsDeleteConditionArgs = {
  conditionId: Scalars['ConditionId'];
};


export type ConditionMutationsUpdateConditionArgs = {
  condition: UpdateCondition;
};

export enum ConditionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Recurrence = 'RECURRENCE',
  Relapse = 'RELAPSE',
  Remission = 'REMISSION',
  Resolved = 'RESOLVED',
  Unconfirmed = 'UNCONFIRMED'
}

export enum ConditionSurgicalRisk {
  High = 'HIGH',
  None = 'NONE',
  Unknown = 'UNKNOWN'
}

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  relation: Scalars['String'];
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  relation: Scalars['String'];
};

export type ContactSearchInput = {
  keywords: Scalars['String'];
};

export type CoverageInput = {
  payerId: Scalars['PayerId'];
  subscriberNumber: Scalars['String'];
};

export type CreateMedication = {
  displayName: Scalars['String'];
  foreignId: Scalars['String'];
  lastReconciled?: InputMaybe<Scalars['DateTimeString']>;
  patientId: Scalars['PatientId'];
  primaryCode: Scalars['String'];
  primarySystem: Scalars['String'];
  status?: InputMaybe<MedicationStatus>;
};

export type CreateProcessStepState = {
  caseId: Scalars['SurgeryId'];
  notes?: InputMaybe<Scalars['String']>;
  processStepTemplateId: Scalars['String'];
  status?: InputMaybe<ProcessStepStatus>;
};

export type CreateProcessStepTemplate = {
  defaultOrder: Scalars['Int'];
  key: ProcessTemplateKey;
  label: Scalars['String'];
  workFlows: Array<SurgeryWorkflow>;
};

export type Credentials = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type DateInfo = {
  __typename?: 'DateInfo';
  boundingBox?: Maybe<BoundingBox>;
  name?: Maybe<Scalars['String']>;
  pageEnd?: Maybe<Scalars['Int']>;
  pageStart?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type DateRangePair = {
  max?: InputMaybe<Scalars['Date']>;
  min?: InputMaybe<Scalars['Date']>;
};

export type Diabetes = {
  __typename?: 'Diabetes';
  a1cLevel: Scalars['Float'];
  answer: Scalars['Boolean'];
  areYouTakingInsulin: Scalars['Boolean'];
  description: Scalars['String'];
};

export type DiabetesInput = {
  a1cLevel: Scalars['Float'];
  answer: Scalars['Boolean'];
  areYouTakingInsulin: Scalars['Boolean'];
  description: Scalars['String'];
};

export type Document = {
  __typename?: 'Document';
  analyses?: Maybe<Array<Maybe<DocumentAnalysis>>>;
  author?: Maybe<Scalars['String']>;
  authorId?: Maybe<Scalars['UserId']>;
  createdAt: Scalars['DateTimeString'];
  effectiveAt?: Maybe<Scalars['DateTimeString']>;
  foreignId?: Maybe<Scalars['String']>;
  id: Scalars['DocumentId'];
  name: Scalars['String'];
  ocrAnalysis?: Maybe<DocumentOcrAnalysis>;
  ocrStatus?: Maybe<DocumentOcrStatus>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['PatientId']>;
  status: DocumentStatus;
  surgeryId?: Maybe<Scalars['SurgeryId']>;
  type: FileType;
  updatedAt: Scalars['DateTimeString'];
  url: Scalars['String'];
};

export type DocumentAnalysis = {
  __typename?: 'DocumentAnalysis';
  documentId: Scalars['DocumentId'];
  id: Scalars['DocumentAnalysisId'];
  jobId?: Maybe<Scalars['String']>;
  status: JobStatus;
  type: AnalysisType;
};

export type DocumentMutations = {
  __typename?: 'DocumentMutations';
  generateUploadUrls?: Maybe<Array<GenerateUploadUrlsResponse>>;
  ingestCanvasDocumentReference?: Maybe<CanvasHpIngestResult>;
  startOCRAnalysis?: Maybe<Document>;
  updateDocumentName?: Maybe<Document>;
  updateDocumentStatus?: Maybe<Document>;
  updateDocumentSurgery?: Maybe<Document>;
};


export type DocumentMutationsGenerateUploadUrlsArgs = {
  fileNames: Array<Scalars['String']>;
};


export type DocumentMutationsIngestCanvasDocumentReferenceArgs = {
  documentReferenceId?: InputMaybe<Scalars['String']>;
  patientId: Scalars['PatientId'];
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};


export type DocumentMutationsStartOcrAnalysisArgs = {
  documentId: Scalars['DocumentId'];
};


export type DocumentMutationsUpdateDocumentNameArgs = {
  documentId: Scalars['ID'];
  documentName: Scalars['String'];
};


export type DocumentMutationsUpdateDocumentStatusArgs = {
  documentId: Scalars['DocumentId'];
  status: DocumentStatus;
};


export type DocumentMutationsUpdateDocumentSurgeryArgs = {
  documentId: Scalars['DocumentId'];
  surgeryId: Scalars['SurgeryId'];
};

export type DocumentOcrAnalysis = {
  __typename?: 'DocumentOCRAnalysis';
  patient?: Maybe<Patient>;
  patientDemographics?: Maybe<PatientDemographics>;
  studies?: Maybe<Array<Maybe<Study>>>;
  surgery?: Maybe<Surgery>;
};

export enum DocumentOcrStatus {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum DocumentStatus {
  Available = 'AVAILABLE',
  Error = 'ERROR',
  Pending = 'PENDING'
}

export type EditUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UserId'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  role: UserRole;
};

export enum EventContextType {
  Patient = 'PATIENT',
  Surgery = 'SURGERY',
  User = 'USER'
}

export type EventLog = {
  __typename?: 'EventLog';
  actor?: Maybe<User>;
  actorId: Scalars['UserId'];
  description: Scalars['String'];
  eventType: Scalars['String'];
  id: Scalars['EventLogId'];
  occurredAt: Scalars['DateTimeString'];
  status: EventLogStatus;
};

export type EventLogInput = {
  date?: InputMaybe<Scalars['DateTimeString']>;
  description: Scalars['String'];
  event: EventLogType;
  surgeryId: Scalars['SurgeryId'];
};

export enum EventLogStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum EventLogType {
  PhoneCallMade = 'PHONE_CALL_MADE'
}

export type Facility = {
  __typename?: 'Facility';
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['OrganizationId'];
  name: Scalars['String'];
  network: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  pointOfContact?: Maybe<Scalars['String']>;
};

export type Fax = {
  __typename?: 'Fax';
  callerId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeString'];
  direction: FaxDirection;
  documentId?: Maybe<Scalars['DocumentId']>;
  from: Scalars['PhoneNumber'];
  fromContact?: Maybe<Contact>;
  id: Scalars['FaxId'];
  name: Scalars['String'];
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['PatientId']>;
  requestFaxId?: Maybe<Scalars['FaxId']>;
  requestMetadata?: Maybe<Scalars['String']>;
  status: FaxStatus;
  subject?: Maybe<Scalars['String']>;
  surgery?: Maybe<Surgery>;
  surgeryId?: Maybe<Scalars['SurgeryId']>;
  to: Scalars['PhoneNumber'];
  toContact?: Maybe<Contact>;
  updatedAt: Scalars['DateTimeString'];
  url: Scalars['String'];
};

export type FaxContactInput = {
  fax: Scalars['PhoneNumber'];
  name: Scalars['String'];
};

export type FaxDateFilter = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export enum FaxDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type FaxOptions = {
  dateRange?: InputMaybe<FaxDateFilter>;
  directionFilter?: InputMaybe<Array<FaxDirection>>;
  pagination?: InputMaybe<PaginationOptions>;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};

export enum FaxResponsePatientMatch {
  Match = 'MATCH',
  Mismatch = 'MISMATCH',
  Unknown = 'UNKNOWN'
}

export type FaxResponseRequestedItemVerification = {
  __typename?: 'FaxResponseRequestedItemVerification';
  reason?: Maybe<FaxResponseVerificationReason>;
  requestCode: Scalars['String'];
  status: FaxResponseVerificationStatus;
};

export enum FaxResponseVerificationReason {
  NoRecords = 'NO_RECORDS',
  Other = 'OTHER',
  PatientNotFound = 'PATIENT_NOT_FOUND',
  ReleaseRequired = 'RELEASE_REQUIRED',
  StudyUnavailable = 'STUDY_UNAVAILABLE',
  VerbalConsentRequired = 'VERBAL_CONSENT_REQUIRED'
}

export type FaxResponseVerificationResult = {
  __typename?: 'FaxResponseVerificationResult';
  documentId: Scalars['DocumentId'];
  items: Array<FaxResponseRequestedItemVerification>;
  patientMatch: FaxResponsePatientMatch;
};

export enum FaxResponseVerificationStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Found = 'FOUND',
  NotFound = 'NOT_FOUND',
  Partial = 'PARTIAL',
  Unavailable = 'UNAVAILABLE',
  Uncertain = 'UNCERTAIN'
}

export enum FaxStatus {
  Delivered = 'DELIVERED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Received = 'RECEIVED',
  Receiving = 'RECEIVING',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type FileCandidate = {
  fileName: Scalars['String'];
  type: FileType;
};

export enum FileType {
  AiPreChart = 'AI_PRE_CHART',
  AiRiskAssessment = 'AI_RISK_ASSESSMENT',
  AobPlusTic = 'AOB_PLUS_TIC',
  DoctorNote = 'DOCTOR_NOTE',
  Hie = 'HIE',
  Lab = 'LAB',
  MedicationInfo = 'MEDICATION_INFO',
  Other = 'OTHER',
  PreopPacket = 'PREOP_PACKET',
  RiskAssessment = 'RISK_ASSESSMENT'
}

export type GenerateUploadUrlsResponse = {
  __typename?: 'GenerateUploadUrlsResponse';
  document: Document;
  uploadUrl: Scalars['SignedS3UploadUrl'];
};

export type GooglePlace = {
  __typename?: 'GooglePlace';
  address?: Maybe<Scalars['String']>;
  foreignId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
};

export type HeartProblems = {
  __typename?: 'HeartProblems';
  bloodTinners: Scalars['Boolean'];
  canYouClimbTwoFlights: Scalars['Boolean'];
  faintedInTheLastYear: Scalars['Boolean'];
  heartRhythmProblems: Scalars['Boolean'];
  heartStents: Scalars['Boolean'];
};

export type HeartProblemsInput = {
  bloodTinners: Scalars['Boolean'];
  canYouClimbTwoFlights: Scalars['Boolean'];
  faintedInTheLastYear: Scalars['Boolean'];
  heartRhythmProblems: Scalars['Boolean'];
  heartStents: Scalars['Boolean'];
};

export type HieJob = {
  __typename?: 'HieJob';
  createdAt?: Maybe<Scalars['DateTimeString']>;
  jobStatus?: Maybe<HieJobStatus>;
  serviceProviders?: Maybe<Array<Maybe<HieServiceProvider>>>;
  targetCompletionDate?: Maybe<Scalars['DateTimeString']>;
  updatedAt?: Maybe<Scalars['DateTimeString']>;
};

export enum HieJobStatus {
  Done = 'done',
  Error = 'error',
  InProgress = 'in_progress',
  Scheduled = 'scheduled'
}

export type HieServiceProvider = {
  __typename?: 'HieServiceProvider';
  service?: Maybe<Scalars['String']>;
  status?: Maybe<ServiceProviderJobStatus>;
};

export type IngestionJob = {
  __typename?: 'IngestionJob';
  createdAt: Scalars['DateTimeString'];
  errorCount: Scalars['Int'];
  id: Scalars['ID'];
  messages: Array<Scalars['String']>;
  processedRows: Scalars['Int'];
  status: IngestionJobStatus;
  totalRows: Scalars['Int'];
  updatedAt: Scalars['DateTimeString'];
};

export enum IngestionJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type IngestionUploadUrl = {
  __typename?: 'IngestionUploadUrl';
  sourceBucket: Scalars['String'];
  sourceKey: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type InitiateFaxRequest = {
  documentId?: InputMaybe<Scalars['DocumentId']>;
  recordsRequest?: InputMaybe<SurgeryRecordsRequestInput>;
  subject: Scalars['String'];
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
  to: Scalars['PhoneNumber'];
};

export enum InitiatePasswordResetMethod {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type InitiatePasswordResetResponse = {
  __typename?: 'InitiatePasswordResetResponse';
  identifier: Scalars['String'];
  method: InitiatePasswordResetMethod;
  success: Scalars['Boolean'];
};

export type InsertRoleAssignment = {
  isAvailable: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  role: RoleType;
  targetId: Scalars['String'];
  targetType: TargetType;
  userId: Scalars['UserId'];
};

export type InsertTask = {
  assigneeId?: InputMaybe<Scalars['UserId']>;
  authorId: Scalars['UserId'];
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['DateString'];
  organizationId: Scalars['OrganizationId'];
  status?: InputMaybe<TaskStatus>;
  surgeryId: Scalars['SurgeryId'];
  title?: InputMaybe<Scalars['String']>;
  viewedByAssignee?: InputMaybe<Scalars['Date']>;
};

export type IntakeProgressStatus = {
  __typename?: 'IntakeProgressStatus';
  coverageLatestDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  intakeQLatestDate?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['PatientId']>;
  phone?: Maybe<Scalars['String']>;
  preopVisitDate?: Maybe<Scalars['Date']>;
  signaturesDate?: Maybe<Scalars['Date']>;
  visitCopay?: Maybe<Scalars['Int']>;
  visitCopayStatus?: Maybe<Scalars['String']>;
};

export type IntakeQuestionaire = {
  __typename?: 'IntakeQuestionaire';
  KidneyDisease: SymptomsAnswer;
  anesthesia: Anesthesia;
  bloodDisase: BooleanAnswer;
  bodilyMedicalDevies: BodilyMedicalDevies;
  congestiveHeartFailure: SymptomsAnswer;
  diabetes: Diabetes;
  endocrineDisorder: TextAnswer;
  heartProblems: HeartProblems;
  id: Scalars['ID'];
  immuneDisorders: BooleanAnswer;
  liverDisease: SymptomsAnswer;
  neurologicalDisorder: NeurologicalDisorder;
  other: TextAnswer;
  pulmonaryProblems: SymptomsAnswer;
};

export type IntakeQuestionaireResponse = {
  KidneyDisease: SymptomsAnswerInput;
  anesthesia: AnesthesiaInput;
  bloodDisase: BooleanAnswerInput;
  bodilyMedicalDevies: BodilyMedicalDeviesInput;
  congestiveHeartFailure: SymptomsAnswerInput;
  diabetes: DiabetesInput;
  endocrineDisorder: TextAnswerInput;
  heartProblems: HeartProblemsInput;
  immuneDisorders: BooleanAnswerInput;
  liverDisease: SymptomsAnswerInput;
  neurologicalDisorder: NeurologicalDisorderInput;
  other: TextAnswerInput;
  pulmonaryProblems: SymptomsAnswerInput;
};

export enum InternalRequirement {
  Document = 'DOCUMENT'
}

export type InternalSurgeryMutations = {
  __typename?: 'InternalSurgeryMutations';
  replacePrimaryOrganization?: Maybe<Surgery>;
  sendIntakeQuestionnaire?: Maybe<Query>;
  sendMessage?: Maybe<Query>;
  sendUpdateCoverageInstructions?: Maybe<Query>;
  updateExternalNote?: Maybe<Surgery>;
  updateMessage?: Maybe<Query>;
  updateNotes?: Maybe<Surgery>;
};


export type InternalSurgeryMutationsReplacePrimaryOrganizationArgs = {
  organizationId: Scalars['ID'];
  surgeonId?: InputMaybe<Scalars['ID']>;
  surgeryId: Scalars['SurgeryId'];
};


export type InternalSurgeryMutationsSendIntakeQuestionnaireArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type InternalSurgeryMutationsSendMessageArgs = {
  message: Scalars['String'];
  patientId: Scalars['ID'];
  translation?: InputMaybe<Scalars['String']>;
};


export type InternalSurgeryMutationsSendUpdateCoverageInstructionsArgs = {
  patient: Scalars['ID'];
};


export type InternalSurgeryMutationsUpdateExternalNoteArgs = {
  notes: Scalars['String'];
  surgeryId: Scalars['SurgeryId'];
};


export type InternalSurgeryMutationsUpdateMessageArgs = {
  id: Scalars['MessageId'];
  translation: Scalars['String'];
};


export type InternalSurgeryMutationsUpdateNotesArgs = {
  notes: Scalars['String'];
  surgeryId: Scalars['SurgeryId'];
};

export enum JobStatus {
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type LabRequirement = {
  __typename?: 'LabRequirement';
  authorId?: Maybe<Scalars['UserId']>;
  code: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  effectiveDuration?: Maybe<Scalars['Int']>;
  frequency: TemporalFrequency;
  id: Scalars['LabRequirementId'];
  labRequirements?: Maybe<Array<LabRequirement>>;
  name: Scalars['String'];
  requirementId?: Maybe<Scalars['String']>;
  targetId: Scalars['ID'];
  targetType: TargetType;
  thresholdHigh?: Maybe<Scalars['Float']>;
  thresholdLow?: Maybe<Scalars['Float']>;
  thresholdOutOfRange?: Maybe<Scalars['Float']>;
  thresholdOutOfRangeHigh?: Maybe<Scalars['Float']>;
  thresholdOutOfRangeLow?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type LabRequirementMutations = {
  __typename?: 'LabRequirementMutations';
  upsertLabRequirement?: Maybe<LabRequirement>;
};


export type LabRequirementMutationsUpsertLabRequirementArgs = {
  requirement?: InputMaybe<UpsertRequirement>;
};

export type LabRequirementOptions = {
  flat?: InputMaybe<Scalars['Boolean']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  mergeOrchestraRequirements?: InputMaybe<Scalars['Boolean']>;
  trigger?: InputMaybe<Trigger>;
};

export type LineItem = {
  __typename?: 'LineItem';
  amount: Scalars['Int'];
  category: Scalars['String'];
  id: Scalars['ID'];
};

export type Location = {
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type LoginDetails = {
  dob: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type Medication = {
  __typename?: 'Medication';
  activeIngredient?: Maybe<Scalars['String']>;
  activeIngredientCode?: Maybe<Scalars['String']>;
  activeIngredientSystem?: Maybe<Scalars['String']>;
  confidenceScore?: Maybe<Scalars['Int']>;
  confidenceScoreRationale?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeString'];
  deletedAt?: Maybe<Scalars['DateTimeString']>;
  displayName: Scalars['String'];
  dosageEnd?: Maybe<Scalars['DateString']>;
  dosageInstructions?: Maybe<Scalars['String']>;
  dosageStart?: Maybe<Scalars['DateString']>;
  foreignId: Scalars['String'];
  id: Scalars['MedicationId'];
  lastFilledDate?: Maybe<Scalars['DateString']>;
  lastPrescribedDate?: Maybe<Scalars['DateString']>;
  lastReconciled?: Maybe<Scalars['DateString']>;
  patientId: Scalars['PatientId'];
  primaryCode: Scalars['String'];
  primarySystem: Scalars['String'];
  status: MedicationStatus;
  surgicalRisk: MedicationSurgicalRisk;
  surgicalRiskReason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeString'];
};

export type MedicationInstruction = {
  __typename?: 'MedicationInstruction';
  id: Scalars['MedicationInstructionId'];
  instruction: Scalars['String'];
  type: CaseInstructionType;
};

export type MedicationMutations = {
  __typename?: 'MedicationMutations';
  clearMedications?: Maybe<Array<Medication>>;
  createMedication?: Maybe<Medication>;
  deleteMedication?: Maybe<Medication>;
  medicationTriageAnalysis?: Maybe<Array<Maybe<Medication>>>;
  reconcileMedications?: Maybe<Array<Medication>>;
  updateMedication?: Maybe<Medication>;
};


export type MedicationMutationsClearMedicationsArgs = {
  medicationIds: Array<Scalars['MedicationId']>;
};


export type MedicationMutationsCreateMedicationArgs = {
  medication: CreateMedication;
};


export type MedicationMutationsDeleteMedicationArgs = {
  medicationId: Scalars['MedicationId'];
};


export type MedicationMutationsMedicationTriageAnalysisArgs = {
  patientId: Scalars['PatientId'];
};


export type MedicationMutationsReconcileMedicationsArgs = {
  medicationIds: Array<Scalars['MedicationId']>;
  patientId: Scalars['PatientId'];
};


export type MedicationMutationsUpdateMedicationArgs = {
  medication: UpdateMedication;
};

export enum MedicationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unconfirmed = 'UNCONFIRMED'
}

export enum MedicationSurgicalRisk {
  High = 'HIGH',
  None = 'NONE',
  Unknown = 'UNKNOWN'
}

export type Message = {
  __typename?: 'Message';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['ID']>;
  authorName?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  foreignStatus?: Maybe<Scalars['String']>;
  id: Scalars['MessageId'];
  origin: MessageOrigin;
  status: MessageStatus;
  timestamp: Scalars['DateTimeString'];
  translation?: Maybe<Scalars['String']>;
};

export type MessageFilter = {
  cursor?: InputMaybe<Scalars['Date']>;
};

export enum MessageOrigin {
  Automated = 'AUTOMATED',
  OpsUser = 'OPS_USER',
  Patient = 'PATIENT',
  PlatformUser = 'PLATFORM_USER',
  Unknown = 'UNKNOWN'
}

export enum MessageStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type Mutation = {
  __typename?: 'Mutation';
  authorizedPatient?: Maybe<AuthorizedPatientMutations>;
  condition?: Maybe<ConditionMutations>;
  document?: Maybe<DocumentMutations>;
  internalSurgery?: Maybe<InternalSurgeryMutations>;
  labRequirement?: Maybe<LabRequirementMutations>;
  medication?: Maybe<MedicationMutations>;
  observation?: Maybe<ObservationMutations>;
  orchestraOperations?: Maybe<OrchestraOperations>;
  patient?: Maybe<PatientMutations>;
  processStep?: Maybe<ProcessStepMutations>;
  provider?: Maybe<ProviderMutations>;
  providerOperations?: Maybe<ProviderOperationsMutations>;
  riskAssessment?: Maybe<RiskAssessmentMutations>;
  roleAssignment?: Maybe<RoleAssignmentMutations>;
  task?: Maybe<TaskMutations>;
};

export type NeurologicalDisorder = {
  __typename?: 'NeurologicalDisorder';
  answer: Scalars['Boolean'];
  description: Scalars['String'];
  lastStroke: Scalars['String'];
};

export type NeurologicalDisorderInput = {
  answer: Scalars['Boolean'];
  description: Scalars['String'];
  lastStroke: Scalars['String'];
};

export type Observation = {
  __typename?: 'Observation';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['UserId']>;
  code: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  effectiveDate?: Maybe<Scalars['DateTimeString']>;
  encounterDescription?: Maybe<Scalars['String']>;
  id: Scalars['ObservationId'];
  observations?: Maybe<Array<Observation>>;
  overruledBy?: Maybe<Scalars['UserId']>;
  overruledByUser?: Maybe<User>;
  overruledType?: Maybe<OverruledType>;
  pageEnd?: Maybe<Scalars['Int']>;
  pageStart?: Maybe<Scalars['Int']>;
  patientId: Scalars['PatientId'];
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<SourceType>;
  sourceUrl?: Maybe<Scalars['String']>;
  system: Scalars['String'];
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type ObservationFilter = {
  loincCodes?: InputMaybe<Array<Scalars['String']>>;
  panels?: InputMaybe<Array<ObservationPanel>>;
};

export type ObservationMutations = {
  __typename?: 'ObservationMutations';
  upsertObservations?: Maybe<Array<Maybe<Observation>>>;
};


export type ObservationMutationsUpsertObservationsArgs = {
  observations?: InputMaybe<Array<InputMaybe<UpsertObservation>>>;
};

export enum ObservationPanel {
  A1C = 'A1C',
  Bmp = 'BMP',
  Cbc = 'CBC'
}

export type ObservationValue = {
  __typename?: 'ObservationValue';
  boundingBox?: Maybe<BoundingBox>;
  code: Scalars['String'];
  datePerformed?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  pageEnd?: Maybe<Scalars['Int']>;
  pageStart?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

export type OpenLoopViabilityStatus = {
  __typename?: 'OpenLoopViabilityStatus';
  isViable: Scalars['Boolean'];
  reason: Scalars['String'];
};

export type OpenLoopVisitScheduleResult = {
  __typename?: 'OpenLoopVisitScheduleResult';
  conflict: Scalars['Boolean'];
  visit?: Maybe<Visit>;
};

export type OrchestraOperations = {
  __typename?: 'OrchestraOperations';
  addFacility?: Maybe<Organization>;
  addOrganization?: Maybe<Organization>;
  inviteUserForOrganization?: Maybe<User>;
  uploadIngestionFile?: Maybe<UploadIngestionFileResponse>;
};


export type OrchestraOperationsAddFacilityArgs = {
  addFacility: AddFacilityInput;
};


export type OrchestraOperationsAddOrganizationArgs = {
  addOrganization: AddOrganizationInput;
};


export type OrchestraOperationsInviteUserForOrganizationArgs = {
  inviteUser: AddUserForOrganizationInput;
};


export type OrchestraOperationsUploadIngestionFileArgs = {
  uploadIngestionFile: UploadIngestionFileInput;
};

export type Organization = {
  __typename?: 'Organization';
  faxNumber?: Maybe<Scalars['PhoneNumber']>;
  features?: Maybe<OrganizationFeatures>;
  id: Scalars['OrganizationId'];
  name: Scalars['String'];
  network: Scalars['String'];
  relatedUsers: Array<User>;
  schedulingLink?: Maybe<Scalars['String']>;
  specialty: OrganizationSpecialty;
  tier?: Maybe<OrganizationTier>;
  users: Array<User>;
};


export type OrganizationRelatedUsersArgs = {
  role?: InputMaybe<UserRole>;
};


export type OrganizationUsersArgs = {
  role?: InputMaybe<UserRole>;
};

export type OrganizationFeatures = {
  __typename?: 'OrganizationFeatures';
  scheduling?: Maybe<Scalars['Boolean']>;
};

export enum OrganizationSpecialty {
  Anesthesia = 'ANESTHESIA',
  Cardiology = 'CARDIOLOGY',
  OperatingFacility = 'OPERATING_FACILITY',
  Other = 'OTHER',
  Pcp = 'PCP',
  Surgical = 'SURGICAL'
}

export enum OrganizationTier {
  FullService = 'FULL_SERVICE',
  SoftwareOnly = 'SOFTWARE_ONLY'
}

export enum OverruledType {
  Cleared = 'CLEARED',
  Unlinked = 'UNLINKED'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  pageSize?: Maybe<Scalars['Int']>;
  startCursor?: Maybe<Scalars['String']>;
};

export type PageInfoInput = {
  cursor?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<PaginationDirection>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type PaginatedSurgeries = {
  __typename?: 'PaginatedSurgeries';
  pageInfo: PageInfo;
  surgeries: Array<Surgery>;
};

export type PaginatedTasks = {
  __typename?: 'PaginatedTasks';
  pageInfo: PageInfo;
  tasks: Array<Task>;
};

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD'
}

export type PaginationOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Patient = {
  __typename?: 'Patient';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['AddressId']>;
  birthSex: SexAtBirth;
  careTeam: Array<CareTeamMember>;
  conditions: Array<Maybe<Condition>>;
  coverage?: Maybe<PatientCoverage>;
  dob?: Maybe<Scalars['Date']>;
  documents: Array<Document>;
  email?: Maybe<Scalars['String']>;
  emrId: Scalars['String'];
  externalHieUrl?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  hiePullStatus?: Maybe<HieJob>;
  id: Scalars['PatientId'];
  intake?: Maybe<IntakeQuestionaire>;
  lastName: Scalars['String'];
  medications: Array<Maybe<Medication>>;
  messages: Array<Message>;
  observations: Array<Observation>;
  outstandingBalance?: Maybe<Array<PatientAccountBalance>>;
  phone?: Maybe<Scalars['String']>;
  phoneType?: Maybe<PhoneType>;
  riskAssessment?: Maybe<RiskAssessment>;
  upcomingSurgery?: Maybe<Surgery>;
  upcomingSurgeryStudyState?: Maybe<StudyState>;
  visits: Array<Visit>;
};


export type PatientMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type PatientObservationsArgs = {
  filter?: InputMaybe<ObservationFilter>;
};


export type PatientVisitsArgs = {
  type?: InputMaybe<VisitType>;
  visitId?: InputMaybe<Scalars['String']>;
};

export type PatientAccountBalance = {
  __typename?: 'PatientAccountBalance';
  amountDue: Scalars['Int'];
  id: Scalars['ID'];
  lineItems?: Maybe<Array<LineItem>>;
  patientId: Scalars['ID'];
};

export type PatientCoverage = {
  __typename?: 'PatientCoverage';
  copay: Scalars['Int'];
  id: Scalars['ID'];
  payerId?: Maybe<Scalars['String']>;
  payerName?: Maybe<Scalars['String']>;
  status: PatientCoverageStatus;
  subscriberNumber: Scalars['String'];
};

export enum PatientCoverageStatus {
  SelfPay = 'SELF_PAY',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type PatientDemographics = {
  __typename?: 'PatientDemographics';
  dateOfBirth?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export enum PatientHieRefreshResponse {
  DataMissing = 'DATA_MISSING',
  Error = 'ERROR',
  Scheduled = 'SCHEDULED'
}

export type PatientInput = {
  address: AddressInput;
  coverage: CoverageInput;
  dateOfService?: InputMaybe<Scalars['String']>;
  dob: Scalars['Date'];
  documents?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  patientId?: InputMaybe<Scalars['PatientId']>;
  payer: Scalars['String'];
  phone: Scalars['String'];
  sexAtBirth: SexAtBirth;
  subscriberId: Scalars['String'];
  surgeonName: Scalars['String'];
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
  surgeryType: Scalars['String'];
};

export type PatientIntakeQuestionaire = {
  id: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  response: IntakeQuestionaireResponse;
};

export type PatientMutations = {
  __typename?: 'PatientMutations';
  addAcknowledgements?: Maybe<Array<Acknowledgement>>;
  addCoverageFromName?: Maybe<PatientCoverage>;
  cancelOpenLoopVisit?: Maybe<Scalars['Boolean']>;
  create?: Maybe<Scalars['String']>;
  deleteDocument?: Maybe<Query>;
  refreshHie?: Maybe<PatientHieRefreshResponse>;
  registerPatient?: Maybe<Scalars['String']>;
  scheduleOpenLoopVisit?: Maybe<OpenLoopVisitScheduleResult>;
  scheduleVisit?: Maybe<Visit>;
  send2faMessage?: Maybe<Scalars['PatientId']>;
  sendESignLinkMessage?: Maybe<Scalars['String']>;
};


export type PatientMutationsAddAcknowledgementsArgs = {
  acknowledgements: Array<AcknowledgementInput>;
};


export type PatientMutationsAddCoverageFromNameArgs = {
  address?: InputMaybe<AddressInput>;
  patientId: Scalars['PatientId'];
  payerName: Scalars['String'];
  subscriberNumber: Scalars['String'];
};


export type PatientMutationsCancelOpenLoopVisitArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type PatientMutationsCreateArgs = {
  patient: PatientInput;
};


export type PatientMutationsDeleteDocumentArgs = {
  id: Scalars['ID'];
};


export type PatientMutationsRefreshHieArgs = {
  id: Scalars['PatientId'];
};


export type PatientMutationsRegisterPatientArgs = {
  request: RegisterRequest;
};


export type PatientMutationsScheduleOpenLoopVisitArgs = {
  preferredTimeZone?: InputMaybe<Scalars['String']>;
  surgeryId: Scalars['SurgeryId'];
};


export type PatientMutationsScheduleVisitArgs = {
  visitParams: VisitParams;
};


export type PatientMutationsSend2faMessageArgs = {
  dob: Scalars['Date'];
  patientId: Scalars['PatientId'];
  phone: Scalars['String'];
};


export type PatientMutationsSendESignLinkMessageArgs = {
  sendText?: InputMaybe<Scalars['Boolean']>;
  surgeryId: Scalars['SurgeryId'];
};

export type Payer = {
  __typename?: 'Payer';
  attachment?: Maybe<Scalars['String']>;
  auto?: Maybe<Scalars['String']>;
  claims_1500?: Maybe<Scalars['String']>;
  dent_claims?: Maybe<Scalars['String']>;
  eligibility?: Maybe<Scalars['String']>;
  era?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  payer_alt_names?: Maybe<Array<Maybe<AltPayerName>>>;
  payer_name?: Maybe<Scalars['String']>;
  payer_state?: Maybe<Scalars['String']>;
  payer_type?: Maybe<Scalars['String']>;
  payerid?: Maybe<Scalars['String']>;
  secondary_support?: Maybe<Scalars['String']>;
  ub_claims?: Maybe<Scalars['String']>;
  workers_comp?: Maybe<Scalars['String']>;
};

export enum PhoneType {
  Invalid = 'INVALID',
  Landline = 'LANDLINE',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Prepaid = 'PREPAID',
  Voip = 'VOIP'
}

export type Place = {
  __typename?: 'Place';
  getAddress?: Maybe<Array<GooglePlace>>;
};


export type PlaceGetAddressArgs = {
  query: Scalars['String'];
};

export type PointOfContact = {
  __typename?: 'PointOfContact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UserId']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  roleAssignmentId?: Maybe<Scalars['RoleAssignmentId']>;
  targetId?: Maybe<Scalars['String']>;
};

export type ProcessStepMutations = {
  __typename?: 'ProcessStepMutations';
  createProcessStepState?: Maybe<ProcessStepState>;
  updateProcessStepState?: Maybe<ProcessStepState>;
};


export type ProcessStepMutationsCreateProcessStepStateArgs = {
  createStepState: CreateProcessStepState;
};


export type ProcessStepMutationsUpdateProcessStepStateArgs = {
  updateStepState: UpdateProcessStepState;
};

export type ProcessStepState = {
  __typename?: 'ProcessStepState';
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
  isVirtual: Scalars['Boolean'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  lastTransitionAt?: Maybe<Scalars['DateString']>;
  lastTransitionBy?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status: ProcessStepStatus;
  transitionType?: Maybe<StateTransitionType>;
};

export enum ProcessStepStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Removed = 'REMOVED',
  Todo = 'TODO'
}

export enum ProcessTemplateKey {
  LabsOrdered = 'LABS_ORDERED',
  OrchestraNote = 'ORCHESTRA_NOTE',
  PacketUploaded = 'PACKET_UPLOADED',
  PatientAdded = 'PATIENT_ADDED',
  SchedulingOutreach = 'SCHEDULING_OUTREACH',
  StudyTrackerUpdated = 'STUDY_TRACKER_UPDATED',
  TriageReport = 'TRIAGE_REPORT',
  VisitComplete = 'VISIT_COMPLETE',
  VisitScheduled = 'VISIT_SCHEDULED'
}

export type ProcessTracker = {
  __typename?: 'ProcessTracker';
  completed: Scalars['Int'];
  inProgress: Scalars['Int'];
  steps?: Maybe<Array<ProcessStepState>>;
  todo: Scalars['Int'];
  total: Scalars['Int'];
};

export type PromptChatOptions = {
  specialtyContext?: InputMaybe<SpecialtyContext>;
};

export type PromptChatResponse = {
  __typename?: 'PromptChatResponse';
  completion?: Maybe<Scalars['String']>;
  documentContext: Array<Document>;
};

export type ProviderMutations = {
  __typename?: 'ProviderMutations';
  addCompletedVisit?: Maybe<Query>;
  changeUserStatus?: Maybe<User>;
  editUserInfo?: Maybe<User>;
  generateS3Files?: Maybe<Array<Document>>;
  initiatePasswordReset?: Maybe<InitiatePasswordResetResponse>;
  inviteUser?: Maybe<Query>;
  login?: Maybe<Scalars['String']>;
  markVisitCompleted?: Maybe<Query>;
  registerSurgery?: Maybe<Surgery>;
  resetLogin?: Maybe<Scalars['String']>;
  sendSurgeryMessage?: Maybe<Message>;
  updateLastMessageRead?: Maybe<Query>;
  updatePatient?: Maybe<Patient>;
  updateSurgery?: Maybe<Surgery>;
  updateSurgeryArchivedStatus?: Maybe<Surgery>;
  updateVisitStatus?: Maybe<Query>;
};


export type ProviderMutationsAddCompletedVisitArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type ProviderMutationsChangeUserStatusArgs = {
  id: Scalars['UserId'];
  status: UserStatus;
};


export type ProviderMutationsEditUserInfoArgs = {
  user: EditUserInput;
};


export type ProviderMutationsGenerateS3FilesArgs = {
  files: Array<FileCandidate>;
  patientId: Scalars['ID'];
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};


export type ProviderMutationsInitiatePasswordResetArgs = {
  email: Scalars['String'];
  method?: InputMaybe<InitiatePasswordResetMethod>;
};


export type ProviderMutationsInviteUserArgs = {
  user: UserInput;
};


export type ProviderMutationsLoginArgs = {
  credentials: Credentials;
};


export type ProviderMutationsMarkVisitCompletedArgs = {
  surgeryId: Scalars['SurgeryId'];
  visitId?: InputMaybe<Scalars['VisitId']>;
};


export type ProviderMutationsRegisterSurgeryArgs = {
  surgery: SurgeryInput;
};


export type ProviderMutationsResetLoginArgs = {
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetCode: Scalars['String'];
};


export type ProviderMutationsSendSurgeryMessageArgs = {
  content: Scalars['String'];
  surgeryId: Scalars['SurgeryId'];
};


export type ProviderMutationsUpdateLastMessageReadArgs = {
  platformThreadId: Scalars['PlatformThreadId'];
};


export type ProviderMutationsUpdatePatientArgs = {
  patient: UpdatePatientInput;
};


export type ProviderMutationsUpdateSurgeryArgs = {
  surgery: UpdateSurgeryInput;
};


export type ProviderMutationsUpdateSurgeryArchivedStatusArgs = {
  updateSurgery: UpdateSurgeryArchivedInput;
};


export type ProviderMutationsUpdateVisitStatusArgs = {
  id: Scalars['SurgeryId'];
  status: VisitStatus;
  visitId?: InputMaybe<Scalars['ID']>;
};

export type ProviderOperationsMutations = {
  __typename?: 'ProviderOperationsMutations';
  associateFaxWithSurgery?: Maybe<Fax>;
  bulkUpload?: Maybe<BulkUploadMutations>;
  generateUploadUploadUrls?: Maybe<Array<Scalars['SignedS3UploadUrl']>>;
  initiateFax?: Maybe<Query>;
  insertFaxContact?: Maybe<Contact>;
  logEvent?: Maybe<Query>;
  resendFax?: Maybe<Query>;
};


export type ProviderOperationsMutationsAssociateFaxWithSurgeryArgs = {
  input: AssociateFaxWithSurgeryInput;
};


export type ProviderOperationsMutationsGenerateUploadUploadUrlsArgs = {
  files: Array<Scalars['String']>;
};


export type ProviderOperationsMutationsInitiateFaxArgs = {
  input: InitiateFaxRequest;
};


export type ProviderOperationsMutationsInsertFaxContactArgs = {
  input: FaxContactInput;
};


export type ProviderOperationsMutationsLogEventArgs = {
  eventInput: EventLogInput;
};


export type ProviderOperationsMutationsResendFaxArgs = {
  faxId: Scalars['FaxId'];
  to?: InputMaybe<Scalars['PhoneNumber']>;
};

export type Query = {
  __typename?: 'Query';
  aiAssessment?: Maybe<AiAssessment>;
  condition?: Maybe<Condition>;
  confirmESign?: Maybe<Scalars['Boolean']>;
  contacts?: Maybe<Array<Contact>>;
  document?: Maybe<Document>;
  events?: Maybe<Array<EventLog>>;
  facilities?: Maybe<Array<Facility>>;
  fail?: Maybe<Scalars['String']>;
  fax?: Maybe<Fax>;
  faxes?: Maybe<Array<Fax>>;
  getClinicalReviewCodingCopy?: Maybe<Scalars['String']>;
  getOpenLoopPreChartV2ShadowNoteEditLink?: Maybe<Scalars['String']>;
  getOpenLoopPrivateNoteEditLink?: Maybe<Scalars['String']>;
  getOpenLoopViabilityStatus?: Maybe<OpenLoopViabilityStatus>;
  getOpsPatientIntakeUrl?: Maybe<Scalars['String']>;
  getPatientFromMedicalRecordNumber?: Maybe<Patient>;
  getPatientIdFromSurgeryId?: Maybe<Scalars['PatientId']>;
  getPatientIntakeUrl?: Maybe<Scalars['String']>;
  hiePullStatus?: Maybe<HieJob>;
  impersonator?: Maybe<User>;
  ingestionJob?: Maybe<IngestionJob>;
  intakeProcessStatus?: Maybe<IntakeProgressStatus>;
  labRequirements?: Maybe<Array<Maybe<LabRequirement>>>;
  labRequirementsByTargetId?: Maybe<Array<Maybe<LabRequirement>>>;
  medication?: Maybe<Medication>;
  medicationSearch: Array<Medication>;
  observations?: Maybe<Array<Maybe<Observation>>>;
  orchestraLabRequirements?: Maybe<Array<Maybe<LabRequirement>>>;
  organization?: Maybe<Organization>;
  organizations?: Maybe<Array<Organization>>;
  patient?: Maybe<Patient>;
  patientMedicationInstructions: Array<CaseInstruction>;
  patientMedications: Array<Medication>;
  patients?: Maybe<Array<Patient>>;
  ping?: Maybe<Scalars['String']>;
  preopClinicalPacket?: Maybe<Scalars['String']>;
  processTracker?: Maybe<ProcessTracker>;
  riskAssessment?: Maybe<RiskAssessment>;
  riskAssessments?: Maybe<Array<RiskAssessment>>;
  roleAssignments?: Maybe<Array<RoleAssignment>>;
  sessionInfo?: Maybe<SessionInfo>;
  static?: Maybe<Static>;
  studyTracking?: Maybe<StudyTrackingState>;
  surgeries?: Maybe<Array<Surgery>>;
  surgeriesPaginated?: Maybe<PaginatedSurgeries>;
  surgeriesSummary?: Maybe<SurgeriesSummary>;
  surgery?: Maybe<Surgery>;
  task?: Maybe<Task>;
  tasks?: Maybe<Array<Task>>;
  tasksPaginated?: Maybe<PaginatedTasks>;
  time: Scalars['Date'];
  token?: Maybe<Scalars['String']>;
  translation?: Maybe<Scalars['String']>;
  unboundFaxes?: Maybe<Array<Fax>>;
  user?: Maybe<User>;
  users: Array<User>;
  usersResponsibleForSurgery: Array<User>;
  visitSlots?: Maybe<Array<VisitSlot>>;
  visits: Array<Visit>;
};


export type QueryAiAssessmentArgs = {
  patientId: Scalars['PatientId'];
};


export type QueryConditionArgs = {
  conditionId: Scalars['ConditionId'];
};


export type QueryConfirmESignArgs = {
  patientId: Scalars['PatientId'];
};


export type QueryContactsArgs = {
  parameters?: InputMaybe<ContactSearchInput>;
};


export type QueryDocumentArgs = {
  id: Scalars['DocumentId'];
};


export type QueryEventsArgs = {
  eventContextId: Scalars['String'];
  type: EventContextType;
};


export type QueryFaxArgs = {
  id: Scalars['FaxId'];
};


export type QueryFaxesArgs = {
  options?: InputMaybe<FaxOptions>;
};


export type QueryGetClinicalReviewCodingCopyArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryGetOpenLoopPreChartV2ShadowNoteEditLinkArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryGetOpenLoopPrivateNoteEditLinkArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryGetOpenLoopViabilityStatusArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryGetOpsPatientIntakeUrlArgs = {
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};


export type QueryGetPatientFromMedicalRecordNumberArgs = {
  medicalRecordNumber: Scalars['String'];
};


export type QueryGetPatientIdFromSurgeryIdArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryGetPatientIntakeUrlArgs = {
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};


export type QueryHiePullStatusArgs = {
  patientId: Scalars['PatientId'];
};


export type QueryIngestionJobArgs = {
  jobId: Scalars['ID'];
};


export type QueryIntakeProcessStatusArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryLabRequirementsArgs = {
  options?: InputMaybe<LabRequirementOptions>;
  surgeryId: Scalars['SurgeryId'];
};


export type QueryLabRequirementsByTargetIdArgs = {
  options?: InputMaybe<LabRequirementOptions>;
  targetId: Scalars['ID'];
};


export type QueryMedicationArgs = {
  medicationId: Scalars['MedicationId'];
};


export type QueryMedicationSearchArgs = {
  search: Scalars['String'];
};


export type QueryObservationsArgs = {
  patientId: Scalars['PatientId'];
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOrganizationsArgs = {
  type?: InputMaybe<OrganizationSpecialty>;
};


export type QueryPatientArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPatientMedicationInstructionsArgs = {
  patientId: Scalars['PatientId'];
};


export type QueryPatientMedicationsArgs = {
  patientId: Scalars['PatientId'];
};


export type QueryPreopClinicalPacketArgs = {
  refresh: Scalars['Boolean'];
  surgeryId: Scalars['SurgeryId'];
};


export type QueryProcessTrackerArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryRiskAssessmentArgs = {
  patientId: Scalars['ID'];
};


export type QueryRoleAssignmentsArgs = {
  options: RoleAssignmentOptions;
};


export type QueryStudyTrackingArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QuerySurgeriesArgs = {
  filterCriteria?: InputMaybe<SurgeriesFilterCriteria>;
};


export type QuerySurgeriesPaginatedArgs = {
  filterCriteria?: InputMaybe<SurgeriesFilterCriteria>;
  pageInfo: PageInfoInput;
};


export type QuerySurgeriesSummaryArgs = {
  filterCriteria: SurgerySummaryCriteria;
};


export type QuerySurgeryArgs = {
  id: Scalars['SurgeryId'];
  options?: InputMaybe<SurgeryOptions>;
};


export type QueryTaskArgs = {
  id: Scalars['TaskId'];
};


export type QueryTasksArgs = {
  options: TaskOptions;
};


export type QueryTasksPaginatedArgs = {
  options: TaskOptions;
  pageInfo: PageInfoInput;
};


export type QueryTranslationArgs = {
  language: Scalars['String'];
  message: Scalars['String'];
  patientId: Scalars['PatientId'];
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['UserId']>;
};


export type QueryUsersArgs = {
  role?: InputMaybe<UserRole>;
};


export type QueryUsersResponsibleForSurgeryArgs = {
  surgeryId: Scalars['SurgeryId'];
};


export type QueryVisitSlotsArgs = {
  filter?: InputMaybe<VisitSlotFilterOptions>;
  type: VisitType;
};


export type QueryVisitsArgs = {
  filter?: InputMaybe<VisitFilterOptions>;
  type?: InputMaybe<VisitType>;
};

export enum RecommendedCareSetting {
  Inpatient = 'INPATIENT',
  Observation = 'OBSERVATION',
  Outpatient = 'OUTPATIENT'
}

export enum ReconciliationStatus {
  Confirmed = 'CONFIRMED',
  Error = 'ERROR',
  Unconfirmed = 'UNCONFIRMED'
}

export type RedFlag = {
  __typename?: 'RedFlag';
  category: Scalars['String'];
  documentId: Scalars['DocumentId'];
  documentUrl: Scalars['String'];
  evidenceDate?: Maybe<Scalars['DateString']>;
  evidenceType?: Maybe<Scalars['String']>;
  evidenceValue?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  id: Scalars['String'];
  noteDate?: Maybe<Scalars['DateString']>;
  observationCodes: Array<Scalars['String']>;
  text: Scalars['String'];
};

export type RegisterRequest = {
  dateOfService?: InputMaybe<Scalars['String']>;
  dob: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  patientId?: InputMaybe<Scalars['String']>;
  payerId: Scalars['String'];
  phone: Scalars['String'];
  sexAtBirth: SexAtBirth;
  subscriberNumber: Scalars['String'];
  subscriberRelationship: Scalars['String'];
  surgeonName: Scalars['String'];
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
  surgeryType: Scalars['String'];
};

export type RiskAssessment = {
  __typename?: 'RiskAssessment';
  cardiologyClearance?: Maybe<ClearanceStatus>;
  clearanceRiskLevel: ClearanceRiskLevel;
  id: Scalars['ID'];
  intakeRiskAssessment?: Maybe<ClearanceStatus>;
  labs?: Maybe<Scalars['String']>;
  medicalClearance?: Maybe<ClearanceStatus>;
  patient?: Maybe<Patient>;
  patientId?: Maybe<Scalars['PatientId']>;
  priorAuth?: Maybe<ClearanceStatus>;
  specialtyClearance?: Maybe<ClearanceStatus>;
  status: ClearanceStatus;
  surgery?: Maybe<Surgery>;
  surgeryId?: Maybe<Scalars['SurgeryId']>;
  surgicalRiskLevel: ClearanceRiskLevel;
};

/** Whether a risk assessment exists, is still being generated, or will never be generated for this surgery. */
export enum RiskAssessmentAvailability {
  Available = 'AVAILABLE',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type RiskAssessmentInput = {
  cardiologyClearance?: InputMaybe<ClearanceStatus>;
  clearanceRiskLevel?: InputMaybe<ClearanceRiskLevel>;
  id: Scalars['ID'];
  intakeRiskAssessment?: InputMaybe<ClearanceStatus>;
  labs?: InputMaybe<Scalars['String']>;
  medicalClearance?: InputMaybe<ClearanceStatus>;
  patientId?: InputMaybe<Scalars['PatientId']>;
  priorAuth?: InputMaybe<ClearanceStatus>;
  specialtyClearance?: InputMaybe<ClearanceStatus>;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};

export type RiskAssessmentMutations = {
  __typename?: 'RiskAssessmentMutations';
  aiPreChart?: Maybe<Scalars['String']>;
  aiRiskAssessment?: Maybe<Scalars['String']>;
  preChartDocuments: Array<Maybe<Document>>;
  promptChat?: Maybe<PromptChatResponse>;
  redFlagSearch: Scalars['Boolean'];
  triageDocuments: Array<Maybe<Document>>;
  updateRiskAssessment?: Maybe<RiskAssessment>;
  updateRiskAssessmentClearanceLevel?: Maybe<RiskAssessment>;
  updateSurgicalRiskLevel?: Maybe<RiskAssessment>;
};


export type RiskAssessmentMutationsAiPreChartArgs = {
  refresh?: InputMaybe<Scalars['Boolean']>;
  surgeryId: Scalars['SurgeryId'];
};


export type RiskAssessmentMutationsAiRiskAssessmentArgs = {
  refresh?: InputMaybe<Scalars['Boolean']>;
  surgeryId: Scalars['SurgeryId'];
};


export type RiskAssessmentMutationsPreChartDocumentsArgs = {
  documentIds: Array<Scalars['DocumentId']>;
};


export type RiskAssessmentMutationsPromptChatArgs = {
  options?: InputMaybe<PromptChatOptions>;
  prompt: Scalars['String'];
  surgeryId: Scalars['SurgeryId'];
};


export type RiskAssessmentMutationsRedFlagSearchArgs = {
  documentId: Scalars['DocumentId'];
};


export type RiskAssessmentMutationsTriageDocumentsArgs = {
  documentIds: Array<Scalars['DocumentId']>;
};


export type RiskAssessmentMutationsUpdateRiskAssessmentArgs = {
  riskAssessment: RiskAssessmentInput;
};


export type RiskAssessmentMutationsUpdateRiskAssessmentClearanceLevelArgs = {
  clearanceLevel: ClearanceLevelInput;
};


export type RiskAssessmentMutationsUpdateSurgicalRiskLevelArgs = {
  surgicalRiskLevel: SurgicalRiskLevelInput;
};

export type RoleAssignment = {
  __typename?: 'RoleAssignment';
  id: Scalars['RoleAssignmentId'];
  isAvailable: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  role: RoleType;
  targetId: Scalars['String'];
  targetType: TargetType;
  userId: Scalars['UserId'];
};

export type RoleAssignmentMutations = {
  __typename?: 'RoleAssignmentMutations';
  insertRole?: Maybe<RoleAssignment>;
  sendPreopPacket?: Maybe<Scalars['Boolean']>;
  updateRole?: Maybe<RoleAssignment>;
};


export type RoleAssignmentMutationsInsertRoleArgs = {
  roleAssignment: InsertRoleAssignment;
};


export type RoleAssignmentMutationsSendPreopPacketArgs = {
  roleIds: Array<Scalars['RoleAssignmentId']>;
  surgeryId: Scalars['SurgeryId'];
};


export type RoleAssignmentMutationsUpdateRoleArgs = {
  roleAssignment: UpdateRoleAssignment;
};

export type RoleAssignmentOptions = {
  role: RoleType;
  targetId: Scalars['String'];
  targetType: TargetType;
};

export enum RoleType {
  DocumentTriage = 'DOCUMENT_TRIAGE',
  GeneralAutomation = 'GENERAL_AUTOMATION',
  LabTriage = 'LAB_TRIAGE',
  PointOfContact = 'POINT_OF_CONTACT',
  SurgeryManager = 'SURGERY_MANAGER'
}

export enum ServiceProviderJobStatus {
  Done = 'done',
  Error = 'error',
  InProgress = 'in_progress',
  Initialize = 'initialize',
  Unset = 'unset'
}

export type SessionInfo = {
  __typename?: 'SessionInfo';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  impersonator?: Maybe<SessionInfo>;
  lastName: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['OrganizationId']>;
  phone?: Maybe<Scalars['String']>;
  role: UserRole;
  type: Scalars['String'];
};

export enum SexAtBirth {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

export type SignaturesAoBandTicFileRequest = {
  fileName: Scalars['String'];
  firstName: Scalars['String'];
  guardianSignature?: InputMaybe<Scalars['String']>;
  isMinor: Scalars['Boolean'];
  lastName: Scalars['String'];
  patientSignature?: InputMaybe<Scalars['String']>;
  relationshipToPatient?: InputMaybe<Scalars['String']>;
  type: FileType;
};

export enum SourceType {
  Document = 'DOCUMENT',
  Fax = 'FAX',
  User = 'USER',
  Zus = 'ZUS'
}

export enum SpecialtyContext {
  PrimaryCare = 'PRIMARY_CARE',
  Rheumatology = 'RHEUMATOLOGY',
  Surgical = 'SURGICAL'
}

export enum StateTransitionType {
  Manual = 'MANUAL',
  System = 'SYSTEM'
}

export type Static = {
  __typename?: 'Static';
  payers?: Maybe<Array<Payer>>;
};

export type Study = {
  __typename?: 'Study';
  boundingBox?: Maybe<BoundingBox>;
  code: Scalars['String'];
  dateInfo?: Maybe<DateInfo>;
  datePerformed?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  observations?: Maybe<Array<Maybe<ObservationValue>>>;
  pageEnd?: Maybe<Scalars['Int']>;
  pageStart?: Maybe<Scalars['Int']>;
  reconciliationStatus?: Maybe<ReconciliationStatus>;
  requirement?: Maybe<LabRequirement>;
  value?: Maybe<Scalars['Float']>;
};

export enum StudyState {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type StudyTrackingState = {
  __typename?: 'StudyTrackingState';
  faxResponseVerifications: Array<FaxResponseVerificationResult>;
  labRequirements?: Maybe<Array<LabRequirement>>;
  observations?: Maybe<Array<Observation>>;
  studyState: StudyState;
};

export type Subscription = {
  __typename?: 'Subscription';
  browserNotification?: Maybe<BrowserNotification>;
  patientSMSMessage?: Maybe<Message>;
  ping?: Maybe<Scalars['String']>;
  platformMessage?: Maybe<Message>;
  surgery?: Maybe<Surgery>;
  task?: Maybe<Task>;
};


export type SubscriptionBrowserNotificationArgs = {
  organizationId?: InputMaybe<Scalars['OrganizationId']>;
  userId?: InputMaybe<Scalars['UserId']>;
};


export type SubscriptionPatientSmsMessageArgs = {
  id?: InputMaybe<Scalars['PatientId']>;
};


export type SubscriptionPlatformMessageArgs = {
  threadId?: InputMaybe<Scalars['PlatformThreadId']>;
};


export type SubscriptionSurgeryArgs = {
  stakeholderId?: InputMaybe<Scalars['OrganizationId']>;
};


export type SubscriptionTaskArgs = {
  assigneeId?: InputMaybe<Scalars['UserId']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']>;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};

export type SurgeriesFilterCriteria = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  clearanceDocumentsNotSent?: InputMaybe<Scalars['Boolean']>;
  clearanceDocumentsSent?: InputMaybe<Scalars['Boolean']>;
  dateOfService?: InputMaybe<DateRangePair>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['OrganizationId']>>>;
  highRiskOnly?: InputMaybe<Scalars['Boolean']>;
  namesMatcher?: InputMaybe<Scalars['String']>;
  negateRiskAssessments?: InputMaybe<Scalars['Boolean']>;
  noDos?: InputMaybe<Scalars['Boolean']>;
  noVisit?: InputMaybe<Scalars['Boolean']>;
  patientCreatedAt?: InputMaybe<DateRangePair>;
  patientDob?: InputMaybe<DateRangePair>;
  patientLastName?: InputMaybe<Scalars['String']>;
  patientPhoneContains?: InputMaybe<Scalars['String']>;
  riskAssessmentIntakeStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<SurgerySortCriteria>;
  surgeonIds?: InputMaybe<Array<InputMaybe<Scalars['UserId']>>>;
  surgeonLastName?: InputMaybe<Scalars['String']>;
  visitDate?: InputMaybe<DateRangePair>;
  visitProviderIds?: InputMaybe<Array<InputMaybe<Scalars['UserId']>>>;
};

export type SurgeriesSummary = {
  __typename?: 'SurgeriesSummary';
  clearedCount: Scalars['Int'];
  inProgressCount: Scalars['Int'];
  noDosCount: Scalars['Int'];
  noVisitCount: Scalars['Int'];
  notClearedCount: Scalars['Int'];
};

export type Surgery = {
  __typename?: 'Surgery';
  archived: Scalars['Boolean'];
  assessment?: Maybe<RiskAssessment>;
  careTeam: Array<CareTeamMember>;
  clearanceDocumentsSent: Scalars['Boolean'];
  clearanceDocumentsSentAt?: Maybe<Scalars['Date']>;
  dateOfService?: Maybe<Scalars['Date']>;
  documents?: Maybe<Array<Document>>;
  externalNotes?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['String']>;
  id: Scalars['SurgeryId'];
  instructions: Array<CaseInstruction>;
  instructionsSent: Scalars['Boolean'];
  messages: Array<Message>;
  notes?: Maybe<Scalars['String']>;
  patient: Patient;
  patientId: Scalars['PatientId'];
  platformMessages: Array<Message>;
  pointsOfContact: Array<PointOfContact>;
  recommendedCareSetting?: Maybe<RecommendedCareSetting>;
  referredOn: Scalars['Date'];
  referrer: Scalars['String'];
  riskAssessmentAvailability: RiskAssessmentAvailability;
  schedulingLink?: Maybe<Scalars['String']>;
  stakeholders?: Maybe<Array<Organization>>;
  studyTracking?: Maybe<StudyTrackingState>;
  surgeon?: Maybe<User>;
  surgeonId?: Maybe<Scalars['String']>;
  surgeonName: Scalars['String'];
  surgeryType: Scalars['String'];
  threadId?: Maybe<Scalars['PlatformThreadId']>;
  unreadPlatformMessages: Scalars['Int'];
  url: Scalars['String'];
  visits: Array<Visit>;
  workflow?: Maybe<SurgeryWorkflow>;
};


export type SurgeryInstructionsArgs = {
  source?: InputMaybe<CaseInstructionSource>;
};


export type SurgeryMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type SurgeryPlatformMessagesArgs = {
  filter?: InputMaybe<MessageFilter>;
};


export type SurgerySchedulingLinkArgs = {
  visitType: VisitType;
};


export type SurgeryStakeholdersArgs = {
  specialty?: InputMaybe<OrganizationSpecialty>;
};


export type SurgeryVisitsArgs = {
  type?: InputMaybe<Array<VisitType>>;
};

export type SurgeryInput = {
  address: AddressInput;
  dateOfService: Scalars['String'];
  dob: Scalars['Date'];
  email?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['OrganizationId']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  medicalRecordNumber?: InputMaybe<Scalars['String']>;
  notesToOrchestra?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  outpatientRiskAssessment?: InputMaybe<Scalars['Boolean']>;
  payerId?: InputMaybe<Scalars['PayerId']>;
  phone?: InputMaybe<Scalars['String']>;
  sexAtBirth: SexAtBirth;
  subscriberNumber?: InputMaybe<Scalars['String']>;
  subscriberRelationship?: InputMaybe<Scalars['String']>;
  surgeon: Scalars['String'];
  surgeryType?: InputMaybe<Scalars['String']>;
};

export type SurgeryOptions = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

export type SurgeryRecordsRequestInput = {
  requestName: Scalars['String'];
  requestedRecords: Array<Scalars['String']>;
};

export type SurgerySortCriteria = {
  field: Scalars['String'];
  order: Scalars['String'];
};

export type SurgerySummaryCriteria = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['ID']>;
};

export enum SurgeryWorkflow {
  FullService = 'FULL_SERVICE',
  SelfService = 'SELF_SERVICE',
  TriageOnly = 'TRIAGE_ONLY'
}

export type SurgicalRiskLevelInput = {
  id: Scalars['ID'];
  surgicalRiskLevel: ClearanceRiskLevel;
};

export type SymptomsAnswer = {
  __typename?: 'SymptomsAnswer';
  answer: Scalars['Boolean'];
  symptoms: Array<Scalars['String']>;
};

export type SymptomsAnswerInput = {
  answer: Scalars['Boolean'];
  symptoms: Array<Scalars['String']>;
};

export enum TargetType {
  Organization = 'ORGANIZATION',
  Surgery = 'SURGERY',
  User = 'USER'
}

export type Task = {
  __typename?: 'Task';
  assigneeId?: Maybe<Scalars['UserId']>;
  authorId: Scalars['UserId'];
  completedAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  dueDate: Scalars['Date'];
  id: Scalars['TaskId'];
  organizationId: Scalars['OrganizationId'];
  status: TaskStatus;
  surgeryId: Scalars['SurgeryId'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeString'];
  viewedByAssignee?: Maybe<Scalars['Date']>;
};

export type TaskMutations = {
  __typename?: 'TaskMutations';
  insertTask?: Maybe<Task>;
  markTaskViewed?: Maybe<Task>;
  updateTask?: Maybe<Task>;
};


export type TaskMutationsInsertTaskArgs = {
  task: InsertTask;
};


export type TaskMutationsMarkTaskViewedArgs = {
  id: Scalars['TaskId'];
};


export type TaskMutationsUpdateTaskArgs = {
  task: UpdateTask;
};

export type TaskOptions = {
  assigneeId?: InputMaybe<Scalars['UserId']>;
  dueDateBefore?: InputMaybe<Scalars['Date']>;
  dueDateOnOrAfter?: InputMaybe<Scalars['Date']>;
  excludeCompleted?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']>;
  statusFilter?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
};

export enum TaskStatus {
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export enum TemporalFrequency {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type TextAnswer = {
  __typename?: 'TextAnswer';
  answer: Scalars['String'];
};

export type TextAnswerInput = {
  answer: Scalars['String'];
};

export type TransformIngestionResult = {
  __typename?: 'TransformIngestionResult';
  resultBucket: Scalars['String'];
  resultKey: Scalars['String'];
  /** A preview sample only (at most 5 rows, header included), for fast review — commitIngestionTransform re-transforms the full source document rather than reusing this sample. */
  rows: Array<Scalars['String']>;
  /** Total number of data rows found in the source document, not counting the header row — independent of how many rows are actually included in `rows`. */
  totalDataRowCount: Scalars['Int'];
};

export type TransformIngestionUploadInput = {
  /** Set on a retry — the previous attempt's rejection feedback is folded into the prompt. */
  feedback?: InputMaybe<Scalars['String']>;
  sourceBucket: Scalars['String'];
  sourceKey: Scalars['String'];
};

export type Trigger = {
  surgeryId: Scalars['SurgeryId'];
  triggers: Array<TriggerType>;
};

export enum TriggerType {
  Age = 'AGE',
  Diabetes = 'DIABETES',
  HighRiskPatient = 'HIGH_RISK_PATIENT',
  HighRiskSurgery = 'HIGH_RISK_SURGERY',
  LowHgb = 'LOW_HGB',
  LowRiskPatient = 'LOW_RISK_PATIENT',
  LowRiskSurgery = 'LOW_RISK_SURGERY',
  MediumRiskPatient = 'MEDIUM_RISK_PATIENT',
  MediumRiskSurgery = 'MEDIUM_RISK_SURGERY'
}

export type UpdateCondition = {
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ConditionId'];
  lastReconciled?: InputMaybe<Scalars['DateTimeString']>;
  notes?: InputMaybe<Scalars['String']>;
  onsetDate?: InputMaybe<Scalars['DateTimeString']>;
  primaryCode?: InputMaybe<Scalars['String']>;
  primarySystem?: InputMaybe<Scalars['String']>;
  recordedDate?: InputMaybe<Scalars['DateTimeString']>;
  secondaryCode?: InputMaybe<Scalars['String']>;
  secondarySystem?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ConditionStatus>;
  surgicalRisk?: InputMaybe<ConditionSurgicalRisk>;
  surgicalRiskReason?: InputMaybe<Scalars['String']>;
};

export type UpdateMedication = {
  activeIngredient?: InputMaybe<Scalars['String']>;
  activeIngredientCode?: InputMaybe<Scalars['String']>;
  activeIngredientSystem?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  dosageEnd?: InputMaybe<Scalars['DateString']>;
  dosageInstructions?: InputMaybe<Scalars['String']>;
  dosageStart?: InputMaybe<Scalars['DateString']>;
  id: Scalars['MedicationId'];
  lastFilledDate?: InputMaybe<Scalars['DateTimeString']>;
  lastPrescribedDate?: InputMaybe<Scalars['DateTimeString']>;
  lastReconciled?: InputMaybe<Scalars['DateTimeString']>;
  primaryCode?: InputMaybe<Scalars['String']>;
  primarySystem?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MedicationStatus>;
  surgicalRisk?: InputMaybe<MedicationSurgicalRisk>;
  surgicalRiskReason?: InputMaybe<Scalars['String']>;
};

export type UpdatePatientInput = {
  address?: InputMaybe<AddressInput>;
  birthSex?: InputMaybe<SexAtBirth>;
  dob?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['PatientId'];
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateProcessStepState = {
  id: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProcessStepStatus>;
};

export type UpdateRoleAssignment = {
  deletedAt?: InputMaybe<Scalars['DateTimeString']>;
  id: Scalars['RoleAssignmentId'];
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateSurgeryArchivedInput = {
  id: Scalars['SurgeryId'];
  isArchived: Scalars['Boolean'];
};

export type UpdateSurgeryInput = {
  clearanceDocumentsSent?: InputMaybe<Scalars['Boolean']>;
  dateOfService?: InputMaybe<Scalars['Date']>;
  facilityId?: InputMaybe<Scalars['OrganizationId']>;
  id: Scalars['ID'];
  serviceLevelChangeReason?: InputMaybe<Scalars['String']>;
  surgeonId?: InputMaybe<Scalars['ID']>;
  surgeryType?: InputMaybe<Scalars['String']>;
  workflow?: InputMaybe<SurgeryWorkflow>;
};

export type UpdateTask = {
  assigneeId?: InputMaybe<Scalars['UserId']>;
  completedAt?: InputMaybe<Scalars['DateString']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['DateString']>;
  expectedUpdatedAt?: InputMaybe<Scalars['DateTimeString']>;
  id: Scalars['TaskId'];
  status?: InputMaybe<TaskStatus>;
  title?: InputMaybe<Scalars['String']>;
  viewedByAssignee?: InputMaybe<Scalars['Date']>;
};

export type UploadIngestionFileInput = {
  content: Scalars['String'];
};

export type UploadIngestionFileResponse = {
  __typename?: 'UploadIngestionFileResponse';
  jobId?: Maybe<Scalars['ID']>;
  messages: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpsertObservation = {
  code: Scalars['String'];
  createdBy?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  effectiveAt?: InputMaybe<Scalars['DateTimeString']>;
  encounterDescription?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  observations?: InputMaybe<Array<InputMaybe<UpsertObservation>>>;
  overruledBy?: InputMaybe<Scalars['String']>;
  overruledType?: InputMaybe<OverruledType>;
  pageEnd?: InputMaybe<Scalars['Int']>;
  pageStart?: InputMaybe<Scalars['Int']>;
  patientId: Scalars['PatientId'];
  sourceId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<SourceType>;
  system: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type UpsertRequirement = {
  authorId?: InputMaybe<Scalars['UserId']>;
  code: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['Date']>;
  effectiveDuration?: InputMaybe<Scalars['Float']>;
  frequency: Scalars['String'];
  id?: InputMaybe<Scalars['LabRequirementId']>;
  labRequirements?: InputMaybe<Array<InputMaybe<UpsertRequirement>>>;
  name: Scalars['String'];
  requirementId?: InputMaybe<Scalars['String']>;
  targetId: Scalars['ID'];
  targetType: TargetType;
  thresholdHigh?: InputMaybe<Scalars['Float']>;
  thresholdLow?: InputMaybe<Scalars['Float']>;
  thresholdOutOfRangeHigh?: InputMaybe<Scalars['Float']>;
  thresholdOutOfRangeLow?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['UserId'];
  lastName: Scalars['String'];
  organizationId: Scalars['OrganizationId'];
  organizationName: Scalars['String'];
  phone: Scalars['String'];
  role: UserRole;
  status: UserStatus;
  type: UserType;
};

export type UserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  role: UserRole;
};

export enum UserRole {
  Admin = 'ADMIN',
  Bot = 'BOT',
  Provider = 'PROVIDER',
  Superuser = 'SUPERUSER',
  Surgeon = 'SURGEON'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED'
}

export enum UserType {
  Consult = 'CONSULT',
  Ops = 'OPS',
  Patient = 'PATIENT',
  Provider = 'PROVIDER'
}

export type ValidateAndIngestUploadInput = {
  sourceBucket: Scalars['String'];
  sourceKey: Scalars['String'];
};

export type Visit = {
  __typename?: 'Visit';
  cancelUrl?: Maybe<Scalars['String']>;
  copay: Scalars['Int'];
  copayStatus: Scalars['ID'];
  date: Scalars['Date'];
  foreignId?: Maybe<Scalars['ID']>;
  id: Scalars['VisitId'];
  patient?: Maybe<Patient>;
  patientId: Scalars['PatientId'];
  provider?: Maybe<User>;
  providerId?: Maybe<Scalars['UserId']>;
  rescheduleUrl?: Maybe<Scalars['String']>;
  status: VisitStatus;
  surgery?: Maybe<Surgery>;
  surgeryId?: Maybe<Scalars['SurgeryId']>;
  type: VisitType;
};

export type VisitCompletedParams = {
  foreignId: Scalars['String'];
};

export type VisitFilterOptions = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  startOfDay?: InputMaybe<Scalars['Boolean']>;
};

export type VisitParams = {
  foreignId: Scalars['String'];
  surgeryId: Scalars['String'];
  type: VisitType;
};

export type VisitSlot = {
  __typename?: 'VisitSlot';
  date: Scalars['Date'];
  id: Scalars['ID'];
  scheduleUrl: Scalars['String'];
  type: VisitType;
};

export type VisitSlotFilterOptions = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export enum VisitStatus {
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Paid = 'PAID',
  Scheduled = 'SCHEDULED'
}

export enum VisitType {
  FollowUp = 'FOLLOW_UP',
  PatVisit = 'PAT_VISIT',
  RiskAssessment = 'RISK_ASSESSMENT'
}

export const BasicSurgeryInfoFragmentDoc = gql`
    fragment BasicSurgeryInfo on Surgery {
  id
  surgeonName
  surgeryType
  dateOfService
}
    `;
export const ModifyRiskAssessmentDataFragmentDoc = gql`
    fragment ModifyRiskAssessmentData on RiskAssessment {
  id
  patientId
  surgeryId
  patient {
    id
    firstName
    lastName
  }
  intakeRiskAssessment
  medicalClearance
  cardiologyClearance
  specialtyClearance
  labs
  priorAuth
  surgery {
    id
    surgeonId
    stakeholders(specialty: SURGICAL) {
      id
      name
    }
    careTeam {
      id
      patientId
      name
      specialty
      phone
      email
      fax
    }
  }
}
    `;
export const StageHandPatientsFragmentDoc = gql`
    fragment StageHandPatients on Patient {
  id
  firstName
  lastName
  externalHieUrl
}
    `;
export const StageHandSurgeryFragmentDoc = gql`
    fragment StageHandSurgery on Surgery {
  id
  patient {
    ...StageHandPatients
  }
}
    ${StageHandPatientsFragmentDoc}`;
export const CareTeamMemberFragmentDoc = gql`
    fragment CareTeamMember on CareTeamMember {
  id
  patientId
  name
  specialty
  phone
  email
  fax
}
    `;
export const GetPatientPlanResponseFragmentDoc = gql`
    fragment GetPatientPlanResponse on Patient {
  id
  firstName
  lastName
  intake {
    id
  }
  outstandingBalance {
    id
    amountDue
  }
  upcomingSurgery {
    id
    dateOfService
    surgeonName
    surgeryType
  }
  careTeam {
    ...CareTeamMember
  }
  visits(type: RISK_ASSESSMENT) {
    id
    type
  }
}
    ${CareTeamMemberFragmentDoc}`;
export const InitiatePasswordResetResponseFragmentDoc = gql`
    fragment InitiatePasswordResetResponse on InitiatePasswordResetResponse {
  success
  method
  identifier
}
    `;
export const ProviderVisitFragmentDoc = gql`
    fragment ProviderVisit on Visit {
  id
  patientId
  surgeryId
  type
  status
  date
  providerId
  foreignId
  rescheduleUrl
  cancelUrl
  surgery {
    id
    url
    dateOfService
    surgeryType
    surgeonName
    surgeon {
      id
      firstName
      lastName
    }
  }
  patient {
    id
    firstName
    lastName
    dob
    email
    phone
  }
  type
}
    `;
export const SurgeryFragmentDoc = gql`
    fragment Surgery on Surgery {
  id
  referredOn
  surgeonName
  surgeryType
  dateOfService
  patientId
}
    `;
export const BasicPatientInfoFragmentDoc = gql`
    fragment BasicPatientInfo on Patient {
  id
  firstName
  lastName
  dob
  phone
  email
  birthSex
}
    `;
export const FullUserFragmentDoc = gql`
    fragment FullUser on User {
  id
  type
  role
  firstName
  lastName
  email
  phone
  status
  organizationId
  organizationName
}
    `;
export const SurgeryListResponseFragmentDoc = gql`
    fragment SurgeryListResponse on Surgery {
  ...Surgery
  archived
  patient {
    ...BasicPatientInfo
  }
  surgeon {
    ...FullUser
  }
  assessment {
    id
    status
    surgicalRiskLevel
    clearanceRiskLevel
    intakeRiskAssessment
    medicalClearance
    cardiologyClearance
    specialtyClearance
  }
  riskAssessmentAvailability
  facilityId
  visits(type: RISK_ASSESSMENT) {
    id
    type
    date
    status
    foreignId
    provider {
      id
      fullName
    }
  }
  allVisits: visits {
    id
    date
    type
    provider {
      id
      fullName
    }
  }
  clearanceDocumentsSent
  clearanceDocumentsSentAt
  workflow
  archived
  unreadPlatformMessages
}
    ${SurgeryFragmentDoc}
${BasicPatientInfoFragmentDoc}
${FullUserFragmentDoc}`;
export const SurgeryEventLogFragmentDoc = gql`
    fragment SurgeryEventLog on EventLog {
  id
  occurredAt
  eventType
  description
  actor {
    id
    fullName
  }
}
    `;
export const DocumentOcDetectedPatientFragmentDoc = gql`
    fragment DocumentOCDetectedPatient on Patient {
  id
  firstName
  lastName
  dob
}
    `;
export const SurgerySearchFragmentDoc = gql`
    fragment SurgerySearch on Surgery {
  id
  surgeryType
  dateOfService
  patient {
    id
    firstName
    lastName
    dob
  }
  assessment {
    intakeRiskAssessment
  }
}
    `;
export const ObservationWithBoundingBoxFragmentDoc = gql`
    fragment observationWithBoundingBox on ObservationValue {
  name
  code
  value
  pageStart
  pageEnd
  datePerformed
  boundingBox {
    left
    width
    top
    height
  }
}
    `;
export const LabRequirementFragmentDoc = gql`
    fragment LabRequirement on LabRequirement {
  id
  name
  targetType
  targetId
  code
  frequency
  thresholdLow
  thresholdHigh
  thresholdOutOfRangeLow
  thresholdOutOfRangeHigh
  unit
  effectiveDuration
  requirementId
  deletedAt
  authorId
}
    `;
export const ObservationStudyFragmentDoc = gql`
    fragment ObservationStudy on Study {
  name
  code
  value
  pageStart
  pageEnd
  datePerformed
  reconciliationStatus
  boundingBox {
    left
    width
    top
    height
  }
  dateInfo {
    name
    value
    pageStart
    pageEnd
    boundingBox {
      left
      width
      top
      height
    }
  }
  observations {
    ...observationWithBoundingBox
  }
  requirement {
    ...LabRequirement
  }
}
    ${ObservationWithBoundingBoxFragmentDoc}
${LabRequirementFragmentDoc}`;
export const GetDocOcrAnalysisFragmentDoc = gql`
    fragment GetDocOcrAnalysis on DocumentOCRAnalysis {
  patientDemographics {
    dateOfBirth
    firstName
    lastName
  }
  patient {
    ...DocumentOCDetectedPatient
  }
  surgery {
    ...SurgerySearch
  }
  studies {
    ...ObservationStudy
  }
}
    ${DocumentOcDetectedPatientFragmentDoc}
${SurgerySearchFragmentDoc}
${ObservationStudyFragmentDoc}`;
export const FaxItemFragmentDoc = gql`
    fragment FaxItem on Fax {
  id
  createdAt
  updatedAt
  subject
  requestMetadata
  direction
  name
  patientId
  surgeryId
  documentId
  requestFaxId
  status
  from
  callerId
  fromContact {
    id
    name
  }
  to
  toContact {
    id
    name
  }
  url
  surgery {
    id
  }
  patient {
    id
    firstName
    lastName
  }
}
    `;
export const FaxContactFragmentDoc = gql`
    fragment FaxContact on Contact {
  id
  relation
  name
  phone
  fax
  email
}
    `;
export const LabOptionFragmentDoc = gql`
    fragment LabOption on LabRequirement {
  id
  name
  code
  frequency
  effectiveDuration
  thresholdLow
  thresholdHigh
  thresholdOutOfRangeLow
  thresholdOutOfRangeHigh
  deletedAt
}
    `;
export const FaxResponseVerificationResultFieldsFragmentDoc = gql`
    fragment FaxResponseVerificationResultFields on FaxResponseVerificationResult {
  documentId
  patientMatch
  items {
    requestCode
    status
    reason
  }
}
    `;
export const MessageItemFragmentDoc = gql`
    fragment MessageItem on Message {
  id
  origin
  status
  content
  translation
  timestamp
  foreignStatus
  authorName
  author {
    id
    fullName
  }
}
    `;
export const ProcessStepStateFragmentDoc = gql`
    fragment ProcessStepState on ProcessStepState {
  id
  key
  label
  status
  displayOrder
  notes
  lastTransitionAt
  lastTransitionBy
  transitionType
  isVirtual
}
    `;
export const InAppSurgeryPlatformMessageFragmentDoc = gql`
    fragment InAppSurgeryPlatformMessage on Message {
  id
  authorId
  author {
    id
    firstName
    lastName
  }
  timestamp
  content
  origin
  status
}
    `;
export const AvailableFacilityFragmentDoc = gql`
    fragment AvailableFacility on Facility {
  id
  name
  network
}
    `;
export const FullAddressFragmentDoc = gql`
    fragment FullAddress on Address {
  id
  address1
  address2
  city
  state
  zip
}
    `;
export const RiskAssessmentFragmentDoc = gql`
    fragment RiskAssessment on RiskAssessment {
  id
  patientId
  surgeryId
  status
  priorAuth
  clearanceRiskLevel
  surgicalRiskLevel
  medicalClearance
  intakeRiskAssessment
  specialtyClearance
  cardiologyClearance
}
    `;
export const DocumentAnalysisFragmentDoc = gql`
    fragment DocumentAnalysis on DocumentAnalysis {
  id
  status
  type
  documentId
  jobId
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on Document {
  id
  createdAt
  updatedAt
  status
  author
  name
  type
  url
  effectiveAt
  foreignId
  ocrStatus
  surgeryId
  analyses {
    ...DocumentAnalysis
  }
}
    ${DocumentAnalysisFragmentDoc}`;
export const FullSurgeryResponseFragmentDoc = gql`
    fragment FullSurgeryResponse on Surgery {
  id
  referrer
  referredOn
  surgeonName
  surgeryType
  dateOfService
  patientId
  externalNotes
  archived
  notes
  workflow
  clearanceDocumentsSent
  clearanceDocumentsSentAt
  schedulingLink(visitType: PAT_VISIT)
  patient {
    id
    dob
    firstName
    lastName
    phone
    phoneType
    email
    emrId
    birthSex
    externalHieUrl
    coverage {
      id
      status
    }
    intake {
      id
    }
    address {
      ...FullAddress
    }
  }
  assessment {
    ...RiskAssessment
  }
  riskAssessmentAvailability
  surgeon {
    id
    firstName
    lastName
    fullName
    organizationId
  }
  documents {
    ...Document
  }
  facilityId
  facility {
    id
    name
    network
  }
  threadId
  unreadPlatformMessages
  pointsOfContact {
    id
    firstName
    lastName
    email
    isPrimary
    roleAssignmentId
    targetId
  }
}
    ${FullAddressFragmentDoc}
${RiskAssessmentFragmentDoc}
${DocumentFragmentDoc}`;
export const TaskFragmentDoc = gql`
    fragment Task on Task {
  id
  updatedAt
  authorId
  title
  description
  surgeryId
  organizationId
  dueDate
  completedAt
  assigneeId
  viewedByAssignee
  deletedAt
  status
}
    `;
export const IdentifyUserSessionFragmentDoc = gql`
    fragment IdentifyUserSession on SessionInfo {
  id
  firstName
  lastName
  email
  phone
  organizationId
  organization {
    id
    name
  }
  impersonator {
    id
    firstName
    lastName
    organizationId
  }
}
    `;
export const GenerateUploadUrlFragmentFragmentDoc = gql`
    fragment generateUploadUrlFragment on GenerateUploadUrlsResponse {
  document {
    id
    status
  }
  uploadUrl
}
    `;
export const FaxFragmentDoc = gql`
    fragment Fax on Fax {
  id
  createdAt
  updatedAt
  patientId
  surgeryId
  documentId
  requestFaxId
  from
  to
  subject
  requestMetadata
  status
  name
  url
}
    `;
export const FullIntakeFragmentDoc = gql`
    fragment FullIntake on IntakeQuestionaire {
  other {
    answer
  }
  endocrineDisorder {
    answer
  }
  immuneDisorders {
    answer
    description
  }
  bloodDisase {
    answer
    description
  }
  KidneyDisease {
    answer
    symptoms
  }
  liverDisease {
    answer
    symptoms
  }
  pulmonaryProblems {
    answer
    symptoms
  }
  congestiveHeartFailure {
    answer
    symptoms
  }
  neurologicalDisorder {
    answer
    description
    lastStroke
  }
  diabetes {
    answer
    description
    a1cLevel
    areYouTakingInsulin
  }
  bodilyMedicalDevies {
    deviceName
    informationCard
    deviceCheckedInLastYear
  }
  heartProblems {
    heartStents
    bloodTinners
    heartRhythmProblems
    faintedInTheLastYear
    canYouClimbTwoFlights
  }
  anesthesia {
    answer
    whatType
    pastProblems
    issuesIntubating
    malignantHyperthermia
    spineProblems
  }
}
    `;
export const FullPatientFragmentDoc = gql`
    fragment FullPatient on Patient {
  id
  emrId
  firstName
  lastName
  dob
  email
  intake {
    ...FullIntake
  }
  documents {
    ...Document
  }
}
    ${FullIntakeFragmentDoc}
${DocumentFragmentDoc}`;
export const ObservationPropsFragmentDoc = gql`
    fragment ObservationProps on Observation {
  id
  patientId
  effectiveDate
  system
  code
  description
  value
  unit
  sourceId
  sourceType
  sourceUrl
  overruledBy
  overruledByUser {
    id
    firstName
    lastName
  }
  overruledType
  encounterDescription
  author {
    id
    firstName
    lastName
  }
}
    `;
export const FullObservationFragmentDoc = gql`
    fragment FullObservation on Observation {
  ...ObservationProps
  observations {
    ...ObservationProps
  }
}
    ${ObservationPropsFragmentDoc}`;
export const ConditionPromptFragmentDoc = gql`
    fragment ConditionPrompt on Condition {
  id
  primaryCode
  secondaryCode
}
    `;
export const ConditionFragmentDoc = gql`
    fragment Condition on Condition {
  id
  deletedAt
  foreignId
  patientId
  displayName
  status
  lastReconciled
  primarySystem
  primaryCode
  secondarySystem
  secondaryCode
  onsetDate
  recordedDate
  surgicalRisk
  surgicalRiskReason
  notes
}
    `;
export const HieJobFragmentDoc = gql`
    fragment HieJob on HieJob {
  jobStatus
  createdAt
  updatedAt
  targetCompletionDate
  serviceProviders {
    service
    status
  }
}
    `;
export const MedicationPromptFragmentDoc = gql`
    fragment MedicationPrompt on Medication {
  id
  displayName
  activeIngredient
}
    `;
export const MedicationFragmentDoc = gql`
    fragment Medication on Medication {
  id
  createdAt
  deletedAt
  foreignId
  activeIngredient
  activeIngredientCode
  status
  lastFilledDate
  lastReconciled
  displayName
  primarySystem
  primaryCode
  confidenceScore
  confidenceScoreRationale
  dosageInstructions
  dosageStart
  dosageEnd
  surgicalRisk
  surgicalRiskReason
  updatedAt
}
    `;
export const GetPatientIntakeFormDocument = gql`
    query getPatientIntakeForm {
  token
  patients {
    ...FullPatient
  }
}
    ${FullPatientFragmentDoc}`;

export function useGetPatientIntakeFormQuery(options?: Omit<Urql.UseQueryArgs<GetPatientIntakeFormQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientIntakeFormQuery, GetPatientIntakeFormQueryVariables>({ query: GetPatientIntakeFormDocument, ...options });
};
export const GetFullPatientDocument = gql`
    query getFullPatient($patientId: ID) {
  patient(id: $patientId) {
    ...FullPatient
    riskAssessment {
      ...RiskAssessment
    }
    upcomingSurgery {
      ...BasicSurgeryInfo
    }
  }
}
    ${FullPatientFragmentDoc}
${RiskAssessmentFragmentDoc}
${BasicSurgeryInfoFragmentDoc}`;

export function useGetFullPatientQuery(options?: Omit<Urql.UseQueryArgs<GetFullPatientQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFullPatientQuery, GetFullPatientQueryVariables>({ query: GetFullPatientDocument, ...options });
};
export const GetRiskAssessmentStatusDocument = gql`
    query getRiskAssessmentStatus {
  riskAssessments {
    ...ModifyRiskAssessmentData
  }
}
    ${ModifyRiskAssessmentDataFragmentDoc}`;

export function useGetRiskAssessmentStatusQuery(options?: Omit<Urql.UseQueryArgs<GetRiskAssessmentStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRiskAssessmentStatusQuery, GetRiskAssessmentStatusQueryVariables>({ query: GetRiskAssessmentStatusDocument, ...options });
};
export const UpdateClearanceRiskLevelDocument = gql`
    mutation updateClearanceRiskLevel($clearanceLevelUpdate: ClearanceLevelInput!) {
  riskAssessment {
    updateRiskAssessmentClearanceLevel(clearanceLevel: $clearanceLevelUpdate) {
      id
      clearanceRiskLevel
    }
  }
}
    `;

export function useUpdateClearanceRiskLevelMutation() {
  return Urql.useMutation<UpdateClearanceRiskLevelMutation, UpdateClearanceRiskLevelMutationVariables>(UpdateClearanceRiskLevelDocument);
};
export const UpdateSurgicalRiskLevelDocument = gql`
    mutation updateSurgicalRiskLevel($surgicalRiskLevelUpdate: SurgicalRiskLevelInput!) {
  riskAssessment {
    updateSurgicalRiskLevel(surgicalRiskLevel: $surgicalRiskLevelUpdate) {
      id
      surgicalRiskLevel
    }
  }
}
    `;

export function useUpdateSurgicalRiskLevelMutation() {
  return Urql.useMutation<UpdateSurgicalRiskLevelMutation, UpdateSurgicalRiskLevelMutationVariables>(UpdateSurgicalRiskLevelDocument);
};
export const UpdateRiskAssessmentDocument = gql`
    mutation updateRiskAssessment($riskAssessment: RiskAssessmentInput!) {
  riskAssessment {
    updateRiskAssessment(riskAssessment: $riskAssessment) {
      id
      patientId
      surgeryId
      clearanceRiskLevel
      intakeRiskAssessment
      medicalClearance
      cardiologyClearance
      specialtyClearance
      labs
      priorAuth
    }
  }
}
    `;

export function useUpdateRiskAssessmentMutation() {
  return Urql.useMutation<UpdateRiskAssessmentMutation, UpdateRiskAssessmentMutationVariables>(UpdateRiskAssessmentDocument);
};
export const UpdateClearanceDocsSentDocument = gql`
    mutation updateClearanceDocsSent($surgery: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $surgery) {
      id
      instructionsSent
      clearanceDocumentsSent
      clearanceDocumentsSentAt
    }
  }
}
    `;

export function useUpdateClearanceDocsSentMutation() {
  return Urql.useMutation<UpdateClearanceDocsSentMutation, UpdateClearanceDocsSentMutationVariables>(UpdateClearanceDocsSentDocument);
};
export const SubmitIngestionDocument = gql`
    mutation submitIngestion($input: UploadIngestionFileInput!) {
  orchestraOperations {
    uploadIngestionFile(uploadIngestionFile: $input) {
      success
      messages
      jobId
    }
  }
}
    `;

export function useSubmitIngestionMutation() {
  return Urql.useMutation<SubmitIngestionMutation, SubmitIngestionMutationVariables>(SubmitIngestionDocument);
};
export const IngestionJobStatusDocument = gql`
    query ingestionJobStatus($jobId: ID!) {
  ingestionJob(jobId: $jobId) {
    id
    status
    totalRows
    processedRows
    errorCount
    messages
    createdAt
    updatedAt
  }
}
    `;

export function useIngestionJobStatusQuery(options: Omit<Urql.UseQueryArgs<IngestionJobStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<IngestionJobStatusQuery, IngestionJobStatusQueryVariables>({ query: IngestionJobStatusDocument, ...options });
};
export const PromptDocument = gql`
    mutation prompt($surgeryId: SurgeryId!, $prompt: String!, $options: PromptChatOptions) {
  riskAssessment {
    promptChat(surgeryId: $surgeryId, prompt: $prompt, options: $options) {
      completion
      documentContext {
        id
        name
        type
        url
      }
    }
  }
}
    `;

export function usePromptMutation() {
  return Urql.useMutation<PromptMutation, PromptMutationVariables>(PromptDocument);
};
export const StagehandPatientsDocument = gql`
    query stagehandPatients {
  surgeries {
    ...StageHandSurgery
  }
}
    ${StageHandSurgeryFragmentDoc}`;

export function useStagehandPatientsQuery(options?: Omit<Urql.UseQueryArgs<StagehandPatientsQueryVariables>, 'query'>) {
  return Urql.useQuery<StagehandPatientsQuery, StagehandPatientsQueryVariables>({ query: StagehandPatientsDocument, ...options });
};
export const GetOrganizationInfoForFaxPageDocument = gql`
    query getOrganizationInfoForFaxPage {
  organization {
    id
    name
    faxNumber
  }
}
    `;

export function useGetOrganizationInfoForFaxPageQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationInfoForFaxPageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationInfoForFaxPageQuery, GetOrganizationInfoForFaxPageQueryVariables>({ query: GetOrganizationInfoForFaxPageDocument, ...options });
};
export const LinkFaxWithSurgeryDocument = gql`
    mutation linkFaxWithSurgery($input: AssociateFaxWithSurgeryInput!) {
  providerOperations {
    associateFaxWithSurgery(input: $input) {
      ...FaxItem
    }
  }
}
    ${FaxItemFragmentDoc}`;

export function useLinkFaxWithSurgeryMutation() {
  return Urql.useMutation<LinkFaxWithSurgeryMutation, LinkFaxWithSurgeryMutationVariables>(LinkFaxWithSurgeryDocument);
};
export const SaveFaxContactDocument = gql`
    mutation saveFaxContact($input: FaxContactInput!) {
  providerOperations {
    insertFaxContact(input: $input) {
      id
      name
      relation
      phone
      fax
      email
    }
  }
}
    `;

export function useSaveFaxContactMutation() {
  return Urql.useMutation<SaveFaxContactMutation, SaveFaxContactMutationVariables>(SaveFaxContactDocument);
};
export const ResendFaxDocument = gql`
    mutation resendFax($faxId: FaxId!, $to: PhoneNumber) {
  providerOperations {
    resendFax(faxId: $faxId, to: $to) {
      ping
    }
  }
}
    `;

export function useResendFaxMutation() {
  return Urql.useMutation<ResendFaxMutation, ResendFaxMutationVariables>(ResendFaxDocument);
};
export const GetUsersDocument = gql`
    query getUsers {
  users {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;

export function useGetUsersQuery(options?: Omit<Urql.UseQueryArgs<GetUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersQuery, GetUsersQueryVariables>({ query: GetUsersDocument, ...options });
};
export const ChangeUserStatusDocument = gql`
    mutation changeUserStatus($id: UserId!, $status: UserStatus!) {
  provider {
    changeUserStatus(id: $id, status: $status) {
      id
      status
    }
  }
}
    `;

export function useChangeUserStatusMutation() {
  return Urql.useMutation<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>(ChangeUserStatusDocument);
};
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  organizations {
    id
    name
    network
    specialty
  }
}
    `;

export function useGetOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>({ query: GetOrganizationsDocument, ...options });
};
export const GetRiskAssessmentDocument = gql`
    query getRiskAssessment($patientId: ID!) {
  patient(id: $patientId) {
    intake {
      ...FullIntake
    }
    documents {
      ...Document
    }
  }
  riskAssessment(patientId: $patientId) {
    id
    patientId
    patient {
      id
      firstName
      lastName
      visits(type: RISK_ASSESSMENT) {
        id
        copayStatus
      }
    }
    intakeRiskAssessment
    medicalClearance
    cardiologyClearance
    specialtyClearance
    labs
    priorAuth
    surgery {
      id
      surgeonId
      stakeholders {
        id
        name
        specialty
      }
      careTeam {
        id
        patientId
        name
        specialty
        phone
        email
        fax
      }
    }
  }
}
    ${FullIntakeFragmentDoc}
${DocumentFragmentDoc}`;

export function useGetRiskAssessmentQuery(options: Omit<Urql.UseQueryArgs<GetRiskAssessmentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRiskAssessmentQuery, GetRiskAssessmentQueryVariables>({ query: GetRiskAssessmentDocument, ...options });
};
export const GetPatientsForSubmissionsDocument = gql`
    query getPatientsForSubmissions {
  patients {
    id
    firstName
    lastName
    intake {
      id
    }
  }
}
    `;

export function useGetPatientsForSubmissionsQuery(options?: Omit<Urql.UseQueryArgs<GetPatientsForSubmissionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientsForSubmissionsQuery, GetPatientsForSubmissionsQueryVariables>({ query: GetPatientsForSubmissionsDocument, ...options });
};
export const UpdateCoverageFromNameDocument = gql`
    mutation updateCoverageFromName($patientId: PatientId!, $payerName: String!, $subscriberNumber: String!, $address: AddressInput!) {
  patient {
    addCoverageFromName(
      patientId: $patientId
      payerName: $payerName
      subscriberNumber: $subscriberNumber
      address: $address
    ) {
      id
      status
    }
  }
}
    `;

export function useUpdateCoverageFromNameMutation() {
  return Urql.useMutation<UpdateCoverageFromNameMutation, UpdateCoverageFromNameMutationVariables>(UpdateCoverageFromNameDocument);
};
export const GetVisitDocument = gql`
    query getVisit($patientId: ID!) {
  patient(id: $patientId) {
    id
    visits {
      id
      copay
      copayStatus
    }
  }
}
    `;

export function useGetVisitQuery(options: Omit<Urql.UseQueryArgs<GetVisitQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVisitQuery, GetVisitQueryVariables>({ query: GetVisitDocument, ...options });
};
export const GetVisitWithProviderDocument = gql`
    query getVisitWithProvider($patientId: ID!) {
  patient(id: $patientId) {
    id
    visits {
      id
      copay
      copayStatus
      provider {
        id
        fullName
      }
    }
  }
}
    `;

export function useGetVisitWithProviderQuery(options: Omit<Urql.UseQueryArgs<GetVisitWithProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVisitWithProviderQuery, GetVisitWithProviderQueryVariables>({ query: GetVisitWithProviderDocument, ...options });
};
export const GetPatientDocument = gql`
    query getPatient($patientId: ID!) {
  patient(id: $patientId) {
    id
    firstName
    lastName
    email
  }
}
    `;

export function useGetPatientQuery(options: Omit<Urql.UseQueryArgs<GetPatientQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientQuery, GetPatientQueryVariables>({ query: GetPatientDocument, ...options });
};
export const RegisterPatientDocument = gql`
    mutation registerPatient($registerRequest: RegisterRequest!) {
  patient {
    registerPatient(request: $registerRequest)
  }
}
    `;

export function useRegisterPatientMutation() {
  return Urql.useMutation<RegisterPatientMutation, RegisterPatientMutationVariables>(RegisterPatientDocument);
};
export const CreatePatientDocument = gql`
    mutation createPatient($patient: PatientInput!) {
  patient {
    create(patient: $patient)
  }
}
    `;

export function useCreatePatientMutation() {
  return Urql.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument);
};
export const UploadIntakeQuestionaireDocument = gql`
    mutation uploadIntakeQuestionaire($intake: PatientIntakeQuestionaire!) {
  authorizedPatient {
    intakeQuestionaire(intake: $intake) {
      ping
    }
  }
}
    `;

export function useUploadIntakeQuestionaireMutation() {
  return Urql.useMutation<UploadIntakeQuestionaireMutation, UploadIntakeQuestionaireMutationVariables>(UploadIntakeQuestionaireDocument);
};
export const HealthcheckDocument = gql`
    query healthcheck {
  ping
}
    `;

export function useHealthcheckQuery(options?: Omit<Urql.UseQueryArgs<HealthcheckQueryVariables>, 'query'>) {
  return Urql.useQuery<HealthcheckQuery, HealthcheckQueryVariables>({ query: HealthcheckDocument, ...options });
};
export const ScheduleVisitDocument = gql`
    mutation scheduleVisit($visitParams: VisitParams!) {
  patient {
    scheduleVisit(visitParams: $visitParams) {
      id
      status
      date
      foreignId
      copay
      copayStatus
    }
  }
}
    `;

export function useScheduleVisitMutation() {
  return Urql.useMutation<ScheduleVisitMutation, ScheduleVisitMutationVariables>(ScheduleVisitDocument);
};
export const RegisterPatientInfoDocument = gql`
    query registerPatientInfo($type: VisitType) {
  patient {
    id
    intake {
      id
    }
    visits(type: $type) {
      id
      copay
      copayStatus
    }
    upcomingSurgery {
      id
    }
  }
}
    `;

export function useRegisterPatientInfoQuery(options?: Omit<Urql.UseQueryArgs<RegisterPatientInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<RegisterPatientInfoQuery, RegisterPatientInfoQueryVariables>({ query: RegisterPatientInfoDocument, ...options });
};
export const RegisterCareTeamDocument = gql`
    mutation RegisterCareTeam($careTeam: [ContactInput!]!) {
  authorizedPatient {
    registerCareTeam(careTeam: $careTeam) {
      id
      name
      relation
    }
  }
}
    `;

export function useRegisterCareTeamMutation() {
  return Urql.useMutation<RegisterCareTeamMutation, RegisterCareTeamMutationVariables>(RegisterCareTeamDocument);
};
export const GetPayersDocument = gql`
    query GetPayers {
  static {
    payers {
      id
      attachment
      workers_comp
      payer_alt_names {
        alt_payer_name
      }
      claims_1500
      payer_name
      ub_claims
      dent_claims
      payer_state
      secondary_support
      auto
      eligibility
      payer_type
      payerid
      era
    }
  }
}
    `;

export function useGetPayersQuery(options?: Omit<Urql.UseQueryArgs<GetPayersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPayersQuery, GetPayersQueryVariables>({ query: GetPayersDocument, ...options });
};
export const GetOutstandingBalanceDocument = gql`
    query getOutstandingBalance {
  patient {
    id
    outstandingBalance {
      id
      patientId
      amountDue
      lineItems {
        id
        category
        amount
      }
    }
  }
}
    `;

export function useGetOutstandingBalanceQuery(options?: Omit<Urql.UseQueryArgs<GetOutstandingBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOutstandingBalanceQuery, GetOutstandingBalanceQueryVariables>({ query: GetOutstandingBalanceDocument, ...options });
};
export const GetPatientUploadUrlsDocument = gql`
    mutation GetPatientUploadUrls($files: [FileCandidate!]!) {
  authorizedPatient {
    generateS3Files(files: $files) {
      id
      createdAt
      updatedAt
      status
      name
      type
      url
    }
  }
}
    `;

export function useGetPatientUploadUrlsMutation() {
  return Urql.useMutation<GetPatientUploadUrlsMutation, GetPatientUploadUrlsMutationVariables>(GetPatientUploadUrlsDocument);
};
export const UploadContentToFileDocument = gql`
    mutation uploadContentToFile($file: SignaturesAoBandTicFileRequest!, $patientId: PatientId!) {
  authorizedPatient {
    uploadS3Content(file: $file, patientId: $patientId) {
      id
      createdAt
      name
      type
      url
    }
  }
}
    `;

export function useUploadContentToFileMutation() {
  return Urql.useMutation<UploadContentToFileMutation, UploadContentToFileMutationVariables>(UploadContentToFileDocument);
};
export const RequestRecordFromContactDocument = gql`
    mutation RequestRecordFromContact($careTeamMemberId: String!) {
  authorizedPatient {
    requestRecordFromCareTeamMember(careTeamMemberId: $careTeamMemberId)
  }
}
    `;

export function useRequestRecordFromContactMutation() {
  return Urql.useMutation<RequestRecordFromContactMutation, RequestRecordFromContactMutationVariables>(RequestRecordFromContactDocument);
};
export const GetPatientDocumentsDocument = gql`
    query getPatientDocuments {
  patient {
    documents {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;

export function useGetPatientDocumentsQuery(options?: Omit<Urql.UseQueryArgs<GetPatientDocumentsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientDocumentsQuery, GetPatientDocumentsQueryVariables>({ query: GetPatientDocumentsDocument, ...options });
};
export const GetPatientPlanDocument = gql`
    query getPatientPlan {
  patient {
    ...GetPatientPlanResponse
  }
}
    ${GetPatientPlanResponseFragmentDoc}`;

export function useGetPatientPlanQuery(options?: Omit<Urql.UseQueryArgs<GetPatientPlanQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientPlanQuery, GetPatientPlanQueryVariables>({ query: GetPatientPlanDocument, ...options });
};
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($deleteDocumentId: ID!, $patientId: ID!) {
  patient {
    deleteDocument(id: $deleteDocumentId) {
      patient(id: $patientId) {
        documents {
          id
          name
          type
          url
        }
      }
    }
  }
}
    `;

export function useDeleteDocumentMutation() {
  return Urql.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument);
};
export const UpdateDocumentNameDocument = gql`
    mutation updateDocumentName($updateDocumentNameId: ID!, $documentName: String!) {
  document {
    updateDocumentName(
      documentId: $updateDocumentNameId
      documentName: $documentName
    ) {
      id
      name
    }
  }
}
    `;

export function useUpdateDocumentNameMutation() {
  return Urql.useMutation<UpdateDocumentNameMutation, UpdateDocumentNameMutationVariables>(UpdateDocumentNameDocument);
};
export const AddCompletedVisitDocument = gql`
    mutation addCompletedVisit($surgeryId: SurgeryId!) {
  provider {
    addCompletedVisit(surgeryId: $surgeryId) {
      surgery(id: $surgeryId) {
        id
        visits {
          id
          status
          date
          foreignId
          copay
          copayStatus
        }
      }
    }
  }
}
    `;

export function useAddCompletedVisitMutation() {
  return Urql.useMutation<AddCompletedVisitMutation, AddCompletedVisitMutationVariables>(AddCompletedVisitDocument);
};
export const MarkVisitCompletedDocument = gql`
    mutation markVisitCompleted($surgeryId: SurgeryId!, $visitId: VisitId) {
  provider {
    markVisitCompleted(surgeryId: $surgeryId, visitId: $visitId) {
      surgery(id: $surgeryId) {
        id
        visits {
          id
          status
          date
          foreignId
          copay
          copayStatus
        }
      }
    }
  }
}
    `;

export function useMarkVisitCompletedMutation() {
  return Urql.useMutation<MarkVisitCompletedMutation, MarkVisitCompletedMutationVariables>(MarkVisitCompletedDocument);
};
export const UpdateVisitStatusDocument = gql`
    mutation updateVisitStatus($id: SurgeryId!, $status: VisitStatus!, $visitId: ID) {
  provider {
    updateVisitStatus(id: $id, status: $status, visitId: $visitId) {
      surgery(id: $id) {
        id
        visits {
          id
          status
          date
          foreignId
          copay
          copayStatus
        }
      }
    }
  }
}
    `;

export function useUpdateVisitStatusMutation() {
  return Urql.useMutation<UpdateVisitStatusMutation, UpdateVisitStatusMutationVariables>(UpdateVisitStatusDocument);
};
export const InitiatePasswordResetDocument = gql`
    mutation InitiatePasswordReset($email: String!, $method: InitiatePasswordResetMethod) {
  provider {
    initiatePasswordReset(email: $email, method: $method) {
      ...InitiatePasswordResetResponse
    }
  }
}
    ${InitiatePasswordResetResponseFragmentDoc}`;

export function useInitiatePasswordResetMutation() {
  return Urql.useMutation<InitiatePasswordResetMutation, InitiatePasswordResetMutationVariables>(InitiatePasswordResetDocument);
};
export const ResetLoginDocument = gql`
    mutation ResetLogin($email: String!, $resetCode: String!, $newPassword: String!) {
  provider {
    resetLogin(email: $email, resetCode: $resetCode, newPassword: $newPassword)
  }
}
    `;

export function useResetLoginMutation() {
  return Urql.useMutation<ResetLoginMutation, ResetLoginMutationVariables>(ResetLoginDocument);
};
export const GetOrganizationSchedulingLinkDocument = gql`
    query getOrganizationSchedulingLink {
  organization {
    id
    schedulingLink
  }
}
    `;

export function useGetOrganizationSchedulingLinkQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationSchedulingLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationSchedulingLinkQuery, GetOrganizationSchedulingLinkQueryVariables>({ query: GetOrganizationSchedulingLinkDocument, ...options });
};
export const GetVisitsDocument = gql`
    query getVisits($type: VisitType!, $filter: VisitFilterOptions) {
  organization {
    id
  }
  visits(type: $type, filter: $filter) {
    ...ProviderVisit
  }
  visitSlots(type: $type) {
    id
    date
    type
    scheduleUrl
  }
}
    ${ProviderVisitFragmentDoc}`;

export function useGetVisitsQuery(options: Omit<Urql.UseQueryArgs<GetVisitsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVisitsQuery, GetVisitsQueryVariables>({ query: GetVisitsDocument, ...options });
};
export const GetUsersForOrganizationDocument = gql`
    query getUsersForOrganization {
  organization {
    users {
      ...FullUser
    }
  }
}
    ${FullUserFragmentDoc}`;

export function useGetUsersForOrganizationQuery(options?: Omit<Urql.UseQueryArgs<GetUsersForOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersForOrganizationQuery, GetUsersForOrganizationQueryVariables>({ query: GetUsersForOrganizationDocument, ...options });
};
export const GetCaseMedicationInstructionsDocument = gql`
    query getCaseMedicationInstructions($surgeryId: SurgeryId!) {
  surgery(id: $surgeryId) {
    instructions(source: MEDICATION) {
      name
      description
      type
    }
  }
}
    `;

export function useGetCaseMedicationInstructionsQuery(options: Omit<Urql.UseQueryArgs<GetCaseMedicationInstructionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCaseMedicationInstructionsQuery, GetCaseMedicationInstructionsQueryVariables>({ query: GetCaseMedicationInstructionsDocument, ...options });
};
export const SendESignLinkMessageDocument = gql`
    mutation sendESignLinkMessage($surgeryId: SurgeryId!, $sendText: Boolean) {
  patient {
    sendESignLinkMessage(surgeryId: $surgeryId, sendText: $sendText)
  }
}
    `;

export function useSendESignLinkMessageMutation() {
  return Urql.useMutation<SendESignLinkMessageMutation, SendESignLinkMessageMutationVariables>(SendESignLinkMessageDocument);
};
export const ConfirmESignDocument = gql`
    query confirmESign($patientId: PatientId!) {
  confirmESign(patientId: $patientId)
}
    `;

export function useConfirmESignQuery(options: Omit<Urql.UseQueryArgs<ConfirmESignQueryVariables>, 'query'>) {
  return Urql.useQuery<ConfirmESignQuery, ConfirmESignQueryVariables>({ query: ConfirmESignDocument, ...options });
};
export const Send2faMessageDocument = gql`
    mutation send2faMessage($patientId: PatientId!, $dob: Date!, $phone: String!) {
  patient {
    send2faMessage(patientId: $patientId, dob: $dob, phone: $phone)
  }
}
    `;

export function useSend2faMessageMutation() {
  return Urql.useMutation<Send2faMessageMutation, Send2faMessageMutationVariables>(Send2faMessageDocument);
};
export const IntakeProcessStatusDocument = gql`
    query intakeProcessStatus($surgeryId: SurgeryId!) {
  intakeProcessStatus(surgeryId: $surgeryId) {
    id
    intakeQLatestDate
    coverageLatestDate
    signaturesDate
    preopVisitDate
    visitCopayStatus
    visitCopay
    patientId
    firstName
    lastName
    email
    phone
  }
}
    `;

export function useIntakeProcessStatusQuery(options: Omit<Urql.UseQueryArgs<IntakeProcessStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<IntakeProcessStatusQuery, IntakeProcessStatusQueryVariables>({ query: IntakeProcessStatusDocument, ...options });
};
export const AddCoverageDocument = gql`
    mutation addCoverage($patientId: PatientId!, $coverage: CoverageInput!) {
  authorizedPatient {
    addCoverage(patientId: $patientId, coverage: $coverage)
  }
}
    `;

export function useAddCoverageMutation() {
  return Urql.useMutation<AddCoverageMutation, AddCoverageMutationVariables>(AddCoverageDocument);
};
export const AddAddressDocument = gql`
    mutation addAddress($patientId: PatientId!, $address: AddressInput!) {
  authorizedPatient {
    addAddress(patientId: $patientId, address: $address)
  }
}
    `;

export function useAddAddressMutation() {
  return Urql.useMutation<AddAddressMutation, AddAddressMutationVariables>(AddAddressDocument);
};
export const ScheduleOpenLoopVisitDocument = gql`
    mutation scheduleOpenLoopVisit($surgeryId: SurgeryId!, $preferredTimeZone: String) {
  patient {
    scheduleOpenLoopVisit(
      surgeryId: $surgeryId
      preferredTimeZone: $preferredTimeZone
    ) {
      conflict
      visit {
        id
        status
        date
        foreignId
        copay
        copayStatus
      }
    }
  }
}
    `;

export function useScheduleOpenLoopVisitMutation() {
  return Urql.useMutation<ScheduleOpenLoopVisitMutation, ScheduleOpenLoopVisitMutationVariables>(ScheduleOpenLoopVisitDocument);
};
export const ValidateAuthDocument = gql`
    mutation validateAuth($surgeryId: SurgeryId!) {
  authorizedPatient {
    validateAuth(surgeryId: $surgeryId)
  }
}
    `;

export function useValidateAuthMutation() {
  return Urql.useMutation<ValidateAuthMutation, ValidateAuthMutationVariables>(ValidateAuthDocument);
};
export const SetPreferredTimeZoneDocument = gql`
    mutation setPreferredTimeZone($preferredTimeZone: String!) {
  authorizedPatient {
    setPreferredTimeZone(preferredTimeZone: $preferredTimeZone)
  }
}
    `;

export function useSetPreferredTimeZoneMutation() {
  return Urql.useMutation<SetPreferredTimeZoneMutation, SetPreferredTimeZoneMutationVariables>(SetPreferredTimeZoneDocument);
};
export const GetPatientIdFromSurgeryIdDocument = gql`
    query getPatientIdFromSurgeryId($surgeryId: SurgeryId!) {
  getPatientIdFromSurgeryId(surgeryId: $surgeryId)
}
    `;

export function useGetPatientIdFromSurgeryIdQuery(options: Omit<Urql.UseQueryArgs<GetPatientIdFromSurgeryIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientIdFromSurgeryIdQuery, GetPatientIdFromSurgeryIdQueryVariables>({ query: GetPatientIdFromSurgeryIdDocument, ...options });
};
export const GetPreopClinicalPacketDocument = gql`
    query getPreopClinicalPacket($surgeryId: SurgeryId!, $refresh: Boolean!) {
  preopClinicalPacket(surgeryId: $surgeryId, refresh: $refresh)
}
    `;

export function useGetPreopClinicalPacketQuery(options: Omit<Urql.UseQueryArgs<GetPreopClinicalPacketQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPreopClinicalPacketQuery, GetPreopClinicalPacketQueryVariables>({ query: GetPreopClinicalPacketDocument, ...options });
};
export const GetPatientContactInfoDocument = gql`
    query getPatientContactInfo($id: SurgeryId!) {
  surgery(id: $id) {
    dateOfService
    patient {
      id
      firstName
      lastName
      email
      phone
    }
  }
}
    `;

export function useGetPatientContactInfoQuery(options: Omit<Urql.UseQueryArgs<GetPatientContactInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientContactInfoQuery, GetPatientContactInfoQueryVariables>({ query: GetPatientContactInfoDocument, ...options });
};
export const AcknowledgeDocumentsDocument = gql`
    mutation acknowledgeDocuments($acknowledgements: [AcknowledgementInput!]!) {
  patient {
    addAcknowledgements(acknowledgements: $acknowledgements) {
      patientId
      docType
      acknowledgedAt
      signature
      mfaCode
    }
  }
}
    `;

export function useAcknowledgeDocumentsMutation() {
  return Urql.useMutation<AcknowledgeDocumentsMutation, AcknowledgeDocumentsMutationVariables>(AcknowledgeDocumentsDocument);
};
export const CancelOpenLoopVisitDocument = gql`
    mutation cancelOpenLoopVisit($surgeryId: SurgeryId!) {
  patient {
    cancelOpenLoopVisit(surgeryId: $surgeryId)
  }
}
    `;

export function useCancelOpenLoopVisitMutation() {
  return Urql.useMutation<CancelOpenLoopVisitMutation, CancelOpenLoopVisitMutationVariables>(CancelOpenLoopVisitDocument);
};
export const GetOrganizationProvidersDocument = gql`
    query getOrganizationProviders {
  organization {
    users(role: PROVIDER) {
      id
      firstName
      lastName
      role
    }
  }
}
    `;

export function useGetOrganizationProvidersQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationProvidersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationProvidersQuery, GetOrganizationProvidersQueryVariables>({ query: GetOrganizationProvidersDocument, ...options });
};
export const ProviderLoginDocument = gql`
    mutation providerLogin($credentials: Credentials!) {
  provider {
    login(credentials: $credentials)
  }
}
    `;

export function useProviderLoginMutation() {
  return Urql.useMutation<ProviderLoginMutation, ProviderLoginMutationVariables>(ProviderLoginDocument);
};
export const GetSurgeriesDocument = gql`
    query getSurgeries($filterCriteria: SurgeriesFilterCriteria) {
  time
  surgeries(filterCriteria: $filterCriteria) {
    ...SurgeryListResponse
  }
}
    ${SurgeryListResponseFragmentDoc}`;

export function useGetSurgeriesQuery(options?: Omit<Urql.UseQueryArgs<GetSurgeriesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeriesQuery, GetSurgeriesQueryVariables>({ query: GetSurgeriesDocument, ...options });
};
export const GetSurgeriesPaginatedDocument = gql`
    query getSurgeriesPaginated($filterCriteria: SurgeriesFilterCriteria, $pageInfo: PageInfoInput!) {
  time
  surgeriesPaginated(filterCriteria: $filterCriteria, pageInfo: $pageInfo) {
    surgeries {
      ...SurgeryListResponse
    }
    pageInfo {
      pageSize
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${SurgeryListResponseFragmentDoc}`;

export function useGetSurgeriesPaginatedQuery(options: Omit<Urql.UseQueryArgs<GetSurgeriesPaginatedQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeriesPaginatedQuery, GetSurgeriesPaginatedQueryVariables>({ query: GetSurgeriesPaginatedDocument, ...options });
};
export const GetSurgeriesSummaryDocument = gql`
    query getSurgeriesSummary($filterCriteria: SurgerySummaryCriteria!) {
  surgeriesSummary(filterCriteria: $filterCriteria) {
    clearedCount
    inProgressCount
    notClearedCount
    noDosCount
    noVisitCount
  }
}
    `;

export function useGetSurgeriesSummaryQuery(options: Omit<Urql.UseQueryArgs<GetSurgeriesSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeriesSummaryQuery, GetSurgeriesSummaryQueryVariables>({ query: GetSurgeriesSummaryDocument, ...options });
};
export const OnSurgeryListUpdatedDocument = gql`
    subscription onSurgeryListUpdated($stakeholderId: OrganizationId) {
  surgery(stakeholderId: $stakeholderId) {
    ...SurgeryListResponse
  }
}
    ${SurgeryListResponseFragmentDoc}`;

export function useOnSurgeryListUpdatedSubscription<TData = OnSurgeryListUpdatedSubscription>(options: Omit<Urql.UseSubscriptionArgs<OnSurgeryListUpdatedSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<OnSurgeryListUpdatedSubscription, TData>) {
  return Urql.useSubscription<OnSurgeryListUpdatedSubscription, TData, OnSurgeryListUpdatedSubscriptionVariables>({ query: OnSurgeryListUpdatedDocument, ...options }, handler);
};
export const GetServerPingDocument = gql`
    subscription getServerPing {
  ping
}
    `;

export function useGetServerPingSubscription<TData = GetServerPingSubscription>(options: Omit<Urql.UseSubscriptionArgs<GetServerPingSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<GetServerPingSubscription, TData>) {
  return Urql.useSubscription<GetServerPingSubscription, TData, GetServerPingSubscriptionVariables>({ query: GetServerPingDocument, ...options }, handler);
};
export const SearchSurgeriesDocument = gql`
    query searchSurgeries($search: String!) {
  surgeries(filterCriteria: {namesMatcher: $search}) {
    ...SurgerySearch
  }
}
    ${SurgerySearchFragmentDoc}`;

export function useSearchSurgeriesQuery(options: Omit<Urql.UseQueryArgs<SearchSurgeriesQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchSurgeriesQuery, SearchSurgeriesQueryVariables>({ query: SearchSurgeriesDocument, ...options });
};
export const GetSurgeryInfoDocument = gql`
    query getSurgeryInfo($id: SurgeryId!) {
  surgery(id: $id) {
    ...SurgerySearch
  }
}
    ${SurgerySearchFragmentDoc}`;

export function useGetSurgeryInfoQuery(options: Omit<Urql.UseQueryArgs<GetSurgeryInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeryInfoQuery, GetSurgeryInfoQueryVariables>({ query: GetSurgeryInfoDocument, ...options });
};
export const GetSurgeryEventsDocument = gql`
    query getSurgeryEvents($eventContextId: String!) {
  events(type: SURGERY, eventContextId: $eventContextId) {
    ...SurgeryEventLog
  }
}
    ${SurgeryEventLogFragmentDoc}`;

export function useGetSurgeryEventsQuery(options: Omit<Urql.UseQueryArgs<GetSurgeryEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeryEventsQuery, GetSurgeryEventsQueryVariables>({ query: GetSurgeryEventsDocument, ...options });
};
export const GetPatientEventsDocument = gql`
    query getPatientEvents($eventContextId: String!) {
  events(type: PATIENT, eventContextId: $eventContextId) {
    ...SurgeryEventLog
  }
}
    ${SurgeryEventLogFragmentDoc}`;

export function useGetPatientEventsQuery(options: Omit<Urql.UseQueryArgs<GetPatientEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientEventsQuery, GetPatientEventsQueryVariables>({ query: GetPatientEventsDocument, ...options });
};
export const UpdateDocumentSurgeryDocument = gql`
    mutation updateDocumentSurgery($documentId: DocumentId!, $surgeryId: SurgeryId!) {
  document {
    updateDocumentSurgery(documentId: $documentId, surgeryId: $surgeryId) {
      id
      surgeryId
      patientId
    }
  }
}
    `;

export function useUpdateDocumentSurgeryMutation() {
  return Urql.useMutation<UpdateDocumentSurgeryMutation, UpdateDocumentSurgeryMutationVariables>(UpdateDocumentSurgeryDocument);
};
export const GetDocAnalysisDocument = gql`
    query getDocAnalysis($documentId: DocumentId!) {
  document(id: $documentId) {
    id
    url
    surgeryId
    patient {
      ...DocumentOCDetectedPatient
    }
    ocrAnalysis {
      ...GetDocOcrAnalysis
    }
  }
}
    ${DocumentOcDetectedPatientFragmentDoc}
${GetDocOcrAnalysisFragmentDoc}`;

export function useGetDocAnalysisQuery(options: Omit<Urql.UseQueryArgs<GetDocAnalysisQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDocAnalysisQuery, GetDocAnalysisQueryVariables>({ query: GetDocAnalysisDocument, ...options });
};
export const GetConditionDocument = gql`
    query getCondition($conditionId: ConditionId!) {
  condition(conditionId: $conditionId) {
    ...Condition
  }
}
    ${ConditionFragmentDoc}`;

export function useGetConditionQuery(options: Omit<Urql.UseQueryArgs<GetConditionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetConditionQuery, GetConditionQueryVariables>({ query: GetConditionDocument, ...options });
};
export const GetPatientConditionsDocument = gql`
    query getPatientConditions($patientId: ID!) {
  patient(id: $patientId) {
    conditions {
      ...Condition
    }
  }
}
    ${ConditionFragmentDoc}`;

export function useGetPatientConditionsQuery(options: Omit<Urql.UseQueryArgs<GetPatientConditionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientConditionsQuery, GetPatientConditionsQueryVariables>({ query: GetPatientConditionsDocument, ...options });
};
export const UpdateConditionDocument = gql`
    mutation updateCondition($condition: UpdateCondition!) {
  condition {
    updateCondition(condition: $condition) {
      ...Condition
    }
  }
}
    ${ConditionFragmentDoc}`;

export function useUpdateConditionMutation() {
  return Urql.useMutation<UpdateConditionMutation, UpdateConditionMutationVariables>(UpdateConditionDocument);
};
export const DeleteConditionDocument = gql`
    mutation deleteCondition($conditionId: ConditionId!) {
  condition {
    deleteCondition(conditionId: $conditionId) {
      ...Condition
    }
  }
}
    ${ConditionFragmentDoc}`;

export function useDeleteConditionMutation() {
  return Urql.useMutation<DeleteConditionMutation, DeleteConditionMutationVariables>(DeleteConditionDocument);
};
export const GetFaxListDocument = gql`
    query getFaxList($options: FaxOptions) {
  faxes(options: $options) {
    ...FaxItem
  }
}
    ${FaxItemFragmentDoc}`;

export function useGetFaxListQuery(options?: Omit<Urql.UseQueryArgs<GetFaxListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFaxListQuery, GetFaxListQueryVariables>({ query: GetFaxListDocument, ...options });
};
export const GenerateDocumentUrlsDocument = gql`
    mutation generateDocumentUrls($input: [String!]!) {
  providerOperations {
    generateUploadUploadUrls(files: $input)
  }
}
    `;

export function useGenerateDocumentUrlsMutation() {
  return Urql.useMutation<GenerateDocumentUrlsMutation, GenerateDocumentUrlsMutationVariables>(GenerateDocumentUrlsDocument);
};
export const InitiateFaxRequestDocument = gql`
    mutation initiateFaxRequest($input: InitiateFaxRequest!) {
  providerOperations {
    initiateFax(input: $input) {
      faxes {
        ...FaxItem
      }
    }
  }
}
    ${FaxItemFragmentDoc}`;

export function useInitiateFaxRequestMutation() {
  return Urql.useMutation<InitiateFaxRequestMutation, InitiateFaxRequestMutationVariables>(InitiateFaxRequestDocument);
};
export const GetFaxContactsDocument = gql`
    query getFaxContacts($parameters: ContactSearchInput) {
  contacts(parameters: $parameters) {
    ...FaxContact
  }
}
    ${FaxContactFragmentDoc}`;

export function useGetFaxContactsQuery(options?: Omit<Urql.UseQueryArgs<GetFaxContactsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFaxContactsQuery, GetFaxContactsQueryVariables>({ query: GetFaxContactsDocument, ...options });
};
export const GetLabOptionsDocument = gql`
    query getLabOptions {
  orchestraLabRequirements {
    ...LabOption
    labRequirements {
      ...LabOption
    }
  }
}
    ${LabOptionFragmentDoc}`;

export function useGetLabOptionsQuery(options?: Omit<Urql.UseQueryArgs<GetLabOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLabOptionsQuery, GetLabOptionsQueryVariables>({ query: GetLabOptionsDocument, ...options });
};
export const GetStudyTrackingDocument = gql`
    query getStudyTracking($surgeryId: SurgeryId!) {
  studyTracking(surgeryId: $surgeryId) {
    labRequirements {
      ...LabRequirement
      labRequirements {
        ...LabRequirement
      }
    }
    observations {
      ...FullObservation
    }
    faxResponseVerifications {
      ...FaxResponseVerificationResultFields
    }
    studyState
  }
}
    ${LabRequirementFragmentDoc}
${FullObservationFragmentDoc}
${FaxResponseVerificationResultFieldsFragmentDoc}`;

export function useGetStudyTrackingQuery(options: Omit<Urql.UseQueryArgs<GetStudyTrackingQueryVariables>, 'query'>) {
  return Urql.useQuery<GetStudyTrackingQuery, GetStudyTrackingQueryVariables>({ query: GetStudyTrackingDocument, ...options });
};
export const GetOrganizationsAndSurgeonsDocument = gql`
    query getOrganizationsAndSurgeons {
  organizations {
    id
    name
    users(role: SURGEON) {
      id
      firstName
      lastName
      role
    }
  }
}
    `;

export function useGetOrganizationsAndSurgeonsQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationsAndSurgeonsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationsAndSurgeonsQuery, GetOrganizationsAndSurgeonsQueryVariables>({ query: GetOrganizationsAndSurgeonsDocument, ...options });
};
export const GetLabRequirementsForOrgDocument = gql`
    query getLabRequirementsForOrg($targetId: ID!, $includeDeleted: Boolean!) {
  labRequirementsByTargetId(
    targetId: $targetId
    options: {includeDeleted: $includeDeleted}
  ) {
    ...LabRequirement
    labRequirements {
      ...LabRequirement
    }
  }
  orchestraLabRequirements {
    ...LabRequirement
    labRequirements {
      ...LabRequirement
    }
  }
}
    ${LabRequirementFragmentDoc}`;

export function useGetLabRequirementsForOrgQuery(options: Omit<Urql.UseQueryArgs<GetLabRequirementsForOrgQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLabRequirementsForOrgQuery, GetLabRequirementsForOrgQueryVariables>({ query: GetLabRequirementsForOrgDocument, ...options });
};
export const UpsertObservationsDocument = gql`
    mutation upsertObservations($observations: [UpsertObservation]!) {
  observation {
    upsertObservations(observations: $observations) {
      id
      effectiveDate
      system
      code
      description
      value
      unit
      createdBy
      overruledBy
      overruledType
      pageStart
      pageEnd
      observations {
        id
        effectiveDate
        system
        code
        description
        value
        unit
        createdBy
        overruledBy
        overruledType
        pageStart
        pageEnd
      }
    }
  }
}
    `;

export function useUpsertObservationsMutation() {
  return Urql.useMutation<UpsertObservationsMutation, UpsertObservationsMutationVariables>(UpsertObservationsDocument);
};
export const UpsertLabRequirementDocument = gql`
    mutation upsertLabRequirement($requirement: UpsertRequirement!) {
  labRequirement {
    upsertLabRequirement(requirement: $requirement) {
      id
      name
      targetType
      targetId
      code
      frequency
      thresholdLow
      thresholdHigh
      thresholdOutOfRangeLow
      thresholdOutOfRangeHigh
      effectiveDuration
      requirementId
      deletedAt
      labRequirements {
        id
        name
        targetType
        targetId
        code
        frequency
        thresholdLow
        thresholdHigh
        thresholdOutOfRangeLow
        thresholdOutOfRangeHigh
        deletedAt
      }
    }
  }
}
    `;

export function useUpsertLabRequirementMutation() {
  return Urql.useMutation<UpsertLabRequirementMutation, UpsertLabRequirementMutationVariables>(UpsertLabRequirementDocument);
};
export const GetOrganizationSchedulingFeatureDocument = gql`
    query getOrganizationSchedulingFeature {
  organization {
    features {
      scheduling
    }
  }
}
    `;

export function useGetOrganizationSchedulingFeatureQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationSchedulingFeatureQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationSchedulingFeatureQuery, GetOrganizationSchedulingFeatureQueryVariables>({ query: GetOrganizationSchedulingFeatureDocument, ...options });
};
export const GetImpersonatorDocument = gql`
    query getImpersonator {
  user {
    id
    fullName
  }
  impersonator {
    id
    fullName
    email
  }
}
    `;

export function useGetImpersonatorQuery(options?: Omit<Urql.UseQueryArgs<GetImpersonatorQueryVariables>, 'query'>) {
  return Urql.useQuery<GetImpersonatorQuery, GetImpersonatorQueryVariables>({ query: GetImpersonatorDocument, ...options });
};
export const GetMedicationDocument = gql`
    query getMedication($medicationId: MedicationId!) {
  medication(medicationId: $medicationId) {
    ...Medication
  }
}
    ${MedicationFragmentDoc}`;

export function useGetMedicationQuery(options: Omit<Urql.UseQueryArgs<GetMedicationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMedicationQuery, GetMedicationQueryVariables>({ query: GetMedicationDocument, ...options });
};
export const GetPatientMedicationsDocument = gql`
    query getPatientMedications($patientId: ID!) {
  patient(id: $patientId) {
    firstName
    lastName
    medications {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useGetPatientMedicationsQuery(options: Omit<Urql.UseQueryArgs<GetPatientMedicationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientMedicationsQuery, GetPatientMedicationsQueryVariables>({ query: GetPatientMedicationsDocument, ...options });
};
export const GetMedicationReconciliationWorkspaceDocument = gql`
    query getMedicationReconciliationWorkspace($patientId: ID!, $patientMedicationId: PatientId!, $eventContextId: String!) {
  patient(id: $patientId) {
    firstName
    lastName
  }
  patientMedications(patientId: $patientMedicationId) {
    ...Medication
  }
  events(type: PATIENT, eventContextId: $eventContextId) {
    occurredAt
    eventType
    actor {
      firstName
      lastName
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useGetMedicationReconciliationWorkspaceQuery(options: Omit<Urql.UseQueryArgs<GetMedicationReconciliationWorkspaceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMedicationReconciliationWorkspaceQuery, GetMedicationReconciliationWorkspaceQueryVariables>({ query: GetMedicationReconciliationWorkspaceDocument, ...options });
};
export const GetPatientMedicationInstructionsDocument = gql`
    query getPatientMedicationInstructions($patientId: PatientId!) {
  patientMedicationInstructions(patientId: $patientId) {
    id
    name
    description
    type
  }
}
    `;

export function useGetPatientMedicationInstructionsQuery(options: Omit<Urql.UseQueryArgs<GetPatientMedicationInstructionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientMedicationInstructionsQuery, GetPatientMedicationInstructionsQueryVariables>({ query: GetPatientMedicationInstructionsDocument, ...options });
};
export const SearchMedicationsDocument = gql`
    query searchMedications($search: String!) {
  medicationSearch(search: $search) {
    displayName
    primaryCode
    primarySystem
    foreignId
  }
}
    `;

export function useSearchMedicationsQuery(options: Omit<Urql.UseQueryArgs<SearchMedicationsQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchMedicationsQuery, SearchMedicationsQueryVariables>({ query: SearchMedicationsDocument, ...options });
};
export const MedicationTriageAnalysisDocument = gql`
    mutation medicationTriageAnalysis($patientId: PatientId!) {
  medication {
    medicationTriageAnalysis(patientId: $patientId) {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useMedicationTriageAnalysisMutation() {
  return Urql.useMutation<MedicationTriageAnalysisMutation, MedicationTriageAnalysisMutationVariables>(MedicationTriageAnalysisDocument);
};
export const CreateMedicationDocument = gql`
    mutation createMedication($medication: CreateMedication!) {
  medication {
    createMedication(medication: $medication) {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useCreateMedicationMutation() {
  return Urql.useMutation<CreateMedicationMutation, CreateMedicationMutationVariables>(CreateMedicationDocument);
};
export const UpdateMedicationDocument = gql`
    mutation updateMedication($medication: UpdateMedication!) {
  medication {
    updateMedication(medication: $medication) {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useUpdateMedicationMutation() {
  return Urql.useMutation<UpdateMedicationMutation, UpdateMedicationMutationVariables>(UpdateMedicationDocument);
};
export const DeleteMedicationDocument = gql`
    mutation deleteMedication($medicationId: MedicationId!) {
  medication {
    deleteMedication(medicationId: $medicationId) {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useDeleteMedicationMutation() {
  return Urql.useMutation<DeleteMedicationMutation, DeleteMedicationMutationVariables>(DeleteMedicationDocument);
};
export const ClearMedicationsDocument = gql`
    mutation clearMedications($medicationIds: [MedicationId!]!) {
  medication {
    clearMedications(medicationIds: $medicationIds) {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useClearMedicationsMutation() {
  return Urql.useMutation<ClearMedicationsMutation, ClearMedicationsMutationVariables>(ClearMedicationsDocument);
};
export const ReconcileMedicationsDocument = gql`
    mutation reconcileMedications($medicationIds: [MedicationId!]!, $patientId: PatientId!) {
  medication {
    reconcileMedications(medicationIds: $medicationIds, patientId: $patientId) {
      ...Medication
    }
  }
}
    ${MedicationFragmentDoc}`;

export function useReconcileMedicationsMutation() {
  return Urql.useMutation<ReconcileMedicationsMutation, ReconcileMedicationsMutationVariables>(ReconcileMedicationsDocument);
};
export const GetOperatingFacilitiesDocument = gql`
    query getOperatingFacilities {
  organizations(type: OPERATING_FACILITY) {
    id
    name
    specialty
  }
}
    `;

export function useGetOperatingFacilitiesQuery(options?: Omit<Urql.UseQueryArgs<GetOperatingFacilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOperatingFacilitiesQuery, GetOperatingFacilitiesQueryVariables>({ query: GetOperatingFacilitiesDocument, ...options });
};
export const GetSurgicalOrganizationsDocument = gql`
    query getSurgicalOrganizations {
  organizations(type: SURGICAL) {
    id
    name
    specialty
  }
}
    `;

export function useGetSurgicalOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<GetSurgicalOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgicalOrganizationsQuery, GetSurgicalOrganizationsQueryVariables>({ query: GetSurgicalOrganizationsDocument, ...options });
};
export const CreateNewSurgicalOrganizationDocument = gql`
    mutation createNewSurgicalOrganization($addOrganization: AddOrganizationInput!) {
  orchestraOperations {
    addOrganization(addOrganization: $addOrganization) {
      id
      name
      specialty
    }
  }
}
    `;

export function useCreateNewSurgicalOrganizationMutation() {
  return Urql.useMutation<CreateNewSurgicalOrganizationMutation, CreateNewSurgicalOrganizationMutationVariables>(CreateNewSurgicalOrganizationDocument);
};
export const CreateNewFacilityDocument = gql`
    mutation createNewFacility($addFacility: AddFacilityInput!) {
  orchestraOperations {
    addFacility(addFacility: $addFacility) {
      id
      name
      network
      specialty
    }
  }
}
    `;

export function useCreateNewFacilityMutation() {
  return Urql.useMutation<CreateNewFacilityMutation, CreateNewFacilityMutationVariables>(CreateNewFacilityDocument);
};
export const GetSurgeonsDocument = gql`
    query getSurgeons {
  users(role: SURGEON) {
    id
    organizationId
    firstName
    lastName
  }
}
    `;

export function useGetSurgeonsQuery(options?: Omit<Urql.UseQueryArgs<GetSurgeonsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeonsQuery, GetSurgeonsQueryVariables>({ query: GetSurgeonsDocument, ...options });
};
export const GetRelatedSurgeonsDocument = gql`
    query getRelatedSurgeons {
  organization {
    relatedUsers(role: SURGEON) {
      id
      organizationId
      firstName
      lastName
    }
  }
}
    `;

export function useGetRelatedSurgeonsQuery(options?: Omit<Urql.UseQueryArgs<GetRelatedSurgeonsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRelatedSurgeonsQuery, GetRelatedSurgeonsQueryVariables>({ query: GetRelatedSurgeonsDocument, ...options });
};
export const GetPatientFromMedicalRecordNumberDocument = gql`
    query getPatientFromMedicalRecordNumber($medicalRecordNumber: String!) {
  getPatientFromMedicalRecordNumber(medicalRecordNumber: $medicalRecordNumber) {
    id
    firstName
    lastName
    birthSex
    phone
    phoneType
    email
    dob
    addressId
    address {
      id
      address1
      address2
      city
      state
      zip
    }
    upcomingSurgery {
      id
      dateOfService
      url
      surgeonName
      surgeryType
      workflow
      facility {
        id
        name
      }
    }
  }
}
    `;

export function useGetPatientFromMedicalRecordNumberQuery(options: Omit<Urql.UseQueryArgs<GetPatientFromMedicalRecordNumberQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientFromMedicalRecordNumberQuery, GetPatientFromMedicalRecordNumberQueryVariables>({ query: GetPatientFromMedicalRecordNumberDocument, ...options });
};
export const InviteUserForOrganizationDocument = gql`
    mutation inviteUserForOrganization($inviteUser: AddUserForOrganizationInput!) {
  orchestraOperations {
    inviteUserForOrganization(inviteUser: $inviteUser) {
      id
    }
  }
}
    `;

export function useInviteUserForOrganizationMutation() {
  return Urql.useMutation<InviteUserForOrganizationMutation, InviteUserForOrganizationMutationVariables>(InviteUserForOrganizationDocument);
};
export const TranslateMessageDocument = gql`
    query translateMessage($message: String!, $language: String!, $patientId: PatientId!) {
  translation(message: $message, language: $language, patientId: $patientId)
}
    `;

export function useTranslateMessageQuery(options: Omit<Urql.UseQueryArgs<TranslateMessageQueryVariables>, 'query'>) {
  return Urql.useQuery<TranslateMessageQuery, TranslateMessageQueryVariables>({ query: TranslateMessageDocument, ...options });
};
export const GetSurgeryMessagesDocument = gql`
    query getSurgeryMessages($surgeryId: SurgeryId!, $filter: MessageFilter) {
  surgery(id: $surgeryId) {
    id
    messages(filter: $filter) {
      ...MessageItem
    }
  }
}
    ${MessageItemFragmentDoc}`;

export function useGetSurgeryMessagesQuery(options: Omit<Urql.UseQueryArgs<GetSurgeryMessagesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeryMessagesQuery, GetSurgeryMessagesQueryVariables>({ query: GetSurgeryMessagesDocument, ...options });
};
export const UpdateMessageRecordDocument = gql`
    mutation updateMessageRecord($id: MessageId!, $translation: String!, $surgeryId: SurgeryId!) {
  internalSurgery {
    updateMessage(id: $id, translation: $translation) {
      surgery(id: $surgeryId) {
        messages {
          ...MessageItem
        }
      }
    }
  }
}
    ${MessageItemFragmentDoc}`;

export function useUpdateMessageRecordMutation() {
  return Urql.useMutation<UpdateMessageRecordMutation, UpdateMessageRecordMutationVariables>(UpdateMessageRecordDocument);
};
export const SendMessageToPatientDocument = gql`
    mutation sendMessageToPatient($surgeryId: SurgeryId!, $patientId: ID!, $message: String!, $translation: String) {
  internalSurgery {
    sendMessage(patientId: $patientId, message: $message, translation: $translation) {
      surgery(id: $surgeryId) {
        messages {
          ...MessageItem
        }
      }
    }
  }
}
    ${MessageItemFragmentDoc}`;

export function useSendMessageToPatientMutation() {
  return Urql.useMutation<SendMessageToPatientMutation, SendMessageToPatientMutationVariables>(SendMessageToPatientDocument);
};
export const OnPatientMessageDocument = gql`
    subscription onPatientMessage($patientId: PatientId) {
  patientSMSMessage(id: $patientId) {
    ...MessageItem
  }
}
    ${MessageItemFragmentDoc}`;

export function useOnPatientMessageSubscription<TData = OnPatientMessageSubscription>(options: Omit<Urql.UseSubscriptionArgs<OnPatientMessageSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<OnPatientMessageSubscription, TData>) {
  return Urql.useSubscription<OnPatientMessageSubscription, TData, OnPatientMessageSubscriptionVariables>({ query: OnPatientMessageDocument, ...options }, handler);
};
export const GetProcessTrackerDocument = gql`
    query getProcessTracker($surgeryId: SurgeryId!) {
  processTracker(surgeryId: $surgeryId) {
    steps {
      id
      key
      label
      status
      displayOrder
      notes
      lastTransitionAt
      lastTransitionBy
      transitionType
      isVirtual
    }
    total
    completed
    inProgress
    todo
  }
}
    `;

export function useGetProcessTrackerQuery(options: Omit<Urql.UseQueryArgs<GetProcessTrackerQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProcessTrackerQuery, GetProcessTrackerQueryVariables>({ query: GetProcessTrackerDocument, ...options });
};
export const CreateProcessStepStateDocument = gql`
    mutation createProcessStepState($createStepState: CreateProcessStepState!) {
  processStep {
    createProcessStepState(createStepState: $createStepState) {
      ...ProcessStepState
    }
  }
}
    ${ProcessStepStateFragmentDoc}`;

export function useCreateProcessStepStateMutation() {
  return Urql.useMutation<CreateProcessStepStateMutation, CreateProcessStepStateMutationVariables>(CreateProcessStepStateDocument);
};
export const UpdateProcessStepStateDocument = gql`
    mutation updateProcessStepState($updateStepState: UpdateProcessStepState!) {
  processStep {
    updateProcessStepState(updateStepState: $updateStepState) {
      ...ProcessStepState
    }
  }
}
    ${ProcessStepStateFragmentDoc}`;

export function useUpdateProcessStepStateMutation() {
  return Urql.useMutation<UpdateProcessStepStateMutation, UpdateProcessStepStateMutationVariables>(UpdateProcessStepStateDocument);
};
export const UpdateDateOfServiceDocument = gql`
    mutation updateDateOfService($surgery: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $surgery) {
      id
      dateOfService
      assessment {
        id
        intakeRiskAssessment
      }
    }
  }
}
    `;

export function useUpdateDateOfServiceMutation() {
  return Urql.useMutation<UpdateDateOfServiceMutation, UpdateDateOfServiceMutationVariables>(UpdateDateOfServiceDocument);
};
export const GetSurgeonsForOrganizationDocument = gql`
    query getSurgeonsForOrganization($organizationId: ID) {
  organization(id: $organizationId) {
    users(role: SURGEON) {
      id
      firstName
      lastName
    }
  }
}
    `;

export function useGetSurgeonsForOrganizationQuery(options?: Omit<Urql.UseQueryArgs<GetSurgeonsForOrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeonsForOrganizationQuery, GetSurgeonsForOrganizationQueryVariables>({ query: GetSurgeonsForOrganizationDocument, ...options });
};
export const SendIntakeQuestionnaireDocument = gql`
    mutation sendIntakeQuestionnaire($surgeryId: SurgeryId!) {
  internalSurgery {
    sendIntakeQuestionnaire(surgeryId: $surgeryId) {
      ping
    }
  }
}
    `;

export function useSendIntakeQuestionnaireMutation() {
  return Urql.useMutation<SendIntakeQuestionnaireMutation, SendIntakeQuestionnaireMutationVariables>(SendIntakeQuestionnaireDocument);
};
export const ConfirmUpdateCoverageDocument = gql`
    mutation confirmUpdateCoverage($patient: ID!, $surgery: SurgeryId!) {
  internalSurgery {
    sendUpdateCoverageInstructions(patient: $patient) {
      surgery(id: $surgery) {
        messages {
          id
          status
          timestamp
          content
          authorName
        }
      }
    }
  }
}
    `;

export function useConfirmUpdateCoverageMutation() {
  return Urql.useMutation<ConfirmUpdateCoverageMutation, ConfirmUpdateCoverageMutationVariables>(ConfirmUpdateCoverageDocument);
};
export const GetSurgeryThreadIdDocument = gql`
    query getSurgeryThreadId($id: SurgeryId!) {
  surgery(id: $id) {
    id
    threadId
  }
}
    `;

export function useGetSurgeryThreadIdQuery(options: Omit<Urql.UseQueryArgs<GetSurgeryThreadIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSurgeryThreadIdQuery, GetSurgeryThreadIdQueryVariables>({ query: GetSurgeryThreadIdDocument, ...options });
};
export const GetPlatformSurgeryMessagesDocument = gql`
    query getPlatformSurgeryMessages($id: SurgeryId!) {
  surgery(id: $id) {
    id
    platformMessages {
      ...InAppSurgeryPlatformMessage
    }
  }
}
    ${InAppSurgeryPlatformMessageFragmentDoc}`;

export function useGetPlatformSurgeryMessagesQuery(options: Omit<Urql.UseQueryArgs<GetPlatformSurgeryMessagesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPlatformSurgeryMessagesQuery, GetPlatformSurgeryMessagesQueryVariables>({ query: GetPlatformSurgeryMessagesDocument, ...options });
};
export const SendSurgeryMessageDocument = gql`
    mutation sendSurgeryMessage($surgeryId: SurgeryId!, $content: String!) {
  provider {
    sendSurgeryMessage(surgeryId: $surgeryId, content: $content) {
      ...InAppSurgeryPlatformMessage
    }
  }
}
    ${InAppSurgeryPlatformMessageFragmentDoc}`;

export function useSendSurgeryMessageMutation() {
  return Urql.useMutation<SendSurgeryMessageMutation, SendSurgeryMessageMutationVariables>(SendSurgeryMessageDocument);
};
export const ListenForMessageThreadDocument = gql`
    subscription listenForMessageThread($threadId: PlatformThreadId) {
  platformMessage(threadId: $threadId) {
    ...InAppSurgeryPlatformMessage
  }
}
    ${InAppSurgeryPlatformMessageFragmentDoc}`;

export function useListenForMessageThreadSubscription<TData = ListenForMessageThreadSubscription>(options: Omit<Urql.UseSubscriptionArgs<ListenForMessageThreadSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<ListenForMessageThreadSubscription, TData>) {
  return Urql.useSubscription<ListenForMessageThreadSubscription, TData, ListenForMessageThreadSubscriptionVariables>({ query: ListenForMessageThreadDocument, ...options }, handler);
};
export const UpdateReadReceiptDocument = gql`
    mutation updateReadReceipt($platformThreadId: PlatformThreadId!, $surgeryId: SurgeryId!) {
  provider {
    updateLastMessageRead(platformThreadId: $platformThreadId) {
      surgery(id: $surgeryId) {
        id
        unreadPlatformMessages
      }
    }
  }
}
    `;

export function useUpdateReadReceiptMutation() {
  return Urql.useMutation<UpdateReadReceiptMutation, UpdateReadReceiptMutationVariables>(UpdateReadReceiptDocument);
};
export const GetProviderUploadDocument = gql`
    mutation GetProviderUpload($patientId: ID!, $files: [FileCandidate!]!, $surgeryId: SurgeryId) {
  provider {
    generateS3Files(patientId: $patientId, files: $files, surgeryId: $surgeryId) {
      id
      createdAt
      updatedAt
      status
      name
      type
      url
    }
  }
}
    `;

export function useGetProviderUploadMutation() {
  return Urql.useMutation<GetProviderUploadMutation, GetProviderUploadMutationVariables>(GetProviderUploadDocument);
};
export const GetAvailableFacilitiesDocument = gql`
    query getAvailableFacilities {
  facilities {
    ...AvailableFacility
  }
}
    ${AvailableFacilityFragmentDoc}`;

export function useGetAvailableFacilitiesQuery(options?: Omit<Urql.UseQueryArgs<GetAvailableFacilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailableFacilitiesQuery, GetAvailableFacilitiesQueryVariables>({ query: GetAvailableFacilitiesDocument, ...options });
};
export const GetFullSurgeryDocument = gql`
    query getFullSurgery($surgeryId: SurgeryId!) {
  surgery(id: $surgeryId, options: {includeArchived: true}) {
    ...FullSurgeryResponse
  }
}
    ${FullSurgeryResponseFragmentDoc}`;

export function useGetFullSurgeryQuery(options: Omit<Urql.UseQueryArgs<GetFullSurgeryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFullSurgeryQuery, GetFullSurgeryQueryVariables>({ query: GetFullSurgeryDocument, ...options });
};
export const UpdateNotesDocument = gql`
    mutation updateNotes($surgeryId: SurgeryId!, $notes: String!) {
  internalSurgery {
    updateNotes(surgeryId: $surgeryId, notes: $notes) {
      id
      notes
    }
  }
}
    `;

export function useUpdateNotesMutation() {
  return Urql.useMutation<UpdateNotesMutation, UpdateNotesMutationVariables>(UpdateNotesDocument);
};
export const UpdateExternalNoteDocument = gql`
    mutation updateExternalNote($surgeryId: SurgeryId!, $notes: String!) {
  internalSurgery {
    updateExternalNote(surgeryId: $surgeryId, notes: $notes) {
      id
      externalNotes
    }
  }
}
    `;

export function useUpdateExternalNoteMutation() {
  return Urql.useMutation<UpdateExternalNoteMutation, UpdateExternalNoteMutationVariables>(UpdateExternalNoteDocument);
};
export const UpdateSurgeryTypeDocument = gql`
    mutation updateSurgeryType($surgery: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $surgery) {
      id
      surgeryType
    }
  }
}
    `;

export function useUpdateSurgeryTypeMutation() {
  return Urql.useMutation<UpdateSurgeryTypeMutation, UpdateSurgeryTypeMutationVariables>(UpdateSurgeryTypeDocument);
};
export const UpdateSurgeryFacilityDocument = gql`
    mutation updateSurgeryFacility($surgery: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $surgery) {
      id
      facilityId
      facility {
        id
        name
        network
      }
    }
  }
}
    `;

export function useUpdateSurgeryFacilityMutation() {
  return Urql.useMutation<UpdateSurgeryFacilityMutation, UpdateSurgeryFacilityMutationVariables>(UpdateSurgeryFacilityDocument);
};
export const UpdateClearanceDocumentsSentDocument = gql`
    mutation updateClearanceDocumentsSent($surgery: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $surgery) {
      id
      clearanceDocumentsSent
      clearanceDocumentsSentAt
    }
  }
}
    `;

export function useUpdateClearanceDocumentsSentMutation() {
  return Urql.useMutation<UpdateClearanceDocumentsSentMutation, UpdateClearanceDocumentsSentMutationVariables>(UpdateClearanceDocumentsSentDocument);
};
export const UpdatePatientInfoDocument = gql`
    mutation updatePatientInfo($patient: UpdatePatientInput!) {
  provider {
    updatePatient(patient: $patient) {
      id
      firstName
      lastName
      email
      phone
      phoneType
      dob
      birthSex
      address {
        ...FullAddress
      }
    }
  }
}
    ${FullAddressFragmentDoc}`;

export function useUpdatePatientInfoMutation() {
  return Urql.useMutation<UpdatePatientInfoMutation, UpdatePatientInfoMutationVariables>(UpdatePatientInfoDocument);
};
export const UpdateSurgeryArchivedStatusDocument = gql`
    mutation UpdateSurgeryArchivedStatus($input: UpdateSurgeryArchivedInput!) {
  provider {
    updateSurgeryArchivedStatus(updateSurgery: $input) {
      id
      archived
    }
  }
}
    `;

export function useUpdateSurgeryArchivedStatusMutation() {
  return Urql.useMutation<UpdateSurgeryArchivedStatusMutation, UpdateSurgeryArchivedStatusMutationVariables>(UpdateSurgeryArchivedStatusDocument);
};
export const GetPatientIntakeUrlDocument = gql`
    query getPatientIntakeUrl($surgeryId: SurgeryId) {
  getPatientIntakeUrl(surgeryId: $surgeryId)
}
    `;

export function useGetPatientIntakeUrlQuery(options?: Omit<Urql.UseQueryArgs<GetPatientIntakeUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientIntakeUrlQuery, GetPatientIntakeUrlQueryVariables>({ query: GetPatientIntakeUrlDocument, ...options });
};
export const GetOpsPatientIntakeUrlDocument = gql`
    query getOpsPatientIntakeUrl($surgeryId: SurgeryId) {
  getOpsPatientIntakeUrl(surgeryId: $surgeryId)
}
    `;

export function useGetOpsPatientIntakeUrlQuery(options?: Omit<Urql.UseQueryArgs<GetOpsPatientIntakeUrlQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOpsPatientIntakeUrlQuery, GetOpsPatientIntakeUrlQueryVariables>({ query: GetOpsPatientIntakeUrlDocument, ...options });
};
export const GetOpenLoopViabilityStatusDocument = gql`
    query getOpenLoopViabilityStatus($surgeryId: SurgeryId!) {
  getOpenLoopViabilityStatus(surgeryId: $surgeryId) {
    isViable
    reason
  }
}
    `;

export function useGetOpenLoopViabilityStatusQuery(options: Omit<Urql.UseQueryArgs<GetOpenLoopViabilityStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOpenLoopViabilityStatusQuery, GetOpenLoopViabilityStatusQueryVariables>({ query: GetOpenLoopViabilityStatusDocument, ...options });
};
export const GetOpenLoopPrivateNoteEditLinkDocument = gql`
    query getOpenLoopPrivateNoteEditLink($surgeryId: SurgeryId!) {
  getOpenLoopPrivateNoteEditLink(surgeryId: $surgeryId)
}
    `;

export function useGetOpenLoopPrivateNoteEditLinkQuery(options: Omit<Urql.UseQueryArgs<GetOpenLoopPrivateNoteEditLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOpenLoopPrivateNoteEditLinkQuery, GetOpenLoopPrivateNoteEditLinkQueryVariables>({ query: GetOpenLoopPrivateNoteEditLinkDocument, ...options });
};
export const GetBridgeNoteReviewLinkDocument = gql`
    query getBridgeNoteReviewLink($surgeryId: SurgeryId!) {
  getOpenLoopPreChartV2ShadowNoteEditLink(surgeryId: $surgeryId)
}
    `;

export function useGetBridgeNoteReviewLinkQuery(options: Omit<Urql.UseQueryArgs<GetBridgeNoteReviewLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBridgeNoteReviewLinkQuery, GetBridgeNoteReviewLinkQueryVariables>({ query: GetBridgeNoteReviewLinkDocument, ...options });
};
export const GetClinicalReviewCodingCopyDocument = gql`
    query getClinicalReviewCodingCopy($surgeryId: SurgeryId!) {
  getClinicalReviewCodingCopy(surgeryId: $surgeryId)
}
    `;

export function useGetClinicalReviewCodingCopyQuery(options: Omit<Urql.UseQueryArgs<GetClinicalReviewCodingCopyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetClinicalReviewCodingCopyQuery, GetClinicalReviewCodingCopyQueryVariables>({ query: GetClinicalReviewCodingCopyDocument, ...options });
};
export const GetHiePullStatusDocument = gql`
    query getHiePullStatus($patientId: PatientId!) {
  hiePullStatus(patientId: $patientId) {
    ...HieJob
  }
}
    ${HieJobFragmentDoc}`;

export function useGetHiePullStatusQuery(options: Omit<Urql.UseQueryArgs<GetHiePullStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetHiePullStatusQuery, GetHiePullStatusQueryVariables>({ query: GetHiePullStatusDocument, ...options });
};
export const LogPhoneCallDocument = gql`
    mutation logPhoneCall($surgeryId: SurgeryId!, $description: String!) {
  providerOperations {
    logEvent(
      eventInput: {event: PHONE_CALL_MADE, surgeryId: $surgeryId, description: $description}
    ) {
      ping
    }
  }
}
    `;

export function useLogPhoneCallMutation() {
  return Urql.useMutation<LogPhoneCallMutation, LogPhoneCallMutationVariables>(LogPhoneCallDocument);
};
export const GetUsersResponsibleForSurgeryDocument = gql`
    query getUsersResponsibleForSurgery($surgeryId: SurgeryId!) {
  usersResponsibleForSurgery(surgeryId: $surgeryId) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;

export function useGetUsersResponsibleForSurgeryQuery(options: Omit<Urql.UseQueryArgs<GetUsersResponsibleForSurgeryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersResponsibleForSurgeryQuery, GetUsersResponsibleForSurgeryQueryVariables>({ query: GetUsersResponsibleForSurgeryDocument, ...options });
};
export const UpdateRoleAssignmentDocument = gql`
    mutation updateRoleAssignment($roleAssignment: UpdateRoleAssignment!) {
  roleAssignment {
    updateRole(roleAssignment: $roleAssignment) {
      id
      targetId
      targetType
      userId
      role
      isPrimary
      isAvailable
    }
  }
}
    `;

export function useUpdateRoleAssignmentMutation() {
  return Urql.useMutation<UpdateRoleAssignmentMutation, UpdateRoleAssignmentMutationVariables>(UpdateRoleAssignmentDocument);
};
export const CreateRoleAssignmentDocument = gql`
    mutation createRoleAssignment($roleAssignment: InsertRoleAssignment!) {
  roleAssignment {
    insertRole(roleAssignment: $roleAssignment) {
      id
      targetId
      targetType
      userId
      role
      isPrimary
      isAvailable
    }
  }
}
    `;

export function useCreateRoleAssignmentMutation() {
  return Urql.useMutation<CreateRoleAssignmentMutation, CreateRoleAssignmentMutationVariables>(CreateRoleAssignmentDocument);
};
export const SendPreopPacketDocument = gql`
    mutation sendPreopPacket($roleIds: [RoleAssignmentId!]!, $surgeryId: SurgeryId!) {
  roleAssignment {
    sendPreopPacket(roleIds: $roleIds, surgeryId: $surgeryId)
  }
}
    `;

export function useSendPreopPacketMutation() {
  return Urql.useMutation<SendPreopPacketMutation, SendPreopPacketMutationVariables>(SendPreopPacketDocument);
};
export const UpdateSurgeryWorkflowDocument = gql`
    mutation updateSurgeryWorkflow($input: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $input) {
      id
      workflow
    }
  }
}
    `;

export function useUpdateSurgeryWorkflowMutation() {
  return Urql.useMutation<UpdateSurgeryWorkflowMutation, UpdateSurgeryWorkflowMutationVariables>(UpdateSurgeryWorkflowDocument);
};
export const AddSurgeryForOrganizationDocument = gql`
    mutation addSurgeryForOrganization($surgery: SurgeryInput!) {
  provider {
    registerSurgery(surgery: $surgery) {
      id
      surgeonId
      surgeonName
      surgeryType
      dateOfService
      patientId
      facilityId
    }
  }
}
    `;

export function useAddSurgeryForOrganizationMutation() {
  return Urql.useMutation<AddSurgeryForOrganizationMutation, AddSurgeryForOrganizationMutationVariables>(AddSurgeryForOrganizationDocument);
};
export const InviteUserDocument = gql`
    mutation inviteUser($user: UserInput!) {
  provider {
    inviteUser(user: $user) {
      organization {
        users {
          ...FullUser
        }
      }
    }
  }
}
    ${FullUserFragmentDoc}`;

export function useInviteUserMutation() {
  return Urql.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument);
};
export const EditUserDocument = gql`
    mutation editUser($user: EditUserInput!) {
  provider {
    editUserInfo(user: $user) {
      ...FullUser
    }
  }
}
    ${FullUserFragmentDoc}`;

export function useEditUserMutation() {
  return Urql.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument);
};
export const GetUserToEditDocument = gql`
    query getUserToEdit($id: UserId) {
  user(id: $id) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;

export function useGetUserToEditQuery(options?: Omit<Urql.UseQueryArgs<GetUserToEditQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserToEditQuery, GetUserToEditQueryVariables>({ query: GetUserToEditDocument, ...options });
};
export const ReplaceSurgeonDocument = gql`
    mutation replaceSurgeon($surgeryId: SurgeryId!, $organizationId: ID!) {
  internalSurgery {
    replacePrimaryOrganization(
      surgeryId: $surgeryId
      organizationId: $organizationId
    ) {
      id
      stakeholders {
        id
        name
        specialty
      }
    }
  }
}
    `;

export function useReplaceSurgeonMutation() {
  return Urql.useMutation<ReplaceSurgeonMutation, ReplaceSurgeonMutationVariables>(ReplaceSurgeonDocument);
};
export const UpdateSurgeonDocument = gql`
    mutation updateSurgeon($surgery: UpdateSurgeryInput!) {
  provider {
    updateSurgery(surgery: $surgery) {
      id
      surgeonId
      surgeon {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

export function useUpdateSurgeonMutation() {
  return Urql.useMutation<UpdateSurgeonMutation, UpdateSurgeonMutationVariables>(UpdateSurgeonDocument);
};
export const GetRedFlagsDocument = gql`
    query getRedFlags($patientId: PatientId!) {
  aiAssessment(patientId: $patientId) {
    redFlags {
      id
      category
      text
      fileName
      documentId
      documentUrl
      noteDate
      evidenceDate
      evidenceType
      evidenceValue
      observationCodes
    }
  }
}
    `;

export function useGetRedFlagsQuery(options: Omit<Urql.UseQueryArgs<GetRedFlagsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRedFlagsQuery, GetRedFlagsQueryVariables>({ query: GetRedFlagsDocument, ...options });
};
export const GetAiRiskAssessmentDocument = gql`
    query getAiRiskAssessment($patientId: PatientId!, $documentId: DocumentId!) {
  aiAssessment(patientId: $patientId) {
    risk(documentId: $documentId) {
      analysis
      synthesis
    }
  }
}
    `;

export function useGetAiRiskAssessmentQuery(options: Omit<Urql.UseQueryArgs<GetAiRiskAssessmentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAiRiskAssessmentQuery, GetAiRiskAssessmentQueryVariables>({ query: GetAiRiskAssessmentDocument, ...options });
};
export const GetAiAssessmentDocIdsDocument = gql`
    query getAiAssessmentDocIds($patientId: PatientId!, $riskDocumentId: DocumentId, $preChartDocumentId: DocumentId) {
  aiAssessment(patientId: $patientId) {
    allAssessmentDocIds(
      riskDocumentId: $riskDocumentId
      preChartDocumentId: $preChartDocumentId
    )
  }
}
    `;

export function useGetAiAssessmentDocIdsQuery(options: Omit<Urql.UseQueryArgs<GetAiAssessmentDocIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAiAssessmentDocIdsQuery, GetAiAssessmentDocIdsQueryVariables>({ query: GetAiAssessmentDocIdsDocument, ...options });
};
export const AiRiskAssessmentDocument = gql`
    mutation aiRiskAssessment($surgeryId: SurgeryId!, $refresh: Boolean) {
  riskAssessment {
    aiRiskAssessment(surgeryId: $surgeryId, refresh: $refresh)
  }
}
    `;

export function useAiRiskAssessmentMutation() {
  return Urql.useMutation<AiRiskAssessmentMutation, AiRiskAssessmentMutationVariables>(AiRiskAssessmentDocument);
};
export const TriageDocumentsDocument = gql`
    mutation triageDocuments($documentIds: [DocumentId!]!) {
  riskAssessment {
    triageDocuments(documentIds: $documentIds) {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;

export function useTriageDocumentsMutation() {
  return Urql.useMutation<TriageDocumentsMutation, TriageDocumentsMutationVariables>(TriageDocumentsDocument);
};
export const AiPreChartDocument = gql`
    mutation aiPreChart($surgeryId: SurgeryId!, $refresh: Boolean) {
  riskAssessment {
    aiPreChart(surgeryId: $surgeryId, refresh: $refresh)
  }
}
    `;

export function useAiPreChartMutation() {
  return Urql.useMutation<AiPreChartMutation, AiPreChartMutationVariables>(AiPreChartDocument);
};
export const PreChartDocumentsDocument = gql`
    mutation preChartDocuments($documentIds: [DocumentId!]!) {
  riskAssessment {
    preChartDocuments(documentIds: $documentIds) {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;

export function usePreChartDocumentsMutation() {
  return Urql.useMutation<PreChartDocumentsMutation, PreChartDocumentsMutationVariables>(PreChartDocumentsDocument);
};
export const GetTaskDocument = gql`
    query getTask($id: TaskId!) {
  task(id: $id) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

export function useGetTaskQuery(options: Omit<Urql.UseQueryArgs<GetTaskQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTaskQuery, GetTaskQueryVariables>({ query: GetTaskDocument, ...options });
};
export const GetTasksDocument = gql`
    query getTasks($options: TaskOptions!) {
  tasks(options: $options) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

export function useGetTasksQuery(options: Omit<Urql.UseQueryArgs<GetTasksQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTasksQuery, GetTasksQueryVariables>({ query: GetTasksDocument, ...options });
};
export const GetTasksPaginatedDocument = gql`
    query getTasksPaginated($options: TaskOptions!, $pageInfo: PageInfoInput!) {
  tasksPaginated(options: $options, pageInfo: $pageInfo) {
    tasks {
      ...Task
    }
    pageInfo {
      pageSize
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${TaskFragmentDoc}`;

export function useGetTasksPaginatedQuery(options: Omit<Urql.UseQueryArgs<GetTasksPaginatedQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTasksPaginatedQuery, GetTasksPaginatedQueryVariables>({ query: GetTasksPaginatedDocument, ...options });
};
export const InsertTaskDocument = gql`
    mutation insertTask($task: InsertTask!) {
  task {
    insertTask(task: $task) {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;

export function useInsertTaskMutation() {
  return Urql.useMutation<InsertTaskMutation, InsertTaskMutationVariables>(InsertTaskDocument);
};
export const MarkTaskViewedDocument = gql`
    mutation markTaskViewed($id: TaskId!) {
  task {
    markTaskViewed(id: $id) {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;

export function useMarkTaskViewedMutation() {
  return Urql.useMutation<MarkTaskViewedMutation, MarkTaskViewedMutationVariables>(MarkTaskViewedDocument);
};
export const UpdateTaskDocument = gql`
    mutation updateTask($task: UpdateTask!) {
  task {
    updateTask(task: $task) {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;

export function useUpdateTaskMutation() {
  return Urql.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument);
};
export const ListenForTaskDocument = gql`
    subscription listenForTask($assigneeId: UserId, $surgeryId: SurgeryId, $organizationId: OrganizationId) {
  task(
    assigneeId: $assigneeId
    surgeryId: $surgeryId
    organizationId: $organizationId
  ) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

export function useListenForTaskSubscription<TData = ListenForTaskSubscription>(options: Omit<Urql.UseSubscriptionArgs<ListenForTaskSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<ListenForTaskSubscription, TData>) {
  return Urql.useSubscription<ListenForTaskSubscription, TData, ListenForTaskSubscriptionVariables>({ query: ListenForTaskDocument, ...options }, handler);
};
export const FindUserDocument = gql`
    query findUser($userId: ID!) {
  ping
}
    `;

export function useFindUserQuery(options: Omit<Urql.UseQueryArgs<FindUserQueryVariables>, 'query'>) {
  return Urql.useQuery<FindUserQuery, FindUserQueryVariables>({ query: FindUserDocument, ...options });
};
export const GetUserByIdDocument = gql`
    query getUserById($id: UserId) {
  user(id: $id) {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;

export function useGetUserByIdQuery(options?: Omit<Urql.UseQueryArgs<GetUserByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>({ query: GetUserByIdDocument, ...options });
};
export const GetUserDocument = gql`
    query getUser {
  user {
    ...FullUser
  }
}
    ${FullUserFragmentDoc}`;

export function useGetUserQuery(options?: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetSessionInfoDocument = gql`
    query getSessionInfo {
  sessionInfo {
    ...IdentifyUserSession
  }
}
    ${IdentifyUserSessionFragmentDoc}`;

export function useGetSessionInfoQuery(options?: Omit<Urql.UseQueryArgs<GetSessionInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSessionInfoQuery, GetSessionInfoQueryVariables>({ query: GetSessionInfoDocument, ...options });
};
export const RequestIngestionUploadUrlDocument = gql`
    mutation requestIngestionUploadUrl($filename: String) {
  providerOperations {
    bulkUpload {
      requestIngestionUploadUrl(filename: $filename) {
        uploadUrl
        sourceBucket
        sourceKey
      }
    }
  }
}
    `;

export function useRequestIngestionUploadUrlMutation() {
  return Urql.useMutation<RequestIngestionUploadUrlMutation, RequestIngestionUploadUrlMutationVariables>(RequestIngestionUploadUrlDocument);
};
export const TransformIngestionUploadDocument = gql`
    mutation transformIngestionUpload($input: TransformIngestionUploadInput!) {
  providerOperations {
    bulkUpload {
      transformIngestionUpload(input: $input) {
        rows
        resultBucket
        resultKey
        totalDataRowCount
      }
    }
  }
}
    `;

export function useTransformIngestionUploadMutation() {
  return Urql.useMutation<TransformIngestionUploadMutation, TransformIngestionUploadMutationVariables>(TransformIngestionUploadDocument);
};
export const CommitIngestionTransformDocument = gql`
    mutation commitIngestionTransform($input: CommitIngestionTransformInput!) {
  providerOperations {
    bulkUpload {
      commitIngestionTransform(input: $input) {
        success
        messages
        jobId
      }
    }
  }
}
    `;

export function useCommitIngestionTransformMutation() {
  return Urql.useMutation<CommitIngestionTransformMutation, CommitIngestionTransformMutationVariables>(CommitIngestionTransformDocument);
};
export const ValidateAndIngestUploadDocument = gql`
    mutation validateAndIngestUpload($input: ValidateAndIngestUploadInput!) {
  providerOperations {
    bulkUpload {
      validateAndIngestUpload(input: $input) {
        success
        messages
        jobId
      }
    }
  }
}
    `;

export function useValidateAndIngestUploadMutation() {
  return Urql.useMutation<ValidateAndIngestUploadMutation, ValidateAndIngestUploadMutationVariables>(ValidateAndIngestUploadDocument);
};
export const BulkUploadIngestionJobDocument = gql`
    query bulkUploadIngestionJob($jobId: ID!) {
  ingestionJob(jobId: $jobId) {
    id
    status
    totalRows
    processedRows
    errorCount
    messages
  }
}
    `;

export function useBulkUploadIngestionJobQuery(options: Omit<Urql.UseQueryArgs<BulkUploadIngestionJobQueryVariables>, 'query'>) {
  return Urql.useQuery<BulkUploadIngestionJobQuery, BulkUploadIngestionJobQueryVariables>({ query: BulkUploadIngestionJobDocument, ...options });
};
export const UpdateDocumentStatusDocument = gql`
    mutation updateDocumentStatus($documentId: DocumentId!, $status: DocumentStatus!) {
  document {
    updateDocumentStatus(documentId: $documentId, status: $status) {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;

export function useUpdateDocumentStatusMutation() {
  return Urql.useMutation<UpdateDocumentStatusMutation, UpdateDocumentStatusMutationVariables>(UpdateDocumentStatusDocument);
};
export const GenerateUploadUrlsDocument = gql`
    mutation generateUploadUrls($fileNames: [String!]!) {
  document {
    generateUploadUrls(fileNames: $fileNames) {
      ...generateUploadUrlFragment
    }
  }
}
    ${GenerateUploadUrlFragmentFragmentDoc}`;

export function useGenerateUploadUrlsMutation() {
  return Urql.useMutation<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>(GenerateUploadUrlsDocument);
};
export const StartOcrAnalysisDocument = gql`
    mutation startOCRAnalysis($documentId: DocumentId!) {
  document {
    startOCRAnalysis(documentId: $documentId) {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;

export function useStartOcrAnalysisMutation() {
  return Urql.useMutation<StartOcrAnalysisMutation, StartOcrAnalysisMutationVariables>(StartOcrAnalysisDocument);
};
export const IngestCanvasDocumentReferenceDocument = gql`
    mutation ingestCanvasDocumentReference($patientId: PatientId!, $documentReferenceId: String, $surgeryId: SurgeryId) {
  document {
    ingestCanvasDocumentReference(
      patientId: $patientId
      documentReferenceId: $documentReferenceId
      surgeryId: $surgeryId
    ) {
      status
      document {
        ...Document
      }
    }
  }
}
    ${DocumentFragmentDoc}`;

export function useIngestCanvasDocumentReferenceMutation() {
  return Urql.useMutation<IngestCanvasDocumentReferenceMutation, IngestCanvasDocumentReferenceMutationVariables>(IngestCanvasDocumentReferenceDocument);
};
export const BrowserNotificationDocument = gql`
    subscription browserNotification($userId: UserId, $organizationId: OrganizationId) {
  browserNotification(userId: $userId, organizationId: $organizationId) {
    id
    date
    title
    body
    url
  }
}
    `;

export function useBrowserNotificationSubscription<TData = BrowserNotificationSubscription>(options: Omit<Urql.UseSubscriptionArgs<BrowserNotificationSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<BrowserNotificationSubscription, TData>) {
  return Urql.useSubscription<BrowserNotificationSubscription, TData, BrowserNotificationSubscriptionVariables>({ query: BrowserNotificationDocument, ...options }, handler);
};


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Acknowledgement: ResolverTypeWrapper<Acknowledgement>;
  AcknowledgementDocType: AcknowledgementDocType;
  AcknowledgementInput: AcknowledgementInput;
  AddFacilityInput: AddFacilityInput;
  AddOrganizationInput: AddOrganizationInput;
  AddUserForOrganizationInput: AddUserForOrganizationInput;
  Address: ResolverTypeWrapper<Address>;
  AddressId: ResolverTypeWrapper<Scalars['AddressId']>;
  AddressInput: AddressInput;
  AiAssessment: ResolverTypeWrapper<AiAssessment>;
  AiRiskAssessment: ResolverTypeWrapper<AiRiskAssessment>;
  AltPayerName: ResolverTypeWrapper<AltPayerName>;
  AnalysisType: AnalysisType;
  Anesthesia: ResolverTypeWrapper<Anesthesia>;
  AnesthesiaInput: AnesthesiaInput;
  AssociateFaxWithSurgeryInput: AssociateFaxWithSurgeryInput;
  AuthMutations: ResolverTypeWrapper<AuthMutations>;
  AuthorizedPatientMutations: ResolverTypeWrapper<AuthorizedPatientMutations>;
  BodilyMedicalDevies: ResolverTypeWrapper<BodilyMedicalDevies>;
  BodilyMedicalDeviesInput: BodilyMedicalDeviesInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BooleanAnswer: ResolverTypeWrapper<BooleanAnswer>;
  BooleanAnswerInput: BooleanAnswerInput;
  BoundingBox: ResolverTypeWrapper<BoundingBox>;
  BrowserNotification: ResolverTypeWrapper<BrowserNotification>;
  BulkUploadMutations: ResolverTypeWrapper<BulkUploadMutations>;
  CanvasHpIngestResult: ResolverTypeWrapper<CanvasHpIngestResult>;
  CanvasHpIngestStatus: CanvasHpIngestStatus;
  CareTeamMember: ResolverTypeWrapper<CareTeamMember>;
  CaseInstruction: ResolverTypeWrapper<CaseInstruction>;
  CaseInstructionId: ResolverTypeWrapper<Scalars['CaseInstructionId']>;
  CaseInstructionSource: CaseInstructionSource;
  CaseInstructionType: CaseInstructionType;
  ClearanceLevelInput: ClearanceLevelInput;
  ClearanceRiskLevel: ClearanceRiskLevel;
  ClearanceStatus: ClearanceStatus;
  CommitIngestionTransformInput: CommitIngestionTransformInput;
  Condition: ResolverTypeWrapper<Condition>;
  ConditionId: ResolverTypeWrapper<Scalars['ConditionId']>;
  ConditionMutations: ResolverTypeWrapper<ConditionMutations>;
  ConditionStatus: ConditionStatus;
  ConditionSurgicalRisk: ConditionSurgicalRisk;
  Contact: ResolverTypeWrapper<Contact>;
  ContactInput: ContactInput;
  ContactSearchInput: ContactSearchInput;
  CoverageInput: CoverageInput;
  CreateMedication: CreateMedication;
  CreateProcessStepState: CreateProcessStepState;
  CreateProcessStepTemplate: CreateProcessStepTemplate;
  Credentials: Credentials;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DateInfo: ResolverTypeWrapper<DateInfo>;
  DateRangePair: DateRangePair;
  DateString: ResolverTypeWrapper<Scalars['DateString']>;
  DateTimeString: ResolverTypeWrapper<Scalars['DateTimeString']>;
  Diabetes: ResolverTypeWrapper<Diabetes>;
  DiabetesInput: DiabetesInput;
  Document: ResolverTypeWrapper<Document>;
  DocumentAnalysis: ResolverTypeWrapper<DocumentAnalysis>;
  DocumentAnalysisId: ResolverTypeWrapper<Scalars['DocumentAnalysisId']>;
  DocumentId: ResolverTypeWrapper<Scalars['DocumentId']>;
  DocumentMutations: ResolverTypeWrapper<DocumentMutations>;
  DocumentOCRAnalysis: ResolverTypeWrapper<DocumentOcrAnalysis>;
  DocumentOCRStatus: DocumentOcrStatus;
  DocumentStatus: DocumentStatus;
  EditUserInput: EditUserInput;
  EventContextType: EventContextType;
  EventLog: ResolverTypeWrapper<EventLog>;
  EventLogId: ResolverTypeWrapper<Scalars['EventLogId']>;
  EventLogInput: EventLogInput;
  EventLogStatus: EventLogStatus;
  EventLogType: EventLogType;
  Facility: ResolverTypeWrapper<Facility>;
  Fax: ResolverTypeWrapper<Fax>;
  FaxContactInput: FaxContactInput;
  FaxDateFilter: FaxDateFilter;
  FaxDirection: FaxDirection;
  FaxId: ResolverTypeWrapper<Scalars['FaxId']>;
  FaxOptions: FaxOptions;
  FaxResponsePatientMatch: FaxResponsePatientMatch;
  FaxResponseRequestedItemVerification: ResolverTypeWrapper<FaxResponseRequestedItemVerification>;
  FaxResponseVerificationReason: FaxResponseVerificationReason;
  FaxResponseVerificationResult: ResolverTypeWrapper<FaxResponseVerificationResult>;
  FaxResponseVerificationStatus: FaxResponseVerificationStatus;
  FaxStatus: FaxStatus;
  FileCandidate: FileCandidate;
  FileType: FileType;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  GenerateUploadUrlsResponse: ResolverTypeWrapper<GenerateUploadUrlsResponse>;
  GooglePlace: ResolverTypeWrapper<GooglePlace>;
  HeartProblems: ResolverTypeWrapper<HeartProblems>;
  HeartProblemsInput: HeartProblemsInput;
  HieJob: ResolverTypeWrapper<HieJob>;
  HieJobStatus: HieJobStatus;
  HieServiceProvider: ResolverTypeWrapper<HieServiceProvider>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IngestionJob: ResolverTypeWrapper<IngestionJob>;
  IngestionJobStatus: IngestionJobStatus;
  IngestionUploadUrl: ResolverTypeWrapper<IngestionUploadUrl>;
  InitiateFaxRequest: InitiateFaxRequest;
  InitiatePasswordResetMethod: InitiatePasswordResetMethod;
  InitiatePasswordResetResponse: ResolverTypeWrapper<InitiatePasswordResetResponse>;
  InsertRoleAssignment: InsertRoleAssignment;
  InsertTask: InsertTask;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  IntakeProgressStatus: ResolverTypeWrapper<IntakeProgressStatus>;
  IntakeQuestionaire: ResolverTypeWrapper<IntakeQuestionaire>;
  IntakeQuestionaireResponse: IntakeQuestionaireResponse;
  InternalRequirement: InternalRequirement;
  InternalSurgeryMutations: ResolverTypeWrapper<InternalSurgeryMutations>;
  JobStatus: JobStatus;
  LabRequirement: ResolverTypeWrapper<LabRequirement>;
  LabRequirementId: ResolverTypeWrapper<Scalars['LabRequirementId']>;
  LabRequirementMutations: ResolverTypeWrapper<LabRequirementMutations>;
  LabRequirementOptions: LabRequirementOptions;
  LineItem: ResolverTypeWrapper<LineItem>;
  Location: never;
  LoginDetails: LoginDetails;
  Medication: ResolverTypeWrapper<Medication>;
  MedicationId: ResolverTypeWrapper<Scalars['MedicationId']>;
  MedicationInstruction: ResolverTypeWrapper<MedicationInstruction>;
  MedicationInstructionId: ResolverTypeWrapper<Scalars['MedicationInstructionId']>;
  MedicationMutations: ResolverTypeWrapper<MedicationMutations>;
  MedicationStatus: MedicationStatus;
  MedicationSurgicalRisk: MedicationSurgicalRisk;
  Message: ResolverTypeWrapper<Message>;
  MessageFilter: MessageFilter;
  MessageId: ResolverTypeWrapper<Scalars['MessageId']>;
  MessageOrigin: MessageOrigin;
  MessageStatus: MessageStatus;
  Mutation: ResolverTypeWrapper<{}>;
  NeurologicalDisorder: ResolverTypeWrapper<NeurologicalDisorder>;
  NeurologicalDisorderInput: NeurologicalDisorderInput;
  Observation: ResolverTypeWrapper<Observation>;
  ObservationFilter: ObservationFilter;
  ObservationId: ResolverTypeWrapper<Scalars['ObservationId']>;
  ObservationMutations: ResolverTypeWrapper<ObservationMutations>;
  ObservationPanel: ObservationPanel;
  ObservationValue: ResolverTypeWrapper<ObservationValue>;
  OpenLoopViabilityStatus: ResolverTypeWrapper<OpenLoopViabilityStatus>;
  OpenLoopVisitScheduleResult: ResolverTypeWrapper<OpenLoopVisitScheduleResult>;
  OrchestraOperations: ResolverTypeWrapper<OrchestraOperations>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationFeatures: ResolverTypeWrapper<OrganizationFeatures>;
  OrganizationId: ResolverTypeWrapper<Scalars['OrganizationId']>;
  OrganizationSpecialty: OrganizationSpecialty;
  OrganizationTier: OrganizationTier;
  OverruledType: OverruledType;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PageInfoInput: PageInfoInput;
  PaginatedSurgeries: ResolverTypeWrapper<PaginatedSurgeries>;
  PaginatedTasks: ResolverTypeWrapper<PaginatedTasks>;
  PaginationDirection: PaginationDirection;
  PaginationOptions: PaginationOptions;
  Patient: ResolverTypeWrapper<Patient>;
  PatientAccountBalance: ResolverTypeWrapper<PatientAccountBalance>;
  PatientCoverage: ResolverTypeWrapper<PatientCoverage>;
  PatientCoverageStatus: PatientCoverageStatus;
  PatientDemographics: ResolverTypeWrapper<PatientDemographics>;
  PatientHieRefreshResponse: PatientHieRefreshResponse;
  PatientId: ResolverTypeWrapper<Scalars['PatientId']>;
  PatientInput: PatientInput;
  PatientIntakeQuestionaire: PatientIntakeQuestionaire;
  PatientMutations: ResolverTypeWrapper<PatientMutations>;
  Payer: ResolverTypeWrapper<Payer>;
  PayerId: ResolverTypeWrapper<Scalars['PayerId']>;
  PhoneNumber: ResolverTypeWrapper<Scalars['PhoneNumber']>;
  PhoneType: PhoneType;
  Place: ResolverTypeWrapper<Place>;
  PlatformThreadId: ResolverTypeWrapper<Scalars['PlatformThreadId']>;
  PointOfContact: ResolverTypeWrapper<PointOfContact>;
  ProcessStepMutations: ResolverTypeWrapper<ProcessStepMutations>;
  ProcessStepState: ResolverTypeWrapper<ProcessStepState>;
  ProcessStepStatus: ProcessStepStatus;
  ProcessTemplateKey: ProcessTemplateKey;
  ProcessTracker: ResolverTypeWrapper<ProcessTracker>;
  PromptChatOptions: PromptChatOptions;
  PromptChatResponse: ResolverTypeWrapper<PromptChatResponse>;
  ProviderMutations: ResolverTypeWrapper<ProviderMutations>;
  ProviderOperationsMutations: ResolverTypeWrapper<ProviderOperationsMutations>;
  Query: ResolverTypeWrapper<{}>;
  RecommendedCareSetting: RecommendedCareSetting;
  ReconciliationStatus: ReconciliationStatus;
  RedFlag: ResolverTypeWrapper<RedFlag>;
  RegisterRequest: RegisterRequest;
  RiskAssessment: ResolverTypeWrapper<RiskAssessment>;
  RiskAssessmentAvailability: RiskAssessmentAvailability;
  RiskAssessmentInput: RiskAssessmentInput;
  RiskAssessmentMutations: ResolverTypeWrapper<RiskAssessmentMutations>;
  RoleAssignment: ResolverTypeWrapper<RoleAssignment>;
  RoleAssignmentId: ResolverTypeWrapper<Scalars['RoleAssignmentId']>;
  RoleAssignmentMutations: ResolverTypeWrapper<RoleAssignmentMutations>;
  RoleAssignmentOptions: RoleAssignmentOptions;
  RoleType: RoleType;
  ServiceProviderJobStatus: ServiceProviderJobStatus;
  SessionInfo: ResolverTypeWrapper<SessionInfo>;
  SexAtBirth: SexAtBirth;
  SignaturesAoBandTicFileRequest: SignaturesAoBandTicFileRequest;
  SignedS3DownloadUrl: ResolverTypeWrapper<Scalars['SignedS3DownloadUrl']>;
  SignedS3UploadUrl: ResolverTypeWrapper<Scalars['SignedS3UploadUrl']>;
  SourceType: SourceType;
  SpecialtyContext: SpecialtyContext;
  StateTransitionType: StateTransitionType;
  Static: ResolverTypeWrapper<Static>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Study: ResolverTypeWrapper<Study>;
  StudyState: StudyState;
  StudyTrackingState: ResolverTypeWrapper<StudyTrackingState>;
  Subscription: ResolverTypeWrapper<{}>;
  SurgeriesFilterCriteria: SurgeriesFilterCriteria;
  SurgeriesSummary: ResolverTypeWrapper<SurgeriesSummary>;
  Surgery: ResolverTypeWrapper<Surgery>;
  SurgeryId: ResolverTypeWrapper<Scalars['SurgeryId']>;
  SurgeryInput: SurgeryInput;
  SurgeryOptions: SurgeryOptions;
  SurgeryRecordsRequestInput: SurgeryRecordsRequestInput;
  SurgerySortCriteria: SurgerySortCriteria;
  SurgerySummaryCriteria: SurgerySummaryCriteria;
  SurgeryWorkflow: SurgeryWorkflow;
  SurgicalRiskLevelInput: SurgicalRiskLevelInput;
  SymptomsAnswer: ResolverTypeWrapper<SymptomsAnswer>;
  SymptomsAnswerInput: SymptomsAnswerInput;
  TargetType: TargetType;
  Task: ResolverTypeWrapper<Task>;
  TaskId: ResolverTypeWrapper<Scalars['TaskId']>;
  TaskMutations: ResolverTypeWrapper<TaskMutations>;
  TaskOptions: TaskOptions;
  TaskStatus: TaskStatus;
  TemporalFrequency: TemporalFrequency;
  TextAnswer: ResolverTypeWrapper<TextAnswer>;
  TextAnswerInput: TextAnswerInput;
  TransformIngestionResult: ResolverTypeWrapper<TransformIngestionResult>;
  TransformIngestionUploadInput: TransformIngestionUploadInput;
  Trigger: Trigger;
  TriggerType: TriggerType;
  UpdateCondition: UpdateCondition;
  UpdateMedication: UpdateMedication;
  UpdatePatientInput: UpdatePatientInput;
  UpdateProcessStepState: UpdateProcessStepState;
  UpdateRoleAssignment: UpdateRoleAssignment;
  UpdateSurgeryArchivedInput: UpdateSurgeryArchivedInput;
  UpdateSurgeryInput: UpdateSurgeryInput;
  UpdateTask: UpdateTask;
  UploadIngestionFileInput: UploadIngestionFileInput;
  UploadIngestionFileResponse: ResolverTypeWrapper<UploadIngestionFileResponse>;
  UpsertObservation: UpsertObservation;
  UpsertRequirement: UpsertRequirement;
  User: ResolverTypeWrapper<User>;
  UserId: ResolverTypeWrapper<Scalars['UserId']>;
  UserInput: UserInput;
  UserRole: UserRole;
  UserStatus: UserStatus;
  UserType: UserType;
  ValidateAndIngestUploadInput: ValidateAndIngestUploadInput;
  Visit: ResolverTypeWrapper<Visit>;
  VisitCompletedParams: VisitCompletedParams;
  VisitFilterOptions: VisitFilterOptions;
  VisitId: ResolverTypeWrapper<Scalars['VisitId']>;
  VisitParams: VisitParams;
  VisitSlot: ResolverTypeWrapper<VisitSlot>;
  VisitSlotFilterOptions: VisitSlotFilterOptions;
  VisitStatus: VisitStatus;
  VisitType: VisitType;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Acknowledgement: Acknowledgement;
  AcknowledgementInput: AcknowledgementInput;
  AddFacilityInput: AddFacilityInput;
  AddOrganizationInput: AddOrganizationInput;
  AddUserForOrganizationInput: AddUserForOrganizationInput;
  Address: Address;
  AddressId: Scalars['AddressId'];
  AddressInput: AddressInput;
  AiAssessment: AiAssessment;
  AiRiskAssessment: AiRiskAssessment;
  AltPayerName: AltPayerName;
  Anesthesia: Anesthesia;
  AnesthesiaInput: AnesthesiaInput;
  AssociateFaxWithSurgeryInput: AssociateFaxWithSurgeryInput;
  AuthMutations: AuthMutations;
  AuthorizedPatientMutations: AuthorizedPatientMutations;
  BodilyMedicalDevies: BodilyMedicalDevies;
  BodilyMedicalDeviesInput: BodilyMedicalDeviesInput;
  Boolean: Scalars['Boolean'];
  BooleanAnswer: BooleanAnswer;
  BooleanAnswerInput: BooleanAnswerInput;
  BoundingBox: BoundingBox;
  BrowserNotification: BrowserNotification;
  BulkUploadMutations: BulkUploadMutations;
  CanvasHpIngestResult: CanvasHpIngestResult;
  CareTeamMember: CareTeamMember;
  CaseInstruction: CaseInstruction;
  CaseInstructionId: Scalars['CaseInstructionId'];
  ClearanceLevelInput: ClearanceLevelInput;
  CommitIngestionTransformInput: CommitIngestionTransformInput;
  Condition: Condition;
  ConditionId: Scalars['ConditionId'];
  ConditionMutations: ConditionMutations;
  Contact: Contact;
  ContactInput: ContactInput;
  ContactSearchInput: ContactSearchInput;
  CoverageInput: CoverageInput;
  CreateMedication: CreateMedication;
  CreateProcessStepState: CreateProcessStepState;
  CreateProcessStepTemplate: CreateProcessStepTemplate;
  Credentials: Credentials;
  Date: Scalars['Date'];
  DateInfo: DateInfo;
  DateRangePair: DateRangePair;
  DateString: Scalars['DateString'];
  DateTimeString: Scalars['DateTimeString'];
  Diabetes: Diabetes;
  DiabetesInput: DiabetesInput;
  Document: Document;
  DocumentAnalysis: DocumentAnalysis;
  DocumentAnalysisId: Scalars['DocumentAnalysisId'];
  DocumentId: Scalars['DocumentId'];
  DocumentMutations: DocumentMutations;
  DocumentOCRAnalysis: DocumentOcrAnalysis;
  EditUserInput: EditUserInput;
  EventLog: EventLog;
  EventLogId: Scalars['EventLogId'];
  EventLogInput: EventLogInput;
  Facility: Facility;
  Fax: Fax;
  FaxContactInput: FaxContactInput;
  FaxDateFilter: FaxDateFilter;
  FaxId: Scalars['FaxId'];
  FaxOptions: FaxOptions;
  FaxResponseRequestedItemVerification: FaxResponseRequestedItemVerification;
  FaxResponseVerificationResult: FaxResponseVerificationResult;
  FileCandidate: FileCandidate;
  Float: Scalars['Float'];
  GenerateUploadUrlsResponse: GenerateUploadUrlsResponse;
  GooglePlace: GooglePlace;
  HeartProblems: HeartProblems;
  HeartProblemsInput: HeartProblemsInput;
  HieJob: HieJob;
  HieServiceProvider: HieServiceProvider;
  ID: Scalars['ID'];
  IngestionJob: IngestionJob;
  IngestionUploadUrl: IngestionUploadUrl;
  InitiateFaxRequest: InitiateFaxRequest;
  InitiatePasswordResetResponse: InitiatePasswordResetResponse;
  InsertRoleAssignment: InsertRoleAssignment;
  InsertTask: InsertTask;
  Int: Scalars['Int'];
  IntakeProgressStatus: IntakeProgressStatus;
  IntakeQuestionaire: IntakeQuestionaire;
  IntakeQuestionaireResponse: IntakeQuestionaireResponse;
  InternalSurgeryMutations: InternalSurgeryMutations;
  LabRequirement: LabRequirement;
  LabRequirementId: Scalars['LabRequirementId'];
  LabRequirementMutations: LabRequirementMutations;
  LabRequirementOptions: LabRequirementOptions;
  LineItem: LineItem;
  Location: never;
  LoginDetails: LoginDetails;
  Medication: Medication;
  MedicationId: Scalars['MedicationId'];
  MedicationInstruction: MedicationInstruction;
  MedicationInstructionId: Scalars['MedicationInstructionId'];
  MedicationMutations: MedicationMutations;
  Message: Message;
  MessageFilter: MessageFilter;
  MessageId: Scalars['MessageId'];
  Mutation: {};
  NeurologicalDisorder: NeurologicalDisorder;
  NeurologicalDisorderInput: NeurologicalDisorderInput;
  Observation: Observation;
  ObservationFilter: ObservationFilter;
  ObservationId: Scalars['ObservationId'];
  ObservationMutations: ObservationMutations;
  ObservationValue: ObservationValue;
  OpenLoopViabilityStatus: OpenLoopViabilityStatus;
  OpenLoopVisitScheduleResult: OpenLoopVisitScheduleResult;
  OrchestraOperations: OrchestraOperations;
  Organization: Organization;
  OrganizationFeatures: OrganizationFeatures;
  OrganizationId: Scalars['OrganizationId'];
  PageInfo: PageInfo;
  PageInfoInput: PageInfoInput;
  PaginatedSurgeries: PaginatedSurgeries;
  PaginatedTasks: PaginatedTasks;
  PaginationOptions: PaginationOptions;
  Patient: Patient;
  PatientAccountBalance: PatientAccountBalance;
  PatientCoverage: PatientCoverage;
  PatientDemographics: PatientDemographics;
  PatientId: Scalars['PatientId'];
  PatientInput: PatientInput;
  PatientIntakeQuestionaire: PatientIntakeQuestionaire;
  PatientMutations: PatientMutations;
  Payer: Payer;
  PayerId: Scalars['PayerId'];
  PhoneNumber: Scalars['PhoneNumber'];
  Place: Place;
  PlatformThreadId: Scalars['PlatformThreadId'];
  PointOfContact: PointOfContact;
  ProcessStepMutations: ProcessStepMutations;
  ProcessStepState: ProcessStepState;
  ProcessTracker: ProcessTracker;
  PromptChatOptions: PromptChatOptions;
  PromptChatResponse: PromptChatResponse;
  ProviderMutations: ProviderMutations;
  ProviderOperationsMutations: ProviderOperationsMutations;
  Query: {};
  RedFlag: RedFlag;
  RegisterRequest: RegisterRequest;
  RiskAssessment: RiskAssessment;
  RiskAssessmentInput: RiskAssessmentInput;
  RiskAssessmentMutations: RiskAssessmentMutations;
  RoleAssignment: RoleAssignment;
  RoleAssignmentId: Scalars['RoleAssignmentId'];
  RoleAssignmentMutations: RoleAssignmentMutations;
  RoleAssignmentOptions: RoleAssignmentOptions;
  SessionInfo: SessionInfo;
  SignaturesAoBandTicFileRequest: SignaturesAoBandTicFileRequest;
  SignedS3DownloadUrl: Scalars['SignedS3DownloadUrl'];
  SignedS3UploadUrl: Scalars['SignedS3UploadUrl'];
  Static: Static;
  String: Scalars['String'];
  Study: Study;
  StudyTrackingState: StudyTrackingState;
  Subscription: {};
  SurgeriesFilterCriteria: SurgeriesFilterCriteria;
  SurgeriesSummary: SurgeriesSummary;
  Surgery: Surgery;
  SurgeryId: Scalars['SurgeryId'];
  SurgeryInput: SurgeryInput;
  SurgeryOptions: SurgeryOptions;
  SurgeryRecordsRequestInput: SurgeryRecordsRequestInput;
  SurgerySortCriteria: SurgerySortCriteria;
  SurgerySummaryCriteria: SurgerySummaryCriteria;
  SurgicalRiskLevelInput: SurgicalRiskLevelInput;
  SymptomsAnswer: SymptomsAnswer;
  SymptomsAnswerInput: SymptomsAnswerInput;
  Task: Task;
  TaskId: Scalars['TaskId'];
  TaskMutations: TaskMutations;
  TaskOptions: TaskOptions;
  TextAnswer: TextAnswer;
  TextAnswerInput: TextAnswerInput;
  TransformIngestionResult: TransformIngestionResult;
  TransformIngestionUploadInput: TransformIngestionUploadInput;
  Trigger: Trigger;
  UpdateCondition: UpdateCondition;
  UpdateMedication: UpdateMedication;
  UpdatePatientInput: UpdatePatientInput;
  UpdateProcessStepState: UpdateProcessStepState;
  UpdateRoleAssignment: UpdateRoleAssignment;
  UpdateSurgeryArchivedInput: UpdateSurgeryArchivedInput;
  UpdateSurgeryInput: UpdateSurgeryInput;
  UpdateTask: UpdateTask;
  UploadIngestionFileInput: UploadIngestionFileInput;
  UploadIngestionFileResponse: UploadIngestionFileResponse;
  UpsertObservation: UpsertObservation;
  UpsertRequirement: UpsertRequirement;
  User: User;
  UserId: Scalars['UserId'];
  UserInput: UserInput;
  ValidateAndIngestUploadInput: ValidateAndIngestUploadInput;
  Visit: Visit;
  VisitCompletedParams: VisitCompletedParams;
  VisitFilterOptions: VisitFilterOptions;
  VisitId: Scalars['VisitId'];
  VisitParams: VisitParams;
  VisitSlot: VisitSlot;
  VisitSlotFilterOptions: VisitSlotFilterOptions;
};

export type AcknowledgementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Acknowledgement'] = ResolversParentTypes['Acknowledgement']> = {
  acknowledgedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  docType?: Resolver<ResolversTypes['AcknowledgementDocType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mfaCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  address1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  zip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface AddressIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AddressId'], any> {
  name: 'AddressId';
}

export type AiAssessmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AiAssessment'] = ResolversParentTypes['AiAssessment']> = {
  allAssessmentDocIds?: Resolver<Maybe<Array<ResolversTypes['DocumentId']>>, ParentType, ContextType, Partial<AiAssessmentAllAssessmentDocIdsArgs>>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  preChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<AiAssessmentPreChartArgs>>;
  redFlags?: Resolver<Maybe<Array<ResolversTypes['RedFlag']>>, ParentType, ContextType>;
  risk?: Resolver<Maybe<ResolversTypes['AiRiskAssessment']>, ParentType, ContextType, Partial<AiAssessmentRiskArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AiRiskAssessmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AiRiskAssessment'] = ResolversParentTypes['AiRiskAssessment']> = {
  analysis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  signalDocumentIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  synthesis?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AltPayerNameResolvers<ContextType = any, ParentType extends ResolversParentTypes['AltPayerName'] = ResolversParentTypes['AltPayerName']> = {
  alt_payer_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnesthesiaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Anesthesia'] = ResolversParentTypes['Anesthesia']> = {
  answer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  issuesIntubating?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  malignantHyperthermia?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pastProblems?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spineProblems?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  whatType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthMutations'] = ResolversParentTypes['AuthMutations']> = {
  login?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AuthMutationsLoginArgs, 'loginDetails'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedPatientMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizedPatientMutations'] = ResolversParentTypes['AuthorizedPatientMutations']> = {
  addAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsAddAddressArgs, 'address' | 'patientId'>>;
  addCoverage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsAddCoverageArgs, 'coverage' | 'patientId'>>;
  addCoverageFromName?: Resolver<Maybe<ResolversTypes['PatientCoverage']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsAddCoverageFromNameArgs, 'patientId' | 'payerName' | 'subscriberNumber'>>;
  generateS3Files?: Resolver<Maybe<Array<ResolversTypes['Document']>>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsGenerateS3FilesArgs, 'files'>>;
  intakeQuestionaire?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsIntakeQuestionaireArgs, 'intake'>>;
  registerCareTeam?: Resolver<Maybe<Array<ResolversTypes['Contact']>>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsRegisterCareTeamArgs, 'careTeam'>>;
  requestRecordFromCareTeamMember?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsRequestRecordFromCareTeamMemberArgs, 'careTeamMemberId'>>;
  setPreferredTimeZone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsSetPreferredTimeZoneArgs, 'preferredTimeZone'>>;
  updateCoverage?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsUpdateCoverageArgs, 'address' | 'coverage' | 'patientId'>>;
  uploadS3Content?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsUploadS3ContentArgs, 'file' | 'patientId'>>;
  validateAuth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<AuthorizedPatientMutationsValidateAuthArgs, 'surgeryId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BodilyMedicalDeviesResolvers<ContextType = any, ParentType extends ResolversParentTypes['BodilyMedicalDevies'] = ResolversParentTypes['BodilyMedicalDevies']> = {
  deviceCheckedInLastYear?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deviceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  informationCard?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  informationCardDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BooleanAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['BooleanAnswer'] = ResolversParentTypes['BooleanAnswer']> = {
  answer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BoundingBoxResolvers<ContextType = any, ParentType extends ResolversParentTypes['BoundingBox'] = ResolversParentTypes['BoundingBox']> = {
  height?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  left?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  top?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  width?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrowserNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BrowserNotification'] = ResolversParentTypes['BrowserNotification']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUploadMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkUploadMutations'] = ResolversParentTypes['BulkUploadMutations']> = {
  commitIngestionTransform?: Resolver<ResolversTypes['UploadIngestionFileResponse'], ParentType, ContextType, RequireFields<BulkUploadMutationsCommitIngestionTransformArgs, 'input'>>;
  requestIngestionUploadUrl?: Resolver<ResolversTypes['IngestionUploadUrl'], ParentType, ContextType, Partial<BulkUploadMutationsRequestIngestionUploadUrlArgs>>;
  transformIngestionUpload?: Resolver<ResolversTypes['TransformIngestionResult'], ParentType, ContextType, RequireFields<BulkUploadMutationsTransformIngestionUploadArgs, 'input'>>;
  validateAndIngestUpload?: Resolver<ResolversTypes['UploadIngestionFileResponse'], ParentType, ContextType, RequireFields<BulkUploadMutationsValidateAndIngestUploadArgs, 'input'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CanvasHpIngestResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CanvasHpIngestResult'] = ResolversParentTypes['CanvasHpIngestResult']> = {
  document?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CanvasHpIngestStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CareTeamMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['CareTeamMember'] = ResolversParentTypes['CareTeamMember']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specialty?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CaseInstructionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CaseInstruction'] = ResolversParentTypes['CaseInstruction']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['CaseInstructionId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['CaseInstructionSource'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CaseInstructionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface CaseInstructionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['CaseInstructionId'], any> {
  name: 'CaseInstructionId';
}

export type ConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Condition'] = ResolversParentTypes['Condition']> = {
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  foreignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ConditionId'], ParentType, ContextType>;
  lastReconciled?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onsetDate?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  primaryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primarySystem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recordedDate?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  secondaryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondarySystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ConditionStatus'], ParentType, ContextType>;
  surgicalRisk?: Resolver<ResolversTypes['ConditionSurgicalRisk'], ParentType, ContextType>;
  surgicalRiskReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ConditionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ConditionId'], any> {
  name: 'ConditionId';
}

export type ConditionMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConditionMutations'] = ResolversParentTypes['ConditionMutations']> = {
  conditionTriageAnalysis?: Resolver<Maybe<Array<Maybe<ResolversTypes['Condition']>>>, ParentType, ContextType, RequireFields<ConditionMutationsConditionTriageAnalysisArgs, 'patientId'>>;
  deleteCondition?: Resolver<Maybe<ResolversTypes['Condition']>, ParentType, ContextType, RequireFields<ConditionMutationsDeleteConditionArgs, 'conditionId'>>;
  updateCondition?: Resolver<Maybe<ResolversTypes['Condition']>, ParentType, ContextType, RequireFields<ConditionMutationsUpdateConditionArgs, 'condition'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contact'] = ResolversParentTypes['Contact']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DateInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DateInfo'] = ResolversParentTypes['DateInfo']> = {
  boundingBox?: Resolver<Maybe<ResolversTypes['BoundingBox']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateString'], any> {
  name: 'DateString';
}

export interface DateTimeStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTimeString'], any> {
  name: 'DateTimeString';
}

export type DiabetesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Diabetes'] = ResolversParentTypes['Diabetes']> = {
  a1cLevel?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  answer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  areYouTakingInsulin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = {
  analyses?: Resolver<Maybe<Array<Maybe<ResolversTypes['DocumentAnalysis']>>>, ParentType, ContextType>;
  author?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorId?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  effectiveAt?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  foreignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ocrAnalysis?: Resolver<Maybe<ResolversTypes['DocumentOCRAnalysis']>, ParentType, ContextType>;
  ocrStatus?: Resolver<Maybe<ResolversTypes['DocumentOCRStatus']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<ResolversTypes['PatientId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DocumentStatus'], ParentType, ContextType>;
  surgeryId?: Resolver<Maybe<ResolversTypes['SurgeryId']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FileType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentAnalysisResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentAnalysis'] = ResolversParentTypes['DocumentAnalysis']> = {
  documentId?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['DocumentAnalysisId'], ParentType, ContextType>;
  jobId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnalysisType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DocumentAnalysisIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DocumentAnalysisId'], any> {
  name: 'DocumentAnalysisId';
}

export interface DocumentIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DocumentId'], any> {
  name: 'DocumentId';
}

export type DocumentMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentMutations'] = ResolversParentTypes['DocumentMutations']> = {
  generateUploadUrls?: Resolver<Maybe<Array<ResolversTypes['GenerateUploadUrlsResponse']>>, ParentType, ContextType, RequireFields<DocumentMutationsGenerateUploadUrlsArgs, 'fileNames'>>;
  ingestCanvasDocumentReference?: Resolver<Maybe<ResolversTypes['CanvasHpIngestResult']>, ParentType, ContextType, RequireFields<DocumentMutationsIngestCanvasDocumentReferenceArgs, 'patientId'>>;
  startOCRAnalysis?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<DocumentMutationsStartOcrAnalysisArgs, 'documentId'>>;
  updateDocumentName?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<DocumentMutationsUpdateDocumentNameArgs, 'documentId' | 'documentName'>>;
  updateDocumentStatus?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<DocumentMutationsUpdateDocumentStatusArgs, 'documentId' | 'status'>>;
  updateDocumentSurgery?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<DocumentMutationsUpdateDocumentSurgeryArgs, 'documentId' | 'surgeryId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocumentOcrAnalysisResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentOCRAnalysis'] = ResolversParentTypes['DocumentOCRAnalysis']> = {
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientDemographics?: Resolver<Maybe<ResolversTypes['PatientDemographics']>, ParentType, ContextType>;
  studies?: Resolver<Maybe<Array<Maybe<ResolversTypes['Study']>>>, ParentType, ContextType>;
  surgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventLog'] = ResolversParentTypes['EventLog']> = {
  actor?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  actorId?: Resolver<ResolversTypes['UserId'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['EventLogId'], ParentType, ContextType>;
  occurredAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EventLogStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EventLogIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EventLogId'], any> {
  name: 'EventLogId';
}

export type FacilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Facility'] = ResolversParentTypes['Facility']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['OrganizationId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pointOfContact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaxResolvers<ContextType = any, ParentType extends ResolversParentTypes['Fax'] = ResolversParentTypes['Fax']> = {
  callerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['FaxDirection'], ParentType, ContextType>;
  documentId?: Resolver<Maybe<ResolversTypes['DocumentId']>, ParentType, ContextType>;
  from?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  fromContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['FaxId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<ResolversTypes['PatientId']>, ParentType, ContextType>;
  requestFaxId?: Resolver<Maybe<ResolversTypes['FaxId']>, ParentType, ContextType>;
  requestMetadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FaxStatus'], ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType>;
  surgeryId?: Resolver<Maybe<ResolversTypes['SurgeryId']>, ParentType, ContextType>;
  to?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  toContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface FaxIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['FaxId'], any> {
  name: 'FaxId';
}

export type FaxResponseRequestedItemVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaxResponseRequestedItemVerification'] = ResolversParentTypes['FaxResponseRequestedItemVerification']> = {
  reason?: Resolver<Maybe<ResolversTypes['FaxResponseVerificationReason']>, ParentType, ContextType>;
  requestCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FaxResponseVerificationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FaxResponseVerificationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaxResponseVerificationResult'] = ResolversParentTypes['FaxResponseVerificationResult']> = {
  documentId?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['FaxResponseRequestedItemVerification']>, ParentType, ContextType>;
  patientMatch?: Resolver<ResolversTypes['FaxResponsePatientMatch'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenerateUploadUrlsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateUploadUrlsResponse'] = ResolversParentTypes['GenerateUploadUrlsResponse']> = {
  document?: Resolver<ResolversTypes['Document'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['SignedS3UploadUrl'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GooglePlaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['GooglePlace'] = ResolversParentTypes['GooglePlace']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  foreignId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HeartProblemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['HeartProblems'] = ResolversParentTypes['HeartProblems']> = {
  bloodTinners?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  canYouClimbTwoFlights?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  faintedInTheLastYear?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  heartRhythmProblems?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  heartStents?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HieJobResolvers<ContextType = any, ParentType extends ResolversParentTypes['HieJob'] = ResolversParentTypes['HieJob']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  jobStatus?: Resolver<Maybe<ResolversTypes['HieJobStatus']>, ParentType, ContextType>;
  serviceProviders?: Resolver<Maybe<Array<Maybe<ResolversTypes['HieServiceProvider']>>>, ParentType, ContextType>;
  targetCompletionDate?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HieServiceProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['HieServiceProvider'] = ResolversParentTypes['HieServiceProvider']> = {
  service?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ServiceProviderJobStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestionJobResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestionJob'] = ResolversParentTypes['IngestionJob']> = {
  createdAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  errorCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  processedRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['IngestionJobStatus'], ParentType, ContextType>;
  totalRows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IngestionUploadUrlResolvers<ContextType = any, ParentType extends ResolversParentTypes['IngestionUploadUrl'] = ResolversParentTypes['IngestionUploadUrl']> = {
  sourceBucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InitiatePasswordResetResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitiatePasswordResetResponse'] = ResolversParentTypes['InitiatePasswordResetResponse']> = {
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['InitiatePasswordResetMethod'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntakeProgressStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeProgressStatus'] = ResolversParentTypes['IntakeProgressStatus']> = {
  coverageLatestDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  intakeQLatestDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<ResolversTypes['PatientId']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preopVisitDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  signaturesDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  visitCopay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  visitCopayStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntakeQuestionaireResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntakeQuestionaire'] = ResolversParentTypes['IntakeQuestionaire']> = {
  KidneyDisease?: Resolver<ResolversTypes['SymptomsAnswer'], ParentType, ContextType>;
  anesthesia?: Resolver<ResolversTypes['Anesthesia'], ParentType, ContextType>;
  bloodDisase?: Resolver<ResolversTypes['BooleanAnswer'], ParentType, ContextType>;
  bodilyMedicalDevies?: Resolver<ResolversTypes['BodilyMedicalDevies'], ParentType, ContextType>;
  congestiveHeartFailure?: Resolver<ResolversTypes['SymptomsAnswer'], ParentType, ContextType>;
  diabetes?: Resolver<ResolversTypes['Diabetes'], ParentType, ContextType>;
  endocrineDisorder?: Resolver<ResolversTypes['TextAnswer'], ParentType, ContextType>;
  heartProblems?: Resolver<ResolversTypes['HeartProblems'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  immuneDisorders?: Resolver<ResolversTypes['BooleanAnswer'], ParentType, ContextType>;
  liverDisease?: Resolver<ResolversTypes['SymptomsAnswer'], ParentType, ContextType>;
  neurologicalDisorder?: Resolver<ResolversTypes['NeurologicalDisorder'], ParentType, ContextType>;
  other?: Resolver<ResolversTypes['TextAnswer'], ParentType, ContextType>;
  pulmonaryProblems?: Resolver<ResolversTypes['SymptomsAnswer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InternalSurgeryMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalSurgeryMutations'] = ResolversParentTypes['InternalSurgeryMutations']> = {
  replacePrimaryOrganization?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsReplacePrimaryOrganizationArgs, 'organizationId' | 'surgeryId'>>;
  sendIntakeQuestionnaire?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsSendIntakeQuestionnaireArgs, 'surgeryId'>>;
  sendMessage?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsSendMessageArgs, 'message' | 'patientId'>>;
  sendUpdateCoverageInstructions?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsSendUpdateCoverageInstructionsArgs, 'patient'>>;
  updateExternalNote?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsUpdateExternalNoteArgs, 'notes' | 'surgeryId'>>;
  updateMessage?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsUpdateMessageArgs, 'id' | 'translation'>>;
  updateNotes?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<InternalSurgeryMutationsUpdateNotesArgs, 'notes' | 'surgeryId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LabRequirementResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabRequirement'] = ResolversParentTypes['LabRequirement']> = {
  authorId?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  effectiveDuration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['TemporalFrequency'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['LabRequirementId'], ParentType, ContextType>;
  labRequirements?: Resolver<Maybe<Array<ResolversTypes['LabRequirement']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requirementId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  targetType?: Resolver<ResolversTypes['TargetType'], ParentType, ContextType>;
  thresholdHigh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thresholdLow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thresholdOutOfRange?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thresholdOutOfRangeHigh?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thresholdOutOfRangeLow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LabRequirementIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LabRequirementId'], any> {
  name: 'LabRequirementId';
}

export type LabRequirementMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['LabRequirementMutations'] = ResolversParentTypes['LabRequirementMutations']> = {
  upsertLabRequirement?: Resolver<Maybe<ResolversTypes['LabRequirement']>, ParentType, ContextType, Partial<LabRequirementMutationsUpsertLabRequirementArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineItem'] = ResolversParentTypes['LineItem']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  lat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lng?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type MedicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Medication'] = ResolversParentTypes['Medication']> = {
  activeIngredient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeIngredientCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activeIngredientSystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confidenceScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  confidenceScoreRationale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dosageEnd?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  dosageInstructions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dosageStart?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  foreignId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['MedicationId'], ParentType, ContextType>;
  lastFilledDate?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  lastPrescribedDate?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  lastReconciled?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  primaryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primarySystem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MedicationStatus'], ParentType, ContextType>;
  surgicalRisk?: Resolver<ResolversTypes['MedicationSurgicalRisk'], ParentType, ContextType>;
  surgicalRiskReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MedicationIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MedicationId'], any> {
  name: 'MedicationId';
}

export type MedicationInstructionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationInstruction'] = ResolversParentTypes['MedicationInstruction']> = {
  id?: Resolver<ResolversTypes['MedicationInstructionId'], ParentType, ContextType>;
  instruction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CaseInstructionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MedicationInstructionIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MedicationInstructionId'], any> {
  name: 'MedicationInstructionId';
}

export type MedicationMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationMutations'] = ResolversParentTypes['MedicationMutations']> = {
  clearMedications?: Resolver<Maybe<Array<ResolversTypes['Medication']>>, ParentType, ContextType, RequireFields<MedicationMutationsClearMedicationsArgs, 'medicationIds'>>;
  createMedication?: Resolver<Maybe<ResolversTypes['Medication']>, ParentType, ContextType, RequireFields<MedicationMutationsCreateMedicationArgs, 'medication'>>;
  deleteMedication?: Resolver<Maybe<ResolversTypes['Medication']>, ParentType, ContextType, RequireFields<MedicationMutationsDeleteMedicationArgs, 'medicationId'>>;
  medicationTriageAnalysis?: Resolver<Maybe<Array<Maybe<ResolversTypes['Medication']>>>, ParentType, ContextType, RequireFields<MedicationMutationsMedicationTriageAnalysisArgs, 'patientId'>>;
  reconcileMedications?: Resolver<Maybe<Array<ResolversTypes['Medication']>>, ParentType, ContextType, RequireFields<MedicationMutationsReconcileMedicationsArgs, 'medicationIds' | 'patientId'>>;
  updateMedication?: Resolver<Maybe<ResolversTypes['Medication']>, ParentType, ContextType, RequireFields<MedicationMutationsUpdateMedicationArgs, 'medication'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  author?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  authorId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  authorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  foreignStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['MessageId'], ParentType, ContextType>;
  origin?: Resolver<ResolversTypes['MessageOrigin'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MessageStatus'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  translation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface MessageIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['MessageId'], any> {
  name: 'MessageId';
}

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  authorizedPatient?: Resolver<Maybe<ResolversTypes['AuthorizedPatientMutations']>, ParentType, ContextType>;
  condition?: Resolver<Maybe<ResolversTypes['ConditionMutations']>, ParentType, ContextType>;
  document?: Resolver<Maybe<ResolversTypes['DocumentMutations']>, ParentType, ContextType>;
  internalSurgery?: Resolver<Maybe<ResolversTypes['InternalSurgeryMutations']>, ParentType, ContextType>;
  labRequirement?: Resolver<Maybe<ResolversTypes['LabRequirementMutations']>, ParentType, ContextType>;
  medication?: Resolver<Maybe<ResolversTypes['MedicationMutations']>, ParentType, ContextType>;
  observation?: Resolver<Maybe<ResolversTypes['ObservationMutations']>, ParentType, ContextType>;
  orchestraOperations?: Resolver<Maybe<ResolversTypes['OrchestraOperations']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['PatientMutations']>, ParentType, ContextType>;
  processStep?: Resolver<Maybe<ResolversTypes['ProcessStepMutations']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['ProviderMutations']>, ParentType, ContextType>;
  providerOperations?: Resolver<Maybe<ResolversTypes['ProviderOperationsMutations']>, ParentType, ContextType>;
  riskAssessment?: Resolver<Maybe<ResolversTypes['RiskAssessmentMutations']>, ParentType, ContextType>;
  roleAssignment?: Resolver<Maybe<ResolversTypes['RoleAssignmentMutations']>, ParentType, ContextType>;
  task?: Resolver<Maybe<ResolversTypes['TaskMutations']>, ParentType, ContextType>;
};

export type NeurologicalDisorderResolvers<ContextType = any, ParentType extends ResolversParentTypes['NeurologicalDisorder'] = ResolversParentTypes['NeurologicalDisorder']> = {
  answer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastStroke?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObservationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Observation'] = ResolversParentTypes['Observation']> = {
  author?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  authorId?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['DateTimeString']>, ParentType, ContextType>;
  encounterDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ObservationId'], ParentType, ContextType>;
  observations?: Resolver<Maybe<Array<ResolversTypes['Observation']>>, ParentType, ContextType>;
  overruledBy?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  overruledByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  overruledType?: Resolver<Maybe<ResolversTypes['OverruledType']>, ParentType, ContextType>;
  pageEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceType?: Resolver<Maybe<ResolversTypes['SourceType']>, ParentType, ContextType>;
  sourceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  system?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ObservationIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ObservationId'], any> {
  name: 'ObservationId';
}

export type ObservationMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObservationMutations'] = ResolversParentTypes['ObservationMutations']> = {
  upsertObservations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Observation']>>>, ParentType, ContextType, Partial<ObservationMutationsUpsertObservationsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ObservationValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['ObservationValue'] = ResolversParentTypes['ObservationValue']> = {
  boundingBox?: Resolver<Maybe<ResolversTypes['BoundingBox']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  datePerformed?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenLoopViabilityStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenLoopViabilityStatus'] = ResolversParentTypes['OpenLoopViabilityStatus']> = {
  isViable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OpenLoopVisitScheduleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OpenLoopVisitScheduleResult'] = ResolversParentTypes['OpenLoopVisitScheduleResult']> = {
  conflict?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  visit?: Resolver<Maybe<ResolversTypes['Visit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrchestraOperationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrchestraOperations'] = ResolversParentTypes['OrchestraOperations']> = {
  addFacility?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<OrchestraOperationsAddFacilityArgs, 'addFacility'>>;
  addOrganization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, RequireFields<OrchestraOperationsAddOrganizationArgs, 'addOrganization'>>;
  inviteUserForOrganization?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<OrchestraOperationsInviteUserForOrganizationArgs, 'inviteUser'>>;
  uploadIngestionFile?: Resolver<Maybe<ResolversTypes['UploadIngestionFileResponse']>, ParentType, ContextType, RequireFields<OrchestraOperationsUploadIngestionFileArgs, 'uploadIngestionFile'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  faxNumber?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  features?: Resolver<Maybe<ResolversTypes['OrganizationFeatures']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['OrganizationId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  network?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  relatedUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, Partial<OrganizationRelatedUsersArgs>>;
  schedulingLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  specialty?: Resolver<ResolversTypes['OrganizationSpecialty'], ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['OrganizationTier']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, Partial<OrganizationUsersArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationFeaturesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFeatures'] = ResolversParentTypes['OrganizationFeatures']> = {
  scheduling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface OrganizationIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['OrganizationId'], any> {
  name: 'OrganizationId';
}

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasPreviousPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedSurgeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedSurgeries'] = ResolversParentTypes['PaginatedSurgeries']> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  surgeries?: Resolver<Array<ResolversTypes['Surgery']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaginatedTasksResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedTasks'] = ResolversParentTypes['PaginatedTasks']> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  tasks?: Resolver<Array<ResolversTypes['Task']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Patient'] = ResolversParentTypes['Patient']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  addressId?: Resolver<Maybe<ResolversTypes['AddressId']>, ParentType, ContextType>;
  birthSex?: Resolver<ResolversTypes['SexAtBirth'], ParentType, ContextType>;
  careTeam?: Resolver<Array<ResolversTypes['CareTeamMember']>, ParentType, ContextType>;
  conditions?: Resolver<Array<Maybe<ResolversTypes['Condition']>>, ParentType, ContextType>;
  coverage?: Resolver<Maybe<ResolversTypes['PatientCoverage']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['Document']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emrId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalHieUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hiePullStatus?: Resolver<Maybe<ResolversTypes['HieJob']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  intake?: Resolver<Maybe<ResolversTypes['IntakeQuestionaire']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  medications?: Resolver<Array<Maybe<ResolversTypes['Medication']>>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, Partial<PatientMessagesArgs>>;
  observations?: Resolver<Array<ResolversTypes['Observation']>, ParentType, ContextType, Partial<PatientObservationsArgs>>;
  outstandingBalance?: Resolver<Maybe<Array<ResolversTypes['PatientAccountBalance']>>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneType?: Resolver<Maybe<ResolversTypes['PhoneType']>, ParentType, ContextType>;
  riskAssessment?: Resolver<Maybe<ResolversTypes['RiskAssessment']>, ParentType, ContextType>;
  upcomingSurgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType>;
  upcomingSurgeryStudyState?: Resolver<Maybe<ResolversTypes['StudyState']>, ParentType, ContextType>;
  visits?: Resolver<Array<ResolversTypes['Visit']>, ParentType, ContextType, Partial<PatientVisitsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientAccountBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientAccountBalance'] = ResolversParentTypes['PatientAccountBalance']> = {
  amountDue?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Maybe<Array<ResolversTypes['LineItem']>>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientCoverageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientCoverage'] = ResolversParentTypes['PatientCoverage']> = {
  copay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PatientCoverageStatus'], ParentType, ContextType>;
  subscriberNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PatientDemographicsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientDemographics'] = ResolversParentTypes['PatientDemographics']> = {
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PatientIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PatientId'], any> {
  name: 'PatientId';
}

export type PatientMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientMutations'] = ResolversParentTypes['PatientMutations']> = {
  addAcknowledgements?: Resolver<Maybe<Array<ResolversTypes['Acknowledgement']>>, ParentType, ContextType, RequireFields<PatientMutationsAddAcknowledgementsArgs, 'acknowledgements'>>;
  addCoverageFromName?: Resolver<Maybe<ResolversTypes['PatientCoverage']>, ParentType, ContextType, RequireFields<PatientMutationsAddCoverageFromNameArgs, 'patientId' | 'payerName' | 'subscriberNumber'>>;
  cancelOpenLoopVisit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<PatientMutationsCancelOpenLoopVisitArgs, 'surgeryId'>>;
  create?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PatientMutationsCreateArgs, 'patient'>>;
  deleteDocument?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<PatientMutationsDeleteDocumentArgs, 'id'>>;
  refreshHie?: Resolver<Maybe<ResolversTypes['PatientHieRefreshResponse']>, ParentType, ContextType, RequireFields<PatientMutationsRefreshHieArgs, 'id'>>;
  registerPatient?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PatientMutationsRegisterPatientArgs, 'request'>>;
  scheduleOpenLoopVisit?: Resolver<Maybe<ResolversTypes['OpenLoopVisitScheduleResult']>, ParentType, ContextType, RequireFields<PatientMutationsScheduleOpenLoopVisitArgs, 'surgeryId'>>;
  scheduleVisit?: Resolver<Maybe<ResolversTypes['Visit']>, ParentType, ContextType, RequireFields<PatientMutationsScheduleVisitArgs, 'visitParams'>>;
  send2faMessage?: Resolver<Maybe<ResolversTypes['PatientId']>, ParentType, ContextType, RequireFields<PatientMutationsSend2faMessageArgs, 'dob' | 'patientId' | 'phone'>>;
  sendESignLinkMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<PatientMutationsSendESignLinkMessageArgs, 'surgeryId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payer'] = ResolversParentTypes['Payer']> = {
  attachment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  claims_1500?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dent_claims?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eligibility?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  era?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payer_alt_names?: Resolver<Maybe<Array<Maybe<ResolversTypes['AltPayerName']>>>, ParentType, ContextType>;
  payer_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payer_state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payer_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payerid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondary_support?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ub_claims?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workers_comp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PayerIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PayerId'], any> {
  name: 'PayerId';
}

export interface PhoneNumberScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PhoneNumber'], any> {
  name: 'PhoneNumber';
}

export type PlaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Place'] = ResolversParentTypes['Place']> = {
  getAddress?: Resolver<Maybe<Array<ResolversTypes['GooglePlace']>>, ParentType, ContextType, RequireFields<PlaceGetAddressArgs, 'query'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface PlatformThreadIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['PlatformThreadId'], any> {
  name: 'PlatformThreadId';
}

export type PointOfContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['PointOfContact'] = ResolversParentTypes['PointOfContact']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  isPrimary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roleAssignmentId?: Resolver<Maybe<ResolversTypes['RoleAssignmentId']>, ParentType, ContextType>;
  targetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessStepMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessStepMutations'] = ResolversParentTypes['ProcessStepMutations']> = {
  createProcessStepState?: Resolver<Maybe<ResolversTypes['ProcessStepState']>, ParentType, ContextType, RequireFields<ProcessStepMutationsCreateProcessStepStateArgs, 'createStepState'>>;
  updateProcessStepState?: Resolver<Maybe<ResolversTypes['ProcessStepState']>, ParentType, ContextType, RequireFields<ProcessStepMutationsUpdateProcessStepStateArgs, 'updateStepState'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessStepStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessStepState'] = ResolversParentTypes['ProcessStepState']> = {
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isVirtual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastTransitionAt?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  lastTransitionBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ProcessStepStatus'], ParentType, ContextType>;
  transitionType?: Resolver<Maybe<ResolversTypes['StateTransitionType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProcessTrackerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProcessTracker'] = ResolversParentTypes['ProcessTracker']> = {
  completed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inProgress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  steps?: Resolver<Maybe<Array<ResolversTypes['ProcessStepState']>>, ParentType, ContextType>;
  todo?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromptChatResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromptChatResponse'] = ResolversParentTypes['PromptChatResponse']> = {
  completion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentContext?: Resolver<Array<ResolversTypes['Document']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProviderMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderMutations'] = ResolversParentTypes['ProviderMutations']> = {
  addCompletedVisit?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderMutationsAddCompletedVisitArgs, 'surgeryId'>>;
  changeUserStatus?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<ProviderMutationsChangeUserStatusArgs, 'id' | 'status'>>;
  editUserInfo?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<ProviderMutationsEditUserInfoArgs, 'user'>>;
  generateS3Files?: Resolver<Maybe<Array<ResolversTypes['Document']>>, ParentType, ContextType, RequireFields<ProviderMutationsGenerateS3FilesArgs, 'files' | 'patientId'>>;
  initiatePasswordReset?: Resolver<Maybe<ResolversTypes['InitiatePasswordResetResponse']>, ParentType, ContextType, RequireFields<ProviderMutationsInitiatePasswordResetArgs, 'email'>>;
  inviteUser?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderMutationsInviteUserArgs, 'user'>>;
  login?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<ProviderMutationsLoginArgs, 'credentials'>>;
  markVisitCompleted?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderMutationsMarkVisitCompletedArgs, 'surgeryId'>>;
  registerSurgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<ProviderMutationsRegisterSurgeryArgs, 'surgery'>>;
  resetLogin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<ProviderMutationsResetLoginArgs, 'email' | 'newPassword' | 'resetCode'>>;
  sendSurgeryMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<ProviderMutationsSendSurgeryMessageArgs, 'content' | 'surgeryId'>>;
  updateLastMessageRead?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderMutationsUpdateLastMessageReadArgs, 'platformThreadId'>>;
  updatePatient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType, RequireFields<ProviderMutationsUpdatePatientArgs, 'patient'>>;
  updateSurgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<ProviderMutationsUpdateSurgeryArgs, 'surgery'>>;
  updateSurgeryArchivedStatus?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<ProviderMutationsUpdateSurgeryArchivedStatusArgs, 'updateSurgery'>>;
  updateVisitStatus?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderMutationsUpdateVisitStatusArgs, 'id' | 'status'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProviderOperationsMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderOperationsMutations'] = ResolversParentTypes['ProviderOperationsMutations']> = {
  associateFaxWithSurgery?: Resolver<Maybe<ResolversTypes['Fax']>, ParentType, ContextType, RequireFields<ProviderOperationsMutationsAssociateFaxWithSurgeryArgs, 'input'>>;
  bulkUpload?: Resolver<Maybe<ResolversTypes['BulkUploadMutations']>, ParentType, ContextType>;
  generateUploadUploadUrls?: Resolver<Maybe<Array<ResolversTypes['SignedS3UploadUrl']>>, ParentType, ContextType, RequireFields<ProviderOperationsMutationsGenerateUploadUploadUrlsArgs, 'files'>>;
  initiateFax?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderOperationsMutationsInitiateFaxArgs, 'input'>>;
  insertFaxContact?: Resolver<Maybe<ResolversTypes['Contact']>, ParentType, ContextType, RequireFields<ProviderOperationsMutationsInsertFaxContactArgs, 'input'>>;
  logEvent?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderOperationsMutationsLogEventArgs, 'eventInput'>>;
  resendFax?: Resolver<Maybe<ResolversTypes['Query']>, ParentType, ContextType, RequireFields<ProviderOperationsMutationsResendFaxArgs, 'faxId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  aiAssessment?: Resolver<Maybe<ResolversTypes['AiAssessment']>, ParentType, ContextType, RequireFields<QueryAiAssessmentArgs, 'patientId'>>;
  condition?: Resolver<Maybe<ResolversTypes['Condition']>, ParentType, ContextType, RequireFields<QueryConditionArgs, 'conditionId'>>;
  confirmESign?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryConfirmESignArgs, 'patientId'>>;
  contacts?: Resolver<Maybe<Array<ResolversTypes['Contact']>>, ParentType, ContextType, Partial<QueryContactsArgs>>;
  document?: Resolver<Maybe<ResolversTypes['Document']>, ParentType, ContextType, RequireFields<QueryDocumentArgs, 'id'>>;
  events?: Resolver<Maybe<Array<ResolversTypes['EventLog']>>, ParentType, ContextType, RequireFields<QueryEventsArgs, 'eventContextId' | 'type'>>;
  facilities?: Resolver<Maybe<Array<ResolversTypes['Facility']>>, ParentType, ContextType>;
  fail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['Fax']>, ParentType, ContextType, RequireFields<QueryFaxArgs, 'id'>>;
  faxes?: Resolver<Maybe<Array<ResolversTypes['Fax']>>, ParentType, ContextType, Partial<QueryFaxesArgs>>;
  getClinicalReviewCodingCopy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetClinicalReviewCodingCopyArgs, 'surgeryId'>>;
  getOpenLoopPreChartV2ShadowNoteEditLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetOpenLoopPreChartV2ShadowNoteEditLinkArgs, 'surgeryId'>>;
  getOpenLoopPrivateNoteEditLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetOpenLoopPrivateNoteEditLinkArgs, 'surgeryId'>>;
  getOpenLoopViabilityStatus?: Resolver<Maybe<ResolversTypes['OpenLoopViabilityStatus']>, ParentType, ContextType, RequireFields<QueryGetOpenLoopViabilityStatusArgs, 'surgeryId'>>;
  getOpsPatientIntakeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryGetOpsPatientIntakeUrlArgs>>;
  getPatientFromMedicalRecordNumber?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType, RequireFields<QueryGetPatientFromMedicalRecordNumberArgs, 'medicalRecordNumber'>>;
  getPatientIdFromSurgeryId?: Resolver<Maybe<ResolversTypes['PatientId']>, ParentType, ContextType, RequireFields<QueryGetPatientIdFromSurgeryIdArgs, 'surgeryId'>>;
  getPatientIntakeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<QueryGetPatientIntakeUrlArgs>>;
  hiePullStatus?: Resolver<Maybe<ResolversTypes['HieJob']>, ParentType, ContextType, RequireFields<QueryHiePullStatusArgs, 'patientId'>>;
  impersonator?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  ingestionJob?: Resolver<Maybe<ResolversTypes['IngestionJob']>, ParentType, ContextType, RequireFields<QueryIngestionJobArgs, 'jobId'>>;
  intakeProcessStatus?: Resolver<Maybe<ResolversTypes['IntakeProgressStatus']>, ParentType, ContextType, RequireFields<QueryIntakeProcessStatusArgs, 'surgeryId'>>;
  labRequirements?: Resolver<Maybe<Array<Maybe<ResolversTypes['LabRequirement']>>>, ParentType, ContextType, RequireFields<QueryLabRequirementsArgs, 'surgeryId'>>;
  labRequirementsByTargetId?: Resolver<Maybe<Array<Maybe<ResolversTypes['LabRequirement']>>>, ParentType, ContextType, RequireFields<QueryLabRequirementsByTargetIdArgs, 'targetId'>>;
  medication?: Resolver<Maybe<ResolversTypes['Medication']>, ParentType, ContextType, RequireFields<QueryMedicationArgs, 'medicationId'>>;
  medicationSearch?: Resolver<Array<ResolversTypes['Medication']>, ParentType, ContextType, RequireFields<QueryMedicationSearchArgs, 'search'>>;
  observations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Observation']>>>, ParentType, ContextType, RequireFields<QueryObservationsArgs, 'patientId'>>;
  orchestraLabRequirements?: Resolver<Maybe<Array<Maybe<ResolversTypes['LabRequirement']>>>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType, Partial<QueryOrganizationArgs>>;
  organizations?: Resolver<Maybe<Array<ResolversTypes['Organization']>>, ParentType, ContextType, Partial<QueryOrganizationsArgs>>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType, Partial<QueryPatientArgs>>;
  patientMedicationInstructions?: Resolver<Array<ResolversTypes['CaseInstruction']>, ParentType, ContextType, RequireFields<QueryPatientMedicationInstructionsArgs, 'patientId'>>;
  patientMedications?: Resolver<Array<ResolversTypes['Medication']>, ParentType, ContextType, RequireFields<QueryPatientMedicationsArgs, 'patientId'>>;
  patients?: Resolver<Maybe<Array<ResolversTypes['Patient']>>, ParentType, ContextType>;
  ping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  preopClinicalPacket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryPreopClinicalPacketArgs, 'refresh' | 'surgeryId'>>;
  processTracker?: Resolver<Maybe<ResolversTypes['ProcessTracker']>, ParentType, ContextType, RequireFields<QueryProcessTrackerArgs, 'surgeryId'>>;
  riskAssessment?: Resolver<Maybe<ResolversTypes['RiskAssessment']>, ParentType, ContextType, RequireFields<QueryRiskAssessmentArgs, 'patientId'>>;
  riskAssessments?: Resolver<Maybe<Array<ResolversTypes['RiskAssessment']>>, ParentType, ContextType>;
  roleAssignments?: Resolver<Maybe<Array<ResolversTypes['RoleAssignment']>>, ParentType, ContextType, RequireFields<QueryRoleAssignmentsArgs, 'options'>>;
  sessionInfo?: Resolver<Maybe<ResolversTypes['SessionInfo']>, ParentType, ContextType>;
  static?: Resolver<Maybe<ResolversTypes['Static']>, ParentType, ContextType>;
  studyTracking?: Resolver<Maybe<ResolversTypes['StudyTrackingState']>, ParentType, ContextType, RequireFields<QueryStudyTrackingArgs, 'surgeryId'>>;
  surgeries?: Resolver<Maybe<Array<ResolversTypes['Surgery']>>, ParentType, ContextType, Partial<QuerySurgeriesArgs>>;
  surgeriesPaginated?: Resolver<Maybe<ResolversTypes['PaginatedSurgeries']>, ParentType, ContextType, RequireFields<QuerySurgeriesPaginatedArgs, 'pageInfo'>>;
  surgeriesSummary?: Resolver<Maybe<ResolversTypes['SurgeriesSummary']>, ParentType, ContextType, RequireFields<QuerySurgeriesSummaryArgs, 'filterCriteria'>>;
  surgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType, RequireFields<QuerySurgeryArgs, 'id'>>;
  task?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<QueryTaskArgs, 'id'>>;
  tasks?: Resolver<Maybe<Array<ResolversTypes['Task']>>, ParentType, ContextType, RequireFields<QueryTasksArgs, 'options'>>;
  tasksPaginated?: Resolver<Maybe<ResolversTypes['PaginatedTasks']>, ParentType, ContextType, RequireFields<QueryTasksPaginatedArgs, 'options' | 'pageInfo'>>;
  time?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  translation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryTranslationArgs, 'language' | 'message' | 'patientId'>>;
  unboundFaxes?: Resolver<Maybe<Array<ResolversTypes['Fax']>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, Partial<QueryUserArgs>>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, Partial<QueryUsersArgs>>;
  usersResponsibleForSurgery?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUsersResponsibleForSurgeryArgs, 'surgeryId'>>;
  visitSlots?: Resolver<Maybe<Array<ResolversTypes['VisitSlot']>>, ParentType, ContextType, RequireFields<QueryVisitSlotsArgs, 'type'>>;
  visits?: Resolver<Array<ResolversTypes['Visit']>, ParentType, ContextType, Partial<QueryVisitsArgs>>;
};

export type RedFlagResolvers<ContextType = any, ParentType extends ResolversParentTypes['RedFlag'] = ResolversParentTypes['RedFlag']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentId?: Resolver<ResolversTypes['DocumentId'], ParentType, ContextType>;
  documentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  evidenceDate?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  evidenceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  evidenceValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noteDate?: Resolver<Maybe<ResolversTypes['DateString']>, ParentType, ContextType>;
  observationCodes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskAssessmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskAssessment'] = ResolversParentTypes['RiskAssessment']> = {
  cardiologyClearance?: Resolver<Maybe<ResolversTypes['ClearanceStatus']>, ParentType, ContextType>;
  clearanceRiskLevel?: Resolver<ResolversTypes['ClearanceRiskLevel'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  intakeRiskAssessment?: Resolver<Maybe<ResolversTypes['ClearanceStatus']>, ParentType, ContextType>;
  labs?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medicalClearance?: Resolver<Maybe<ResolversTypes['ClearanceStatus']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<Maybe<ResolversTypes['PatientId']>, ParentType, ContextType>;
  priorAuth?: Resolver<Maybe<ResolversTypes['ClearanceStatus']>, ParentType, ContextType>;
  specialtyClearance?: Resolver<Maybe<ResolversTypes['ClearanceStatus']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ClearanceStatus'], ParentType, ContextType>;
  surgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType>;
  surgeryId?: Resolver<Maybe<ResolversTypes['SurgeryId']>, ParentType, ContextType>;
  surgicalRiskLevel?: Resolver<ResolversTypes['ClearanceRiskLevel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskAssessmentMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskAssessmentMutations'] = ResolversParentTypes['RiskAssessmentMutations']> = {
  aiPreChart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsAiPreChartArgs, 'surgeryId'>>;
  aiRiskAssessment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsAiRiskAssessmentArgs, 'surgeryId'>>;
  preChartDocuments?: Resolver<Array<Maybe<ResolversTypes['Document']>>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsPreChartDocumentsArgs, 'documentIds'>>;
  promptChat?: Resolver<Maybe<ResolversTypes['PromptChatResponse']>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsPromptChatArgs, 'prompt' | 'surgeryId'>>;
  redFlagSearch?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RiskAssessmentMutationsRedFlagSearchArgs, 'documentId'>>;
  triageDocuments?: Resolver<Array<Maybe<ResolversTypes['Document']>>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsTriageDocumentsArgs, 'documentIds'>>;
  updateRiskAssessment?: Resolver<Maybe<ResolversTypes['RiskAssessment']>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsUpdateRiskAssessmentArgs, 'riskAssessment'>>;
  updateRiskAssessmentClearanceLevel?: Resolver<Maybe<ResolversTypes['RiskAssessment']>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsUpdateRiskAssessmentClearanceLevelArgs, 'clearanceLevel'>>;
  updateSurgicalRiskLevel?: Resolver<Maybe<ResolversTypes['RiskAssessment']>, ParentType, ContextType, RequireFields<RiskAssessmentMutationsUpdateSurgicalRiskLevelArgs, 'surgicalRiskLevel'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleAssignment'] = ResolversParentTypes['RoleAssignment']> = {
  id?: Resolver<ResolversTypes['RoleAssignmentId'], ParentType, ContextType>;
  isAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrimary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['RoleType'], ParentType, ContextType>;
  targetId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetType?: Resolver<ResolversTypes['TargetType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['UserId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface RoleAssignmentIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['RoleAssignmentId'], any> {
  name: 'RoleAssignmentId';
}

export type RoleAssignmentMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleAssignmentMutations'] = ResolversParentTypes['RoleAssignmentMutations']> = {
  insertRole?: Resolver<Maybe<ResolversTypes['RoleAssignment']>, ParentType, ContextType, RequireFields<RoleAssignmentMutationsInsertRoleArgs, 'roleAssignment'>>;
  sendPreopPacket?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<RoleAssignmentMutationsSendPreopPacketArgs, 'roleIds' | 'surgeryId'>>;
  updateRole?: Resolver<Maybe<ResolversTypes['RoleAssignment']>, ParentType, ContextType, RequireFields<RoleAssignmentMutationsUpdateRoleArgs, 'roleAssignment'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SessionInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SessionInfo'] = ResolversParentTypes['SessionInfo']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impersonator?: Resolver<Maybe<ResolversTypes['SessionInfo']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['OrganizationId']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface SignedS3DownloadUrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SignedS3DownloadUrl'], any> {
  name: 'SignedS3DownloadUrl';
}

export interface SignedS3UploadUrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SignedS3UploadUrl'], any> {
  name: 'SignedS3UploadUrl';
}

export type StaticResolvers<ContextType = any, ParentType extends ResolversParentTypes['Static'] = ResolversParentTypes['Static']> = {
  payers?: Resolver<Maybe<Array<ResolversTypes['Payer']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Study'] = ResolversParentTypes['Study']> = {
  boundingBox?: Resolver<Maybe<ResolversTypes['BoundingBox']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateInfo?: Resolver<Maybe<ResolversTypes['DateInfo']>, ParentType, ContextType>;
  datePerformed?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  observations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ObservationValue']>>>, ParentType, ContextType>;
  pageEnd?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageStart?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reconciliationStatus?: Resolver<Maybe<ResolversTypes['ReconciliationStatus']>, ParentType, ContextType>;
  requirement?: Resolver<Maybe<ResolversTypes['LabRequirement']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StudyTrackingStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['StudyTrackingState'] = ResolversParentTypes['StudyTrackingState']> = {
  faxResponseVerifications?: Resolver<Array<ResolversTypes['FaxResponseVerificationResult']>, ParentType, ContextType>;
  labRequirements?: Resolver<Maybe<Array<ResolversTypes['LabRequirement']>>, ParentType, ContextType>;
  observations?: Resolver<Maybe<Array<ResolversTypes['Observation']>>, ParentType, ContextType>;
  studyState?: Resolver<ResolversTypes['StudyState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  browserNotification?: SubscriptionResolver<Maybe<ResolversTypes['BrowserNotification']>, "browserNotification", ParentType, ContextType, Partial<SubscriptionBrowserNotificationArgs>>;
  patientSMSMessage?: SubscriptionResolver<Maybe<ResolversTypes['Message']>, "patientSMSMessage", ParentType, ContextType, Partial<SubscriptionPatientSmsMessageArgs>>;
  ping?: SubscriptionResolver<Maybe<ResolversTypes['String']>, "ping", ParentType, ContextType>;
  platformMessage?: SubscriptionResolver<Maybe<ResolversTypes['Message']>, "platformMessage", ParentType, ContextType, Partial<SubscriptionPlatformMessageArgs>>;
  surgery?: SubscriptionResolver<Maybe<ResolversTypes['Surgery']>, "surgery", ParentType, ContextType, Partial<SubscriptionSurgeryArgs>>;
  task?: SubscriptionResolver<Maybe<ResolversTypes['Task']>, "task", ParentType, ContextType, Partial<SubscriptionTaskArgs>>;
};

export type SurgeriesSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SurgeriesSummary'] = ResolversParentTypes['SurgeriesSummary']> = {
  clearedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inProgressCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  noDosCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  noVisitCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  notClearedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurgeryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Surgery'] = ResolversParentTypes['Surgery']> = {
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  assessment?: Resolver<Maybe<ResolversTypes['RiskAssessment']>, ParentType, ContextType>;
  careTeam?: Resolver<Array<ResolversTypes['CareTeamMember']>, ParentType, ContextType>;
  clearanceDocumentsSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  clearanceDocumentsSentAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  dateOfService?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<Array<ResolversTypes['Document']>>, ParentType, ContextType>;
  externalNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  facility?: Resolver<Maybe<ResolversTypes['Facility']>, ParentType, ContextType>;
  facilityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['SurgeryId'], ParentType, ContextType>;
  instructions?: Resolver<Array<ResolversTypes['CaseInstruction']>, ParentType, ContextType, Partial<SurgeryInstructionsArgs>>;
  instructionsSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, Partial<SurgeryMessagesArgs>>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  platformMessages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, Partial<SurgeryPlatformMessagesArgs>>;
  pointsOfContact?: Resolver<Array<ResolversTypes['PointOfContact']>, ParentType, ContextType>;
  recommendedCareSetting?: Resolver<Maybe<ResolversTypes['RecommendedCareSetting']>, ParentType, ContextType>;
  referredOn?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  referrer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  riskAssessmentAvailability?: Resolver<ResolversTypes['RiskAssessmentAvailability'], ParentType, ContextType>;
  schedulingLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<SurgerySchedulingLinkArgs, 'visitType'>>;
  stakeholders?: Resolver<Maybe<Array<ResolversTypes['Organization']>>, ParentType, ContextType, Partial<SurgeryStakeholdersArgs>>;
  studyTracking?: Resolver<Maybe<ResolversTypes['StudyTrackingState']>, ParentType, ContextType>;
  surgeon?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  surgeonId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surgeonName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  surgeryType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  threadId?: Resolver<Maybe<ResolversTypes['PlatformThreadId']>, ParentType, ContextType>;
  unreadPlatformMessages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visits?: Resolver<Array<ResolversTypes['Visit']>, ParentType, ContextType, Partial<SurgeryVisitsArgs>>;
  workflow?: Resolver<Maybe<ResolversTypes['SurgeryWorkflow']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface SurgeryIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['SurgeryId'], any> {
  name: 'SurgeryId';
}

export type SymptomsAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['SymptomsAnswer'] = ResolversParentTypes['SymptomsAnswer']> = {
  answer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  symptoms?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['Task'] = ResolversParentTypes['Task']> = {
  assigneeId?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  authorId?: Resolver<ResolversTypes['UserId'], ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dueDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['TaskId'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['OrganizationId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TaskStatus'], ParentType, ContextType>;
  surgeryId?: Resolver<ResolversTypes['SurgeryId'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTimeString'], ParentType, ContextType>;
  viewedByAssignee?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TaskIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TaskId'], any> {
  name: 'TaskId';
}

export type TaskMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskMutations'] = ResolversParentTypes['TaskMutations']> = {
  insertTask?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<TaskMutationsInsertTaskArgs, 'task'>>;
  markTaskViewed?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<TaskMutationsMarkTaskViewedArgs, 'id'>>;
  updateTask?: Resolver<Maybe<ResolversTypes['Task']>, ParentType, ContextType, RequireFields<TaskMutationsUpdateTaskArgs, 'task'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextAnswer'] = ResolversParentTypes['TextAnswer']> = {
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransformIngestionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransformIngestionResult'] = ResolversParentTypes['TransformIngestionResult']> = {
  resultBucket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resultKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rows?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  totalDataRowCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadIngestionFileResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadIngestionFileResponse'] = ResolversParentTypes['UploadIngestionFileResponse']> = {
  jobId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UserId'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['OrganizationId'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['UserType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UserIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UserId'], any> {
  name: 'UserId';
}

export type VisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['Visit'] = ResolversParentTypes['Visit']> = {
  cancelUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  copayStatus?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  foreignId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['VisitId'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['PatientId'], ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  providerId?: Resolver<Maybe<ResolversTypes['UserId']>, ParentType, ContextType>;
  rescheduleUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['VisitStatus'], ParentType, ContextType>;
  surgery?: Resolver<Maybe<ResolversTypes['Surgery']>, ParentType, ContextType>;
  surgeryId?: Resolver<Maybe<ResolversTypes['SurgeryId']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface VisitIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['VisitId'], any> {
  name: 'VisitId';
}

export type VisitSlotResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitSlot'] = ResolversParentTypes['VisitSlot']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheduleUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['VisitType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Acknowledgement?: AcknowledgementResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  AddressId?: GraphQLScalarType;
  AiAssessment?: AiAssessmentResolvers<ContextType>;
  AiRiskAssessment?: AiRiskAssessmentResolvers<ContextType>;
  AltPayerName?: AltPayerNameResolvers<ContextType>;
  Anesthesia?: AnesthesiaResolvers<ContextType>;
  AuthMutations?: AuthMutationsResolvers<ContextType>;
  AuthorizedPatientMutations?: AuthorizedPatientMutationsResolvers<ContextType>;
  BodilyMedicalDevies?: BodilyMedicalDeviesResolvers<ContextType>;
  BooleanAnswer?: BooleanAnswerResolvers<ContextType>;
  BoundingBox?: BoundingBoxResolvers<ContextType>;
  BrowserNotification?: BrowserNotificationResolvers<ContextType>;
  BulkUploadMutations?: BulkUploadMutationsResolvers<ContextType>;
  CanvasHpIngestResult?: CanvasHpIngestResultResolvers<ContextType>;
  CareTeamMember?: CareTeamMemberResolvers<ContextType>;
  CaseInstruction?: CaseInstructionResolvers<ContextType>;
  CaseInstructionId?: GraphQLScalarType;
  Condition?: ConditionResolvers<ContextType>;
  ConditionId?: GraphQLScalarType;
  ConditionMutations?: ConditionMutationsResolvers<ContextType>;
  Contact?: ContactResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateInfo?: DateInfoResolvers<ContextType>;
  DateString?: GraphQLScalarType;
  DateTimeString?: GraphQLScalarType;
  Diabetes?: DiabetesResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentAnalysis?: DocumentAnalysisResolvers<ContextType>;
  DocumentAnalysisId?: GraphQLScalarType;
  DocumentId?: GraphQLScalarType;
  DocumentMutations?: DocumentMutationsResolvers<ContextType>;
  DocumentOCRAnalysis?: DocumentOcrAnalysisResolvers<ContextType>;
  EventLog?: EventLogResolvers<ContextType>;
  EventLogId?: GraphQLScalarType;
  Facility?: FacilityResolvers<ContextType>;
  Fax?: FaxResolvers<ContextType>;
  FaxId?: GraphQLScalarType;
  FaxResponseRequestedItemVerification?: FaxResponseRequestedItemVerificationResolvers<ContextType>;
  FaxResponseVerificationResult?: FaxResponseVerificationResultResolvers<ContextType>;
  GenerateUploadUrlsResponse?: GenerateUploadUrlsResponseResolvers<ContextType>;
  GooglePlace?: GooglePlaceResolvers<ContextType>;
  HeartProblems?: HeartProblemsResolvers<ContextType>;
  HieJob?: HieJobResolvers<ContextType>;
  HieServiceProvider?: HieServiceProviderResolvers<ContextType>;
  IngestionJob?: IngestionJobResolvers<ContextType>;
  IngestionUploadUrl?: IngestionUploadUrlResolvers<ContextType>;
  InitiatePasswordResetResponse?: InitiatePasswordResetResponseResolvers<ContextType>;
  IntakeProgressStatus?: IntakeProgressStatusResolvers<ContextType>;
  IntakeQuestionaire?: IntakeQuestionaireResolvers<ContextType>;
  InternalSurgeryMutations?: InternalSurgeryMutationsResolvers<ContextType>;
  LabRequirement?: LabRequirementResolvers<ContextType>;
  LabRequirementId?: GraphQLScalarType;
  LabRequirementMutations?: LabRequirementMutationsResolvers<ContextType>;
  LineItem?: LineItemResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  Medication?: MedicationResolvers<ContextType>;
  MedicationId?: GraphQLScalarType;
  MedicationInstruction?: MedicationInstructionResolvers<ContextType>;
  MedicationInstructionId?: GraphQLScalarType;
  MedicationMutations?: MedicationMutationsResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageId?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  NeurologicalDisorder?: NeurologicalDisorderResolvers<ContextType>;
  Observation?: ObservationResolvers<ContextType>;
  ObservationId?: GraphQLScalarType;
  ObservationMutations?: ObservationMutationsResolvers<ContextType>;
  ObservationValue?: ObservationValueResolvers<ContextType>;
  OpenLoopViabilityStatus?: OpenLoopViabilityStatusResolvers<ContextType>;
  OpenLoopVisitScheduleResult?: OpenLoopVisitScheduleResultResolvers<ContextType>;
  OrchestraOperations?: OrchestraOperationsResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationFeatures?: OrganizationFeaturesResolvers<ContextType>;
  OrganizationId?: GraphQLScalarType;
  PageInfo?: PageInfoResolvers<ContextType>;
  PaginatedSurgeries?: PaginatedSurgeriesResolvers<ContextType>;
  PaginatedTasks?: PaginatedTasksResolvers<ContextType>;
  Patient?: PatientResolvers<ContextType>;
  PatientAccountBalance?: PatientAccountBalanceResolvers<ContextType>;
  PatientCoverage?: PatientCoverageResolvers<ContextType>;
  PatientDemographics?: PatientDemographicsResolvers<ContextType>;
  PatientId?: GraphQLScalarType;
  PatientMutations?: PatientMutationsResolvers<ContextType>;
  Payer?: PayerResolvers<ContextType>;
  PayerId?: GraphQLScalarType;
  PhoneNumber?: GraphQLScalarType;
  Place?: PlaceResolvers<ContextType>;
  PlatformThreadId?: GraphQLScalarType;
  PointOfContact?: PointOfContactResolvers<ContextType>;
  ProcessStepMutations?: ProcessStepMutationsResolvers<ContextType>;
  ProcessStepState?: ProcessStepStateResolvers<ContextType>;
  ProcessTracker?: ProcessTrackerResolvers<ContextType>;
  PromptChatResponse?: PromptChatResponseResolvers<ContextType>;
  ProviderMutations?: ProviderMutationsResolvers<ContextType>;
  ProviderOperationsMutations?: ProviderOperationsMutationsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RedFlag?: RedFlagResolvers<ContextType>;
  RiskAssessment?: RiskAssessmentResolvers<ContextType>;
  RiskAssessmentMutations?: RiskAssessmentMutationsResolvers<ContextType>;
  RoleAssignment?: RoleAssignmentResolvers<ContextType>;
  RoleAssignmentId?: GraphQLScalarType;
  RoleAssignmentMutations?: RoleAssignmentMutationsResolvers<ContextType>;
  SessionInfo?: SessionInfoResolvers<ContextType>;
  SignedS3DownloadUrl?: GraphQLScalarType;
  SignedS3UploadUrl?: GraphQLScalarType;
  Static?: StaticResolvers<ContextType>;
  Study?: StudyResolvers<ContextType>;
  StudyTrackingState?: StudyTrackingStateResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SurgeriesSummary?: SurgeriesSummaryResolvers<ContextType>;
  Surgery?: SurgeryResolvers<ContextType>;
  SurgeryId?: GraphQLScalarType;
  SymptomsAnswer?: SymptomsAnswerResolvers<ContextType>;
  Task?: TaskResolvers<ContextType>;
  TaskId?: GraphQLScalarType;
  TaskMutations?: TaskMutationsResolvers<ContextType>;
  TextAnswer?: TextAnswerResolvers<ContextType>;
  TransformIngestionResult?: TransformIngestionResultResolvers<ContextType>;
  UploadIngestionFileResponse?: UploadIngestionFileResponseResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserId?: GraphQLScalarType;
  Visit?: VisitResolvers<ContextType>;
  VisitId?: GraphQLScalarType;
  VisitSlot?: VisitSlotResolvers<ContextType>;
};


export type GetPatientIntakeFormQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientIntakeFormQuery = { __typename?: 'Query', token?: string | null, patients?: Array<{ __typename?: 'Patient', id: Api.PatientId, emrId: string, firstName: string, lastName: string, dob?: any | null, email?: string | null, intake?: { __typename?: 'IntakeQuestionaire', other: { __typename?: 'TextAnswer', answer: string }, endocrineDisorder: { __typename?: 'TextAnswer', answer: string }, immuneDisorders: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, bloodDisase: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, KidneyDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, liverDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, pulmonaryProblems: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, congestiveHeartFailure: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, neurologicalDisorder: { __typename?: 'NeurologicalDisorder', answer: boolean, description: string, lastStroke: string }, diabetes: { __typename?: 'Diabetes', answer: boolean, description: string, a1cLevel: number, areYouTakingInsulin: boolean }, bodilyMedicalDevies: { __typename?: 'BodilyMedicalDevies', deviceName: string, informationCard: boolean, deviceCheckedInLastYear: boolean }, heartProblems: { __typename?: 'HeartProblems', heartStents: boolean, bloodTinners: boolean, heartRhythmProblems: boolean, faintedInTheLastYear: boolean, canYouClimbTwoFlights: boolean }, anesthesia: { __typename?: 'Anesthesia', answer: boolean, whatType: string, pastProblems: string, issuesIntubating: boolean, malignantHyperthermia: boolean, spineProblems: boolean } } | null, documents: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> }> | null };

export type RiskAssessmentFragment = { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, status: ClearanceStatus, priorAuth?: ClearanceStatus | null, clearanceRiskLevel: ClearanceRiskLevel, surgicalRiskLevel: ClearanceRiskLevel, medicalClearance?: ClearanceStatus | null, intakeRiskAssessment?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null };

export type BasicSurgeryInfoFragment = { __typename?: 'Surgery', id: Api.SurgeryId, surgeonName: string, surgeryType: string, dateOfService?: any | null };

export type GetFullPatientQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['ID']>;
}>;


export type GetFullPatientQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, emrId: string, firstName: string, lastName: string, dob?: any | null, email?: string | null, riskAssessment?: { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, status: ClearanceStatus, priorAuth?: ClearanceStatus | null, clearanceRiskLevel: ClearanceRiskLevel, surgicalRiskLevel: ClearanceRiskLevel, medicalClearance?: ClearanceStatus | null, intakeRiskAssessment?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null } | null, upcomingSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeonName: string, surgeryType: string, dateOfService?: any | null } | null, intake?: { __typename?: 'IntakeQuestionaire', other: { __typename?: 'TextAnswer', answer: string }, endocrineDisorder: { __typename?: 'TextAnswer', answer: string }, immuneDisorders: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, bloodDisase: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, KidneyDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, liverDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, pulmonaryProblems: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, congestiveHeartFailure: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, neurologicalDisorder: { __typename?: 'NeurologicalDisorder', answer: boolean, description: string, lastStroke: string }, diabetes: { __typename?: 'Diabetes', answer: boolean, description: string, a1cLevel: number, areYouTakingInsulin: boolean }, bodilyMedicalDevies: { __typename?: 'BodilyMedicalDevies', deviceName: string, informationCard: boolean, deviceCheckedInLastYear: boolean }, heartProblems: { __typename?: 'HeartProblems', heartStents: boolean, bloodTinners: boolean, heartRhythmProblems: boolean, faintedInTheLastYear: boolean, canYouClimbTwoFlights: boolean }, anesthesia: { __typename?: 'Anesthesia', answer: boolean, whatType: string, pastProblems: string, issuesIntubating: boolean, malignantHyperthermia: boolean, spineProblems: boolean } } | null, documents: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> } | null };

export type ModifyRiskAssessmentDataFragment = { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, labs?: string | null, priorAuth?: ClearanceStatus | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeonId?: string | null, stakeholders?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string }> | null, careTeam: Array<{ __typename?: 'CareTeamMember', id: string, patientId: string, name: string, specialty: string, phone?: string | null, email?: string | null, fax?: string | null }> } | null };

export type GetRiskAssessmentStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskAssessmentStatusQuery = { __typename?: 'Query', riskAssessments?: Array<{ __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, labs?: string | null, priorAuth?: ClearanceStatus | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeonId?: string | null, stakeholders?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string }> | null, careTeam: Array<{ __typename?: 'CareTeamMember', id: string, patientId: string, name: string, specialty: string, phone?: string | null, email?: string | null, fax?: string | null }> } | null }> | null };

export type UpdateClearanceRiskLevelMutationVariables = Exact<{
  clearanceLevelUpdate: ClearanceLevelInput;
}>;


export type UpdateClearanceRiskLevelMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', updateRiskAssessmentClearanceLevel?: { __typename?: 'RiskAssessment', id: string, clearanceRiskLevel: ClearanceRiskLevel } | null } | null };

export type UpdateSurgicalRiskLevelMutationVariables = Exact<{
  surgicalRiskLevelUpdate: SurgicalRiskLevelInput;
}>;


export type UpdateSurgicalRiskLevelMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', updateSurgicalRiskLevel?: { __typename?: 'RiskAssessment', id: string, surgicalRiskLevel: ClearanceRiskLevel } | null } | null };

export type UpdateRiskAssessmentMutationVariables = Exact<{
  riskAssessment: RiskAssessmentInput;
}>;


export type UpdateRiskAssessmentMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', updateRiskAssessment?: { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, clearanceRiskLevel: ClearanceRiskLevel, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, labs?: string | null, priorAuth?: ClearanceStatus | null } | null } | null };

export type UpdateClearanceDocsSentMutationVariables = Exact<{
  surgery: UpdateSurgeryInput;
}>;


export type UpdateClearanceDocsSentMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, instructionsSent: boolean, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null } | null } | null };

export type SubmitIngestionMutationVariables = Exact<{
  input: UploadIngestionFileInput;
}>;


export type SubmitIngestionMutation = { __typename?: 'Mutation', orchestraOperations?: { __typename?: 'OrchestraOperations', uploadIngestionFile?: { __typename?: 'UploadIngestionFileResponse', success: boolean, messages: Array<string>, jobId?: string | null } | null } | null };

export type IngestionJobStatusQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type IngestionJobStatusQuery = { __typename?: 'Query', ingestionJob?: { __typename?: 'IngestionJob', id: string, status: IngestionJobStatus, totalRows: number, processedRows: number, errorCount: number, messages: Array<string>, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString } | null };

export type PromptMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  prompt: Scalars['String'];
  options?: InputMaybe<PromptChatOptions>;
}>;


export type PromptMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', promptChat?: { __typename?: 'PromptChatResponse', completion?: string | null, documentContext: Array<{ __typename?: 'Document', id: Api.DocumentId, name: string, type: FileType, url: string }> } | null } | null };

export type StagehandPatientsQueryVariables = Exact<{ [key: string]: never; }>;


export type StagehandPatientsQuery = { __typename?: 'Query', surgeries?: Array<{ __typename?: 'Surgery', id: Api.SurgeryId, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, externalHieUrl?: string | null } }> | null };

export type StageHandSurgeryFragment = { __typename?: 'Surgery', id: Api.SurgeryId, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, externalHieUrl?: string | null } };

export type StageHandPatientsFragment = { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, externalHieUrl?: string | null };

export type GetOrganizationInfoForFaxPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationInfoForFaxPageQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: Api.OrganizationId, name: string, faxNumber?: Api.PhoneNumber | null } | null };

export type LinkFaxWithSurgeryMutationVariables = Exact<{
  input: AssociateFaxWithSurgeryInput;
}>;


export type LinkFaxWithSurgeryMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', associateFaxWithSurgery?: { __typename?: 'Fax', id: Api.FaxId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, subject?: string | null, requestMetadata?: string | null, direction: FaxDirection, name: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, documentId?: Api.DocumentId | null, requestFaxId?: Api.FaxId | null, status: FaxStatus, from: Api.PhoneNumber, callerId?: string | null, to: Api.PhoneNumber, url: string, fromContact?: { __typename?: 'Contact', id: string, name: string } | null, toContact?: { __typename?: 'Contact', id: string, name: string } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string } | null } | null } | null };

export type SaveFaxContactMutationVariables = Exact<{
  input: FaxContactInput;
}>;


export type SaveFaxContactMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', insertFaxContact?: { __typename?: 'Contact', id: string, name: string, relation: string, phone?: string | null, fax?: string | null, email?: string | null } | null } | null };

export type ResendFaxMutationVariables = Exact<{
  faxId: Scalars['FaxId'];
  to?: InputMaybe<Scalars['PhoneNumber']>;
}>;


export type ResendFaxMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', resendFax?: { __typename?: 'Query', ping?: string | null } | null } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string }> };

export type ChangeUserStatusMutationVariables = Exact<{
  id: Scalars['UserId'];
  status: UserStatus;
}>;


export type ChangeUserStatusMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', changeUserStatus?: { __typename?: 'User', id: Api.UserId, status: UserStatus } | null } | null };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string, network: string, specialty: OrganizationSpecialty }> | null };

export type GetRiskAssessmentQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetRiskAssessmentQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', intake?: { __typename?: 'IntakeQuestionaire', other: { __typename?: 'TextAnswer', answer: string }, endocrineDisorder: { __typename?: 'TextAnswer', answer: string }, immuneDisorders: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, bloodDisase: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, KidneyDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, liverDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, pulmonaryProblems: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, congestiveHeartFailure: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, neurologicalDisorder: { __typename?: 'NeurologicalDisorder', answer: boolean, description: string, lastStroke: string }, diabetes: { __typename?: 'Diabetes', answer: boolean, description: string, a1cLevel: number, areYouTakingInsulin: boolean }, bodilyMedicalDevies: { __typename?: 'BodilyMedicalDevies', deviceName: string, informationCard: boolean, deviceCheckedInLastYear: boolean }, heartProblems: { __typename?: 'HeartProblems', heartStents: boolean, bloodTinners: boolean, heartRhythmProblems: boolean, faintedInTheLastYear: boolean, canYouClimbTwoFlights: boolean }, anesthesia: { __typename?: 'Anesthesia', answer: boolean, whatType: string, pastProblems: string, issuesIntubating: boolean, malignantHyperthermia: boolean, spineProblems: boolean } } | null, documents: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> } | null, riskAssessment?: { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, labs?: string | null, priorAuth?: ClearanceStatus | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, copayStatus: string }> } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeonId?: string | null, stakeholders?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string, specialty: OrganizationSpecialty }> | null, careTeam: Array<{ __typename?: 'CareTeamMember', id: string, patientId: string, name: string, specialty: string, phone?: string | null, email?: string | null, fax?: string | null }> } | null } | null };

export type GetPatientsForSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientsForSubmissionsQuery = { __typename?: 'Query', patients?: Array<{ __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, intake?: { __typename?: 'IntakeQuestionaire', id: string } | null }> | null };

export type UpdateCoverageFromNameMutationVariables = Exact<{
  patientId: Scalars['PatientId'];
  payerName: Scalars['String'];
  subscriberNumber: Scalars['String'];
  address: AddressInput;
}>;


export type UpdateCoverageFromNameMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', addCoverageFromName?: { __typename?: 'PatientCoverage', id: string, status: PatientCoverageStatus } | null } | null };

export type GetVisitQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetVisitQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, copay: number, copayStatus: string }> } | null };

export type GetVisitWithProviderQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetVisitWithProviderQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, copay: number, copayStatus: string, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> } | null };

export type GetPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetPatientQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, email?: string | null } | null };

export type RegisterPatientMutationVariables = Exact<{
  registerRequest: RegisterRequest;
}>;


export type RegisterPatientMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', registerPatient?: string | null } | null };

export type CreatePatientMutationVariables = Exact<{
  patient: PatientInput;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', create?: string | null } | null };

export type UploadIntakeQuestionaireMutationVariables = Exact<{
  intake: PatientIntakeQuestionaire;
}>;


export type UploadIntakeQuestionaireMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', intakeQuestionaire?: { __typename?: 'Query', ping?: string | null } | null } | null };

export type HealthcheckQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthcheckQuery = { __typename?: 'Query', ping?: string | null };

export type ScheduleVisitMutationVariables = Exact<{
  visitParams: VisitParams;
}>;


export type ScheduleVisitMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', scheduleVisit?: { __typename?: 'Visit', id: Api.VisitId, status: VisitStatus, date: any, foreignId?: string | null, copay: number, copayStatus: string } | null } | null };

export type RegisterPatientInfoQueryVariables = Exact<{
  type?: InputMaybe<VisitType>;
}>;


export type RegisterPatientInfoQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, intake?: { __typename?: 'IntakeQuestionaire', id: string } | null, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, copay: number, copayStatus: string }>, upcomingSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId } | null } | null };

export type RegisterCareTeamMutationVariables = Exact<{
  careTeam: Array<ContactInput> | ContactInput;
}>;


export type RegisterCareTeamMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', registerCareTeam?: Array<{ __typename?: 'Contact', id: string, name: string, relation: string }> | null } | null };

export type GetPayersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPayersQuery = { __typename?: 'Query', static?: { __typename?: 'Static', payers?: Array<{ __typename?: 'Payer', id: string, attachment?: string | null, workers_comp?: string | null, claims_1500?: string | null, payer_name?: string | null, ub_claims?: string | null, dent_claims?: string | null, payer_state?: string | null, secondary_support?: string | null, auto?: string | null, eligibility?: string | null, payer_type?: string | null, payerid?: string | null, era?: string | null, payer_alt_names?: Array<{ __typename?: 'AltPayerName', alt_payer_name?: string | null } | null> | null }> | null } | null };

export type GetOutstandingBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutstandingBalanceQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, outstandingBalance?: Array<{ __typename?: 'PatientAccountBalance', id: string, patientId: string, amountDue: number, lineItems?: Array<{ __typename?: 'LineItem', id: string, category: string, amount: number }> | null }> | null } | null };

export type GetPatientUploadUrlsMutationVariables = Exact<{
  files: Array<FileCandidate> | FileCandidate;
}>;


export type GetPatientUploadUrlsMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', generateS3Files?: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, name: string, type: FileType, url: string }> | null } | null };

export type UploadContentToFileMutationVariables = Exact<{
  file: SignaturesAoBandTicFileRequest;
  patientId: Scalars['PatientId'];
}>;


export type UploadContentToFileMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', uploadS3Content?: { __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, name: string, type: FileType, url: string } | null } | null };

export type RequestRecordFromContactMutationVariables = Exact<{
  careTeamMemberId: Scalars['String'];
}>;


export type RequestRecordFromContactMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', requestRecordFromCareTeamMember?: string | null } | null };

export type GetPatientDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientDocumentsQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', documents: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> } | null };

export type GetPatientPlanResponseFragment = { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, intake?: { __typename?: 'IntakeQuestionaire', id: string } | null, outstandingBalance?: Array<{ __typename?: 'PatientAccountBalance', id: string, amountDue: number }> | null, upcomingSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, dateOfService?: any | null, surgeonName: string, surgeryType: string } | null, careTeam: Array<{ __typename?: 'CareTeamMember', id: string, patientId: string, name: string, specialty: string, phone?: string | null, email?: string | null, fax?: string | null }>, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, type: VisitType }> };

export type GetPatientPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientPlanQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, intake?: { __typename?: 'IntakeQuestionaire', id: string } | null, outstandingBalance?: Array<{ __typename?: 'PatientAccountBalance', id: string, amountDue: number }> | null, upcomingSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, dateOfService?: any | null, surgeonName: string, surgeryType: string } | null, careTeam: Array<{ __typename?: 'CareTeamMember', id: string, patientId: string, name: string, specialty: string, phone?: string | null, email?: string | null, fax?: string | null }>, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, type: VisitType }> } | null };

export type DeleteDocumentMutationVariables = Exact<{
  deleteDocumentId: Scalars['ID'];
  patientId: Scalars['ID'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', deleteDocument?: { __typename?: 'Query', patient?: { __typename?: 'Patient', documents: Array<{ __typename?: 'Document', id: Api.DocumentId, name: string, type: FileType, url: string }> } | null } | null } | null };

export type UpdateDocumentNameMutationVariables = Exact<{
  updateDocumentNameId: Scalars['ID'];
  documentName: Scalars['String'];
}>;


export type UpdateDocumentNameMutation = { __typename?: 'Mutation', document?: { __typename?: 'DocumentMutations', updateDocumentName?: { __typename?: 'Document', id: Api.DocumentId, name: string } | null } | null };

export type AddCompletedVisitMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type AddCompletedVisitMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', addCompletedVisit?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, status: VisitStatus, date: any, foreignId?: string | null, copay: number, copayStatus: string }> } | null } | null } | null };

export type MarkVisitCompletedMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  visitId?: InputMaybe<Scalars['VisitId']>;
}>;


export type MarkVisitCompletedMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', markVisitCompleted?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, status: VisitStatus, date: any, foreignId?: string | null, copay: number, copayStatus: string }> } | null } | null } | null };

export type UpdateVisitStatusMutationVariables = Exact<{
  id: Scalars['SurgeryId'];
  status: VisitStatus;
  visitId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateVisitStatusMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateVisitStatus?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, status: VisitStatus, date: any, foreignId?: string | null, copay: number, copayStatus: string }> } | null } | null } | null };

export type InitiatePasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
  method?: InputMaybe<InitiatePasswordResetMethod>;
}>;


export type InitiatePasswordResetMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', initiatePasswordReset?: { __typename?: 'InitiatePasswordResetResponse', success: boolean, method: InitiatePasswordResetMethod, identifier: string } | null } | null };

export type InitiatePasswordResetResponseFragment = { __typename?: 'InitiatePasswordResetResponse', success: boolean, method: InitiatePasswordResetMethod, identifier: string };

export type ResetLoginMutationVariables = Exact<{
  email: Scalars['String'];
  resetCode: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ResetLoginMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', resetLogin?: string | null } | null };

export type GetOrganizationSchedulingLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationSchedulingLinkQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: Api.OrganizationId, schedulingLink?: string | null } | null };

export type GetVisitsQueryVariables = Exact<{
  type: VisitType;
  filter?: InputMaybe<VisitFilterOptions>;
}>;


export type GetVisitsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: Api.OrganizationId } | null, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, patientId: Api.PatientId, surgeryId?: Api.SurgeryId | null, type: VisitType, status: VisitStatus, date: any, providerId?: Api.UserId | null, foreignId?: string | null, rescheduleUrl?: string | null, cancelUrl?: string | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, url: string, dateOfService?: any | null, surgeryType: string, surgeonName: string, surgeon?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, email?: string | null, phone?: string | null } | null }>, visitSlots?: Array<{ __typename?: 'VisitSlot', id: string, date: any, type: VisitType, scheduleUrl: string }> | null };

export type ProviderVisitFragment = { __typename?: 'Visit', id: Api.VisitId, patientId: Api.PatientId, surgeryId?: Api.SurgeryId | null, type: VisitType, status: VisitStatus, date: any, providerId?: Api.UserId | null, foreignId?: string | null, rescheduleUrl?: string | null, cancelUrl?: string | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, url: string, dateOfService?: any | null, surgeryType: string, surgeonName: string, surgeon?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, email?: string | null, phone?: string | null } | null };

export type GetUsersForOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersForOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string }> } | null };

export type GetCaseMedicationInstructionsQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetCaseMedicationInstructionsQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', instructions: Array<{ __typename?: 'CaseInstruction', name: string, description: string, type: CaseInstructionType }> } | null };

export type SendESignLinkMessageMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  sendText?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendESignLinkMessageMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', sendESignLinkMessage?: string | null } | null };

export type ConfirmESignQueryVariables = Exact<{
  patientId: Scalars['PatientId'];
}>;


export type ConfirmESignQuery = { __typename?: 'Query', confirmESign?: boolean | null };

export type Send2faMessageMutationVariables = Exact<{
  patientId: Scalars['PatientId'];
  dob: Scalars['Date'];
  phone: Scalars['String'];
}>;


export type Send2faMessageMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', send2faMessage?: Api.PatientId | null } | null };

export type IntakeProcessStatusQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type IntakeProcessStatusQuery = { __typename?: 'Query', intakeProcessStatus?: { __typename?: 'IntakeProgressStatus', id?: string | null, intakeQLatestDate?: any | null, coverageLatestDate?: any | null, signaturesDate?: any | null, preopVisitDate?: any | null, visitCopayStatus?: string | null, visitCopay?: number | null, patientId?: Api.PatientId | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null };

export type AddCoverageMutationVariables = Exact<{
  patientId: Scalars['PatientId'];
  coverage: CoverageInput;
}>;


export type AddCoverageMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', addCoverage?: string | null } | null };

export type AddAddressMutationVariables = Exact<{
  patientId: Scalars['PatientId'];
  address: AddressInput;
}>;


export type AddAddressMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', addAddress?: string | null } | null };

export type ScheduleOpenLoopVisitMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  preferredTimeZone?: InputMaybe<Scalars['String']>;
}>;


export type ScheduleOpenLoopVisitMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', scheduleOpenLoopVisit?: { __typename?: 'OpenLoopVisitScheduleResult', conflict: boolean, visit?: { __typename?: 'Visit', id: Api.VisitId, status: VisitStatus, date: any, foreignId?: string | null, copay: number, copayStatus: string } | null } | null } | null };

export type ValidateAuthMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type ValidateAuthMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', validateAuth?: boolean | null } | null };

export type SetPreferredTimeZoneMutationVariables = Exact<{
  preferredTimeZone: Scalars['String'];
}>;


export type SetPreferredTimeZoneMutation = { __typename?: 'Mutation', authorizedPatient?: { __typename?: 'AuthorizedPatientMutations', setPreferredTimeZone?: boolean | null } | null };

export type GetPatientIdFromSurgeryIdQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetPatientIdFromSurgeryIdQuery = { __typename?: 'Query', getPatientIdFromSurgeryId?: Api.PatientId | null };

export type GetPreopClinicalPacketQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  refresh: Scalars['Boolean'];
}>;


export type GetPreopClinicalPacketQuery = { __typename?: 'Query', preopClinicalPacket?: string | null };

export type GetPatientContactInfoQueryVariables = Exact<{
  id: Scalars['SurgeryId'];
}>;


export type GetPatientContactInfoQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', dateOfService?: any | null, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, email?: string | null, phone?: string | null } } | null };

export type AcknowledgeDocumentsMutationVariables = Exact<{
  acknowledgements: Array<AcknowledgementInput> | AcknowledgementInput;
}>;


export type AcknowledgeDocumentsMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', addAcknowledgements?: Array<{ __typename?: 'Acknowledgement', patientId: Api.PatientId, docType: AcknowledgementDocType, acknowledgedAt: any, signature?: string | null, mfaCode?: string | null }> | null } | null };

export type CancelOpenLoopVisitMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type CancelOpenLoopVisitMutation = { __typename?: 'Mutation', patient?: { __typename?: 'PatientMutations', cancelOpenLoopVisit?: boolean | null } | null };

export type GetOrganizationProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationProvidersQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'User', id: Api.UserId, firstName: string, lastName: string, role: UserRole }> } | null };

export type ProviderLoginMutationVariables = Exact<{
  credentials: Credentials;
}>;


export type ProviderLoginMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', login?: string | null } | null };

export type BasicPatientInfoFragment = { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, phone?: string | null, email?: string | null, birthSex: SexAtBirth };

export type SurgeryListResponseFragment = { __typename?: 'Surgery', archived: boolean, riskAssessmentAvailability: RiskAssessmentAvailability, facilityId?: string | null, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null, workflow?: SurgeryWorkflow | null, unreadPlatformMessages: number, id: Api.SurgeryId, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, phone?: string | null, email?: string | null, birthSex: SexAtBirth }, surgeon?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null, assessment?: { __typename?: 'RiskAssessment', id: string, status: ClearanceStatus, surgicalRiskLevel: ClearanceRiskLevel, clearanceRiskLevel: ClearanceRiskLevel, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null } | null, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, type: VisitType, date: any, status: VisitStatus, foreignId?: string | null, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }>, allVisits: Array<{ __typename?: 'Visit', id: Api.VisitId, date: any, type: VisitType, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> };

export type GetSurgeriesQueryVariables = Exact<{
  filterCriteria?: InputMaybe<SurgeriesFilterCriteria>;
}>;


export type GetSurgeriesQuery = { __typename?: 'Query', time: any, surgeries?: Array<{ __typename?: 'Surgery', archived: boolean, riskAssessmentAvailability: RiskAssessmentAvailability, facilityId?: string | null, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null, workflow?: SurgeryWorkflow | null, unreadPlatformMessages: number, id: Api.SurgeryId, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, phone?: string | null, email?: string | null, birthSex: SexAtBirth }, surgeon?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null, assessment?: { __typename?: 'RiskAssessment', id: string, status: ClearanceStatus, surgicalRiskLevel: ClearanceRiskLevel, clearanceRiskLevel: ClearanceRiskLevel, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null } | null, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, type: VisitType, date: any, status: VisitStatus, foreignId?: string | null, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }>, allVisits: Array<{ __typename?: 'Visit', id: Api.VisitId, date: any, type: VisitType, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> }> | null };

export type GetSurgeriesPaginatedQueryVariables = Exact<{
  filterCriteria?: InputMaybe<SurgeriesFilterCriteria>;
  pageInfo: PageInfoInput;
}>;


export type GetSurgeriesPaginatedQuery = { __typename?: 'Query', time: any, surgeriesPaginated?: { __typename?: 'PaginatedSurgeries', surgeries: Array<{ __typename?: 'Surgery', archived: boolean, riskAssessmentAvailability: RiskAssessmentAvailability, facilityId?: string | null, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null, workflow?: SurgeryWorkflow | null, unreadPlatformMessages: number, id: Api.SurgeryId, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, phone?: string | null, email?: string | null, birthSex: SexAtBirth }, surgeon?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null, assessment?: { __typename?: 'RiskAssessment', id: string, status: ClearanceStatus, surgicalRiskLevel: ClearanceRiskLevel, clearanceRiskLevel: ClearanceRiskLevel, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null } | null, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, type: VisitType, date: any, status: VisitStatus, foreignId?: string | null, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }>, allVisits: Array<{ __typename?: 'Visit', id: Api.VisitId, date: any, type: VisitType, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> }>, pageInfo: { __typename?: 'PageInfo', pageSize?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSurgeriesSummaryQueryVariables = Exact<{
  filterCriteria: SurgerySummaryCriteria;
}>;


export type GetSurgeriesSummaryQuery = { __typename?: 'Query', surgeriesSummary?: { __typename?: 'SurgeriesSummary', clearedCount: number, inProgressCount: number, notClearedCount: number, noDosCount: number, noVisitCount: number } | null };

export type OnSurgeryListUpdatedSubscriptionVariables = Exact<{
  stakeholderId?: InputMaybe<Scalars['OrganizationId']>;
}>;


export type OnSurgeryListUpdatedSubscription = { __typename?: 'Subscription', surgery?: { __typename?: 'Surgery', archived: boolean, riskAssessmentAvailability: RiskAssessmentAvailability, facilityId?: string | null, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null, workflow?: SurgeryWorkflow | null, unreadPlatformMessages: number, id: Api.SurgeryId, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null, phone?: string | null, email?: string | null, birthSex: SexAtBirth }, surgeon?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null, assessment?: { __typename?: 'RiskAssessment', id: string, status: ClearanceStatus, surgicalRiskLevel: ClearanceRiskLevel, clearanceRiskLevel: ClearanceRiskLevel, intakeRiskAssessment?: ClearanceStatus | null, medicalClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null } | null, visits: Array<{ __typename?: 'Visit', id: Api.VisitId, type: VisitType, date: any, status: VisitStatus, foreignId?: string | null, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }>, allVisits: Array<{ __typename?: 'Visit', id: Api.VisitId, date: any, type: VisitType, provider?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> } | null };

export type GetServerPingSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetServerPingSubscription = { __typename?: 'Subscription', ping?: string | null };

export type SearchSurgeriesQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchSurgeriesQuery = { __typename?: 'Query', surgeries?: Array<{ __typename?: 'Surgery', id: Api.SurgeryId, surgeryType: string, dateOfService?: any | null, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null }, assessment?: { __typename?: 'RiskAssessment', intakeRiskAssessment?: ClearanceStatus | null } | null }> | null };

export type GetSurgeryInfoQueryVariables = Exact<{
  id: Scalars['SurgeryId'];
}>;


export type GetSurgeryInfoQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeryType: string, dateOfService?: any | null, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null }, assessment?: { __typename?: 'RiskAssessment', intakeRiskAssessment?: ClearanceStatus | null } | null } | null };

export type SurgerySearchFragment = { __typename?: 'Surgery', id: Api.SurgeryId, surgeryType: string, dateOfService?: any | null, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null }, assessment?: { __typename?: 'RiskAssessment', intakeRiskAssessment?: ClearanceStatus | null } | null };

export type GetSurgeryEventsQueryVariables = Exact<{
  eventContextId: Scalars['String'];
}>;


export type GetSurgeryEventsQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'EventLog', id: Api.EventLogId, occurredAt: Api.DateTimeString, eventType: string, description: string, actor?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> | null };

export type GetPatientEventsQueryVariables = Exact<{
  eventContextId: Scalars['String'];
}>;


export type GetPatientEventsQuery = { __typename?: 'Query', events?: Array<{ __typename?: 'EventLog', id: Api.EventLogId, occurredAt: Api.DateTimeString, eventType: string, description: string, actor?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> | null };

export type SurgeryEventLogFragment = { __typename?: 'EventLog', id: Api.EventLogId, occurredAt: Api.DateTimeString, eventType: string, description: string, actor?: { __typename?: 'User', id: Api.UserId, fullName: string } | null };

export type UpdateDocumentSurgeryMutationVariables = Exact<{
  documentId: Scalars['DocumentId'];
  surgeryId: Scalars['SurgeryId'];
}>;


export type UpdateDocumentSurgeryMutation = { __typename?: 'Mutation', document?: { __typename?: 'DocumentMutations', updateDocumentSurgery?: { __typename?: 'Document', id: Api.DocumentId, surgeryId?: Api.SurgeryId | null, patientId?: Api.PatientId | null } | null } | null };

export type GetDocAnalysisQueryVariables = Exact<{
  documentId: Scalars['DocumentId'];
}>;


export type GetDocAnalysisQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: Api.DocumentId, url: string, surgeryId?: Api.SurgeryId | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null } | null, ocrAnalysis?: { __typename?: 'DocumentOCRAnalysis', patientDemographics?: { __typename?: 'PatientDemographics', dateOfBirth?: any | null, firstName?: string | null, lastName?: string | null } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeryType: string, dateOfService?: any | null, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null }, assessment?: { __typename?: 'RiskAssessment', intakeRiskAssessment?: ClearanceStatus | null } | null } | null, studies?: Array<{ __typename?: 'Study', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, reconciliationStatus?: ReconciliationStatus | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null, dateInfo?: { __typename?: 'DateInfo', name?: string | null, value?: string | null, pageStart?: number | null, pageEnd?: number | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null } | null, observations?: Array<{ __typename?: 'ObservationValue', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null } | null> | null, requirement?: { __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null } | null } | null> | null } | null } | null };

export type GetDocOcrAnalysisFragment = { __typename?: 'DocumentOCRAnalysis', patientDemographics?: { __typename?: 'PatientDemographics', dateOfBirth?: any | null, firstName?: string | null, lastName?: string | null } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeryType: string, dateOfService?: any | null, patient: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null }, assessment?: { __typename?: 'RiskAssessment', intakeRiskAssessment?: ClearanceStatus | null } | null } | null, studies?: Array<{ __typename?: 'Study', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, reconciliationStatus?: ReconciliationStatus | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null, dateInfo?: { __typename?: 'DateInfo', name?: string | null, value?: string | null, pageStart?: number | null, pageEnd?: number | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null } | null, observations?: Array<{ __typename?: 'ObservationValue', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null } | null> | null, requirement?: { __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null } | null } | null> | null };

export type DocumentOcDetectedPatientFragment = { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, dob?: any | null };

export type ObservationStudyFragment = { __typename?: 'Study', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, reconciliationStatus?: ReconciliationStatus | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null, dateInfo?: { __typename?: 'DateInfo', name?: string | null, value?: string | null, pageStart?: number | null, pageEnd?: number | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null } | null, observations?: Array<{ __typename?: 'ObservationValue', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null } | null> | null, requirement?: { __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null } | null };

export type ObservationWithBoundingBoxFragment = { __typename?: 'ObservationValue', name: string, code: string, value?: number | null, pageStart?: number | null, pageEnd?: number | null, datePerformed?: any | null, boundingBox?: { __typename?: 'BoundingBox', left: number, width: number, top: number, height: number } | null };

export type GetConditionQueryVariables = Exact<{
  conditionId: Scalars['ConditionId'];
}>;


export type GetConditionQuery = { __typename?: 'Query', condition?: { __typename?: 'Condition', id: Api.ConditionId, deletedAt?: Api.DateTimeString | null, foreignId: string, patientId: Api.PatientId, displayName: string, status: ConditionStatus, lastReconciled?: Api.DateString | null, primarySystem: string, primaryCode: string, secondarySystem?: string | null, secondaryCode?: string | null, onsetDate?: Api.DateString | null, recordedDate?: Api.DateString | null, surgicalRisk: ConditionSurgicalRisk, surgicalRiskReason?: string | null, notes?: string | null } | null };

export type GetPatientConditionsQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetPatientConditionsQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', conditions: Array<{ __typename?: 'Condition', id: Api.ConditionId, deletedAt?: Api.DateTimeString | null, foreignId: string, patientId: Api.PatientId, displayName: string, status: ConditionStatus, lastReconciled?: Api.DateString | null, primarySystem: string, primaryCode: string, secondarySystem?: string | null, secondaryCode?: string | null, onsetDate?: Api.DateString | null, recordedDate?: Api.DateString | null, surgicalRisk: ConditionSurgicalRisk, surgicalRiskReason?: string | null, notes?: string | null } | null> } | null };

export type UpdateConditionMutationVariables = Exact<{
  condition: UpdateCondition;
}>;


export type UpdateConditionMutation = { __typename?: 'Mutation', condition?: { __typename?: 'ConditionMutations', updateCondition?: { __typename?: 'Condition', id: Api.ConditionId, deletedAt?: Api.DateTimeString | null, foreignId: string, patientId: Api.PatientId, displayName: string, status: ConditionStatus, lastReconciled?: Api.DateString | null, primarySystem: string, primaryCode: string, secondarySystem?: string | null, secondaryCode?: string | null, onsetDate?: Api.DateString | null, recordedDate?: Api.DateString | null, surgicalRisk: ConditionSurgicalRisk, surgicalRiskReason?: string | null, notes?: string | null } | null } | null };

export type DeleteConditionMutationVariables = Exact<{
  conditionId: Scalars['ConditionId'];
}>;


export type DeleteConditionMutation = { __typename?: 'Mutation', condition?: { __typename?: 'ConditionMutations', deleteCondition?: { __typename?: 'Condition', id: Api.ConditionId, deletedAt?: Api.DateTimeString | null, foreignId: string, patientId: Api.PatientId, displayName: string, status: ConditionStatus, lastReconciled?: Api.DateString | null, primarySystem: string, primaryCode: string, secondarySystem?: string | null, secondaryCode?: string | null, onsetDate?: Api.DateString | null, recordedDate?: Api.DateString | null, surgicalRisk: ConditionSurgicalRisk, surgicalRiskReason?: string | null, notes?: string | null } | null } | null };

export type GetFaxListQueryVariables = Exact<{
  options?: InputMaybe<FaxOptions>;
}>;


export type GetFaxListQuery = { __typename?: 'Query', faxes?: Array<{ __typename?: 'Fax', id: Api.FaxId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, subject?: string | null, requestMetadata?: string | null, direction: FaxDirection, name: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, documentId?: Api.DocumentId | null, requestFaxId?: Api.FaxId | null, status: FaxStatus, from: Api.PhoneNumber, callerId?: string | null, to: Api.PhoneNumber, url: string, fromContact?: { __typename?: 'Contact', id: string, name: string } | null, toContact?: { __typename?: 'Contact', id: string, name: string } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string } | null }> | null };

export type GenerateDocumentUrlsMutationVariables = Exact<{
  input: Array<Scalars['String']> | Scalars['String'];
}>;


export type GenerateDocumentUrlsMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', generateUploadUploadUrls?: Array<Api.SignedS3UploadUrl> | null } | null };

export type InitiateFaxRequestMutationVariables = Exact<{
  input: InitiateFaxRequest;
}>;


export type InitiateFaxRequestMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', initiateFax?: { __typename?: 'Query', faxes?: Array<{ __typename?: 'Fax', id: Api.FaxId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, subject?: string | null, requestMetadata?: string | null, direction: FaxDirection, name: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, documentId?: Api.DocumentId | null, requestFaxId?: Api.FaxId | null, status: FaxStatus, from: Api.PhoneNumber, callerId?: string | null, to: Api.PhoneNumber, url: string, fromContact?: { __typename?: 'Contact', id: string, name: string } | null, toContact?: { __typename?: 'Contact', id: string, name: string } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string } | null }> | null } | null } | null };

export type FaxItemFragment = { __typename?: 'Fax', id: Api.FaxId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, subject?: string | null, requestMetadata?: string | null, direction: FaxDirection, name: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, documentId?: Api.DocumentId | null, requestFaxId?: Api.FaxId | null, status: FaxStatus, from: Api.PhoneNumber, callerId?: string | null, to: Api.PhoneNumber, url: string, fromContact?: { __typename?: 'Contact', id: string, name: string } | null, toContact?: { __typename?: 'Contact', id: string, name: string } | null, surgery?: { __typename?: 'Surgery', id: Api.SurgeryId } | null, patient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string } | null };

export type GetFaxContactsQueryVariables = Exact<{
  parameters?: InputMaybe<ContactSearchInput>;
}>;


export type GetFaxContactsQuery = { __typename?: 'Query', contacts?: Array<{ __typename?: 'Contact', id: string, relation: string, name: string, phone?: string | null, fax?: string | null, email?: string | null }> | null };

export type FaxContactFragment = { __typename?: 'Contact', id: string, relation: string, name: string, phone?: string | null, fax?: string | null, email?: string | null };

export type LabRequirementFragment = { __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null };

export type LabOptionFragment = { __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, code: string, frequency: TemporalFrequency, effectiveDuration?: number | null, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, deletedAt?: any | null };

export type GetLabOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLabOptionsQuery = { __typename?: 'Query', orchestraLabRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, code: string, frequency: TemporalFrequency, effectiveDuration?: number | null, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, deletedAt?: any | null, labRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, code: string, frequency: TemporalFrequency, effectiveDuration?: number | null, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, deletedAt?: any | null }> | null } | null> | null };

export type GetStudyTrackingQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetStudyTrackingQuery = { __typename?: 'Query', studyTracking?: { __typename?: 'StudyTrackingState', studyState: StudyState, labRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null, labRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null }> | null }> | null, observations?: Array<{ __typename?: 'Observation', id: Api.ObservationId, patientId: Api.PatientId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, sourceId?: string | null, sourceType?: SourceType | null, sourceUrl?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, encounterDescription?: string | null, observations?: Array<{ __typename?: 'Observation', id: Api.ObservationId, patientId: Api.PatientId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, sourceId?: string | null, sourceType?: SourceType | null, sourceUrl?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, encounterDescription?: string | null, overruledByUser?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null }> | null, overruledByUser?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null }> | null, faxResponseVerifications: Array<{ __typename?: 'FaxResponseVerificationResult', documentId: Api.DocumentId, patientMatch: FaxResponsePatientMatch, items: Array<{ __typename?: 'FaxResponseRequestedItemVerification', requestCode: string, status: FaxResponseVerificationStatus, reason?: FaxResponseVerificationReason | null }> }> } | null };

export type FaxResponseVerificationResultFieldsFragment = { __typename?: 'FaxResponseVerificationResult', documentId: Api.DocumentId, patientMatch: FaxResponsePatientMatch, items: Array<{ __typename?: 'FaxResponseRequestedItemVerification', requestCode: string, status: FaxResponseVerificationStatus, reason?: FaxResponseVerificationReason | null }> };

export type GetOrganizationsAndSurgeonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsAndSurgeonsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string, users: Array<{ __typename?: 'User', id: Api.UserId, firstName: string, lastName: string, role: UserRole }> }> | null };

export type GetLabRequirementsForOrgQueryVariables = Exact<{
  targetId: Scalars['ID'];
  includeDeleted: Scalars['Boolean'];
}>;


export type GetLabRequirementsForOrgQuery = { __typename?: 'Query', labRequirementsByTargetId?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null, labRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null }> | null } | null> | null, orchestraLabRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null, labRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, unit?: string | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, authorId?: Api.UserId | null }> | null } | null> | null };

export type UpsertObservationsMutationVariables = Exact<{
  observations: Array<InputMaybe<UpsertObservation>> | InputMaybe<UpsertObservation>;
}>;


export type UpsertObservationsMutation = { __typename?: 'Mutation', observation?: { __typename?: 'ObservationMutations', upsertObservations?: Array<{ __typename?: 'Observation', id: Api.ObservationId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, createdBy?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, pageStart?: number | null, pageEnd?: number | null, observations?: Array<{ __typename?: 'Observation', id: Api.ObservationId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, createdBy?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, pageStart?: number | null, pageEnd?: number | null }> | null } | null> | null } | null };

export type UpsertLabRequirementMutationVariables = Exact<{
  requirement: UpsertRequirement;
}>;


export type UpsertLabRequirementMutation = { __typename?: 'Mutation', labRequirement?: { __typename?: 'LabRequirementMutations', upsertLabRequirement?: { __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, effectiveDuration?: number | null, requirementId?: string | null, deletedAt?: any | null, labRequirements?: Array<{ __typename?: 'LabRequirement', id: Api.LabRequirementId, name: string, targetType: TargetType, targetId: string, code: string, frequency: TemporalFrequency, thresholdLow?: number | null, thresholdHigh?: number | null, thresholdOutOfRangeLow?: number | null, thresholdOutOfRangeHigh?: number | null, deletedAt?: any | null }> | null } | null } | null };

export type GetOrganizationSchedulingFeatureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationSchedulingFeatureQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', features?: { __typename?: 'OrganizationFeatures', scheduling?: boolean | null } | null } | null };

export type GetImpersonatorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImpersonatorQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: Api.UserId, fullName: string } | null, impersonator?: { __typename?: 'User', id: Api.UserId, fullName: string, email: string } | null };

export type GetMedicationQueryVariables = Exact<{
  medicationId: Scalars['MedicationId'];
}>;


export type GetMedicationQuery = { __typename?: 'Query', medication?: { __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString } | null };

export type GetPatientMedicationsQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetPatientMedicationsQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', firstName: string, lastName: string, medications: Array<{ __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString } | null> } | null };

export type GetMedicationReconciliationWorkspaceQueryVariables = Exact<{
  patientId: Scalars['ID'];
  patientMedicationId: Scalars['PatientId'];
  eventContextId: Scalars['String'];
}>;


export type GetMedicationReconciliationWorkspaceQuery = { __typename?: 'Query', patient?: { __typename?: 'Patient', firstName: string, lastName: string } | null, patientMedications: Array<{ __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString }>, events?: Array<{ __typename?: 'EventLog', occurredAt: Api.DateTimeString, eventType: string, actor?: { __typename?: 'User', firstName: string, lastName: string } | null }> | null };

export type GetPatientMedicationInstructionsQueryVariables = Exact<{
  patientId: Scalars['PatientId'];
}>;


export type GetPatientMedicationInstructionsQuery = { __typename?: 'Query', patientMedicationInstructions: Array<{ __typename?: 'CaseInstruction', id: Api.CaseInstructionId, name: string, description: string, type: CaseInstructionType }> };

export type SearchMedicationsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchMedicationsQuery = { __typename?: 'Query', medicationSearch: Array<{ __typename?: 'Medication', displayName: string, primaryCode: string, primarySystem: string, foreignId: string }> };

export type MedicationTriageAnalysisMutationVariables = Exact<{
  patientId: Scalars['PatientId'];
}>;


export type MedicationTriageAnalysisMutation = { __typename?: 'Mutation', medication?: { __typename?: 'MedicationMutations', medicationTriageAnalysis?: Array<{ __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString } | null> | null } | null };

export type CreateMedicationMutationVariables = Exact<{
  medication: CreateMedication;
}>;


export type CreateMedicationMutation = { __typename?: 'Mutation', medication?: { __typename?: 'MedicationMutations', createMedication?: { __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString } | null } | null };

export type UpdateMedicationMutationVariables = Exact<{
  medication: UpdateMedication;
}>;


export type UpdateMedicationMutation = { __typename?: 'Mutation', medication?: { __typename?: 'MedicationMutations', updateMedication?: { __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString } | null } | null };

export type DeleteMedicationMutationVariables = Exact<{
  medicationId: Scalars['MedicationId'];
}>;


export type DeleteMedicationMutation = { __typename?: 'Mutation', medication?: { __typename?: 'MedicationMutations', deleteMedication?: { __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString } | null } | null };

export type ClearMedicationsMutationVariables = Exact<{
  medicationIds: Array<Scalars['MedicationId']> | Scalars['MedicationId'];
}>;


export type ClearMedicationsMutation = { __typename?: 'Mutation', medication?: { __typename?: 'MedicationMutations', clearMedications?: Array<{ __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString }> | null } | null };

export type ReconcileMedicationsMutationVariables = Exact<{
  medicationIds: Array<Scalars['MedicationId']> | Scalars['MedicationId'];
  patientId: Scalars['PatientId'];
}>;


export type ReconcileMedicationsMutation = { __typename?: 'Mutation', medication?: { __typename?: 'MedicationMutations', reconcileMedications?: Array<{ __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString }> | null } | null };

export type GetOperatingFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOperatingFacilitiesQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string, specialty: OrganizationSpecialty }> | null };

export type GetSurgicalOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurgicalOrganizationsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string, specialty: OrganizationSpecialty }> | null };

export type CreateNewSurgicalOrganizationMutationVariables = Exact<{
  addOrganization: AddOrganizationInput;
}>;


export type CreateNewSurgicalOrganizationMutation = { __typename?: 'Mutation', orchestraOperations?: { __typename?: 'OrchestraOperations', addOrganization?: { __typename?: 'Organization', id: Api.OrganizationId, name: string, specialty: OrganizationSpecialty } | null } | null };

export type CreateNewFacilityMutationVariables = Exact<{
  addFacility: AddFacilityInput;
}>;


export type CreateNewFacilityMutation = { __typename?: 'Mutation', orchestraOperations?: { __typename?: 'OrchestraOperations', addFacility?: { __typename?: 'Organization', id: Api.OrganizationId, name: string, network: string, specialty: OrganizationSpecialty } | null } | null };

export type GetSurgeonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSurgeonsQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: Api.UserId, organizationId: Api.OrganizationId, firstName: string, lastName: string }> };

export type GetRelatedSurgeonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRelatedSurgeonsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', relatedUsers: Array<{ __typename?: 'User', id: Api.UserId, organizationId: Api.OrganizationId, firstName: string, lastName: string }> } | null };

export type GetPatientFromMedicalRecordNumberQueryVariables = Exact<{
  medicalRecordNumber: Scalars['String'];
}>;


export type GetPatientFromMedicalRecordNumberQuery = { __typename?: 'Query', getPatientFromMedicalRecordNumber?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, birthSex: SexAtBirth, phone?: string | null, phoneType?: PhoneType | null, email?: string | null, dob?: any | null, addressId?: Api.AddressId | null, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string } | null, upcomingSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, dateOfService?: any | null, url: string, surgeonName: string, surgeryType: string, workflow?: SurgeryWorkflow | null, facility?: { __typename?: 'Facility', id: Api.OrganizationId, name: string } | null } | null } | null };

export type InviteUserForOrganizationMutationVariables = Exact<{
  inviteUser: AddUserForOrganizationInput;
}>;


export type InviteUserForOrganizationMutation = { __typename?: 'Mutation', orchestraOperations?: { __typename?: 'OrchestraOperations', inviteUserForOrganization?: { __typename?: 'User', id: Api.UserId } | null } | null };

export type MessageItemFragment = { __typename?: 'Message', id: Api.MessageId, origin: MessageOrigin, status: MessageStatus, content: string, translation?: string | null, timestamp: Api.DateTimeString, foreignStatus?: string | null, authorName?: string | null, author?: { __typename?: 'User', id: Api.UserId, fullName: string } | null };

export type TranslateMessageQueryVariables = Exact<{
  message: Scalars['String'];
  language: Scalars['String'];
  patientId: Scalars['PatientId'];
}>;


export type TranslateMessageQuery = { __typename?: 'Query', translation?: string | null };

export type GetSurgeryMessagesQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  filter?: InputMaybe<MessageFilter>;
}>;


export type GetSurgeryMessagesQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, messages: Array<{ __typename?: 'Message', id: Api.MessageId, origin: MessageOrigin, status: MessageStatus, content: string, translation?: string | null, timestamp: Api.DateTimeString, foreignStatus?: string | null, authorName?: string | null, author?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> } | null };

export type UpdateMessageRecordMutationVariables = Exact<{
  id: Scalars['MessageId'];
  translation: Scalars['String'];
  surgeryId: Scalars['SurgeryId'];
}>;


export type UpdateMessageRecordMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', updateMessage?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', messages: Array<{ __typename?: 'Message', id: Api.MessageId, origin: MessageOrigin, status: MessageStatus, content: string, translation?: string | null, timestamp: Api.DateTimeString, foreignStatus?: string | null, authorName?: string | null, author?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> } | null } | null } | null };

export type SendMessageToPatientMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  patientId: Scalars['ID'];
  message: Scalars['String'];
  translation?: InputMaybe<Scalars['String']>;
}>;


export type SendMessageToPatientMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', sendMessage?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', messages: Array<{ __typename?: 'Message', id: Api.MessageId, origin: MessageOrigin, status: MessageStatus, content: string, translation?: string | null, timestamp: Api.DateTimeString, foreignStatus?: string | null, authorName?: string | null, author?: { __typename?: 'User', id: Api.UserId, fullName: string } | null }> } | null } | null } | null };

export type OnPatientMessageSubscriptionVariables = Exact<{
  patientId?: InputMaybe<Scalars['PatientId']>;
}>;


export type OnPatientMessageSubscription = { __typename?: 'Subscription', patientSMSMessage?: { __typename?: 'Message', id: Api.MessageId, origin: MessageOrigin, status: MessageStatus, content: string, translation?: string | null, timestamp: Api.DateTimeString, foreignStatus?: string | null, authorName?: string | null, author?: { __typename?: 'User', id: Api.UserId, fullName: string } | null } | null };

export type GetProcessTrackerQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetProcessTrackerQuery = { __typename?: 'Query', processTracker?: { __typename?: 'ProcessTracker', total: number, completed: number, inProgress: number, todo: number, steps?: Array<{ __typename?: 'ProcessStepState', id: string, key: string, label?: string | null, status: ProcessStepStatus, displayOrder: number, notes?: string | null, lastTransitionAt?: Api.DateString | null, lastTransitionBy?: string | null, transitionType?: StateTransitionType | null, isVirtual: boolean }> | null } | null };

export type CreateProcessStepStateMutationVariables = Exact<{
  createStepState: CreateProcessStepState;
}>;


export type CreateProcessStepStateMutation = { __typename?: 'Mutation', processStep?: { __typename?: 'ProcessStepMutations', createProcessStepState?: { __typename?: 'ProcessStepState', id: string, key: string, label?: string | null, status: ProcessStepStatus, displayOrder: number, notes?: string | null, lastTransitionAt?: Api.DateString | null, lastTransitionBy?: string | null, transitionType?: StateTransitionType | null, isVirtual: boolean } | null } | null };

export type UpdateProcessStepStateMutationVariables = Exact<{
  updateStepState: UpdateProcessStepState;
}>;


export type UpdateProcessStepStateMutation = { __typename?: 'Mutation', processStep?: { __typename?: 'ProcessStepMutations', updateProcessStepState?: { __typename?: 'ProcessStepState', id: string, key: string, label?: string | null, status: ProcessStepStatus, displayOrder: number, notes?: string | null, lastTransitionAt?: Api.DateString | null, lastTransitionBy?: string | null, transitionType?: StateTransitionType | null, isVirtual: boolean } | null } | null };

export type ProcessStepStateFragment = { __typename?: 'ProcessStepState', id: string, key: string, label?: string | null, status: ProcessStepStatus, displayOrder: number, notes?: string | null, lastTransitionAt?: Api.DateString | null, lastTransitionBy?: string | null, transitionType?: StateTransitionType | null, isVirtual: boolean };

export type UpdateDateOfServiceMutationVariables = Exact<{
  surgery: UpdateSurgeryInput;
}>;


export type UpdateDateOfServiceMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, dateOfService?: any | null, assessment?: { __typename?: 'RiskAssessment', id: string, intakeRiskAssessment?: ClearanceStatus | null } | null } | null } | null };

export type GetSurgeonsForOrganizationQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetSurgeonsForOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'User', id: Api.UserId, firstName: string, lastName: string }> } | null };

export type SendIntakeQuestionnaireMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type SendIntakeQuestionnaireMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', sendIntakeQuestionnaire?: { __typename?: 'Query', ping?: string | null } | null } | null };

export type ConfirmUpdateCoverageMutationVariables = Exact<{
  patient: Scalars['ID'];
  surgery: Scalars['SurgeryId'];
}>;


export type ConfirmUpdateCoverageMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', sendUpdateCoverageInstructions?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', messages: Array<{ __typename?: 'Message', id: Api.MessageId, status: MessageStatus, timestamp: Api.DateTimeString, content: string, authorName?: string | null }> } | null } | null } | null };

export type GetSurgeryThreadIdQueryVariables = Exact<{
  id: Scalars['SurgeryId'];
}>;


export type GetSurgeryThreadIdQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, threadId?: Api.PlatformThreadId | null } | null };

export type GetPlatformSurgeryMessagesQueryVariables = Exact<{
  id: Scalars['SurgeryId'];
}>;


export type GetPlatformSurgeryMessagesQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, platformMessages: Array<{ __typename?: 'Message', id: Api.MessageId, authorId?: string | null, timestamp: Api.DateTimeString, content: string, origin: MessageOrigin, status: MessageStatus, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null }> } | null };

export type SendSurgeryMessageMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  content: Scalars['String'];
}>;


export type SendSurgeryMessageMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', sendSurgeryMessage?: { __typename?: 'Message', id: Api.MessageId, authorId?: string | null, timestamp: Api.DateTimeString, content: string, origin: MessageOrigin, status: MessageStatus, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null } | null } | null };

export type ListenForMessageThreadSubscriptionVariables = Exact<{
  threadId?: InputMaybe<Scalars['PlatformThreadId']>;
}>;


export type ListenForMessageThreadSubscription = { __typename?: 'Subscription', platformMessage?: { __typename?: 'Message', id: Api.MessageId, authorId?: string | null, timestamp: Api.DateTimeString, content: string, origin: MessageOrigin, status: MessageStatus, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null } | null };

export type InAppSurgeryPlatformMessageFragment = { __typename?: 'Message', id: Api.MessageId, authorId?: string | null, timestamp: Api.DateTimeString, content: string, origin: MessageOrigin, status: MessageStatus, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null };

export type UpdateReadReceiptMutationVariables = Exact<{
  platformThreadId: Scalars['PlatformThreadId'];
  surgeryId: Scalars['SurgeryId'];
}>;


export type UpdateReadReceiptMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateLastMessageRead?: { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, unreadPlatformMessages: number } | null } | null } | null };

export type GetProviderUploadMutationVariables = Exact<{
  patientId: Scalars['ID'];
  files: Array<FileCandidate> | FileCandidate;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
}>;


export type GetProviderUploadMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', generateS3Files?: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, name: string, type: FileType, url: string }> | null } | null };

export type GetAvailableFacilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableFacilitiesQuery = { __typename?: 'Query', facilities?: Array<{ __typename?: 'Facility', id: Api.OrganizationId, name: string, network: string }> | null };

export type AvailableFacilityFragment = { __typename?: 'Facility', id: Api.OrganizationId, name: string, network: string };

export type FullSurgeryResponseFragment = { __typename?: 'Surgery', id: Api.SurgeryId, referrer: string, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, externalNotes?: string | null, archived: boolean, notes?: string | null, workflow?: SurgeryWorkflow | null, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null, schedulingLink?: string | null, riskAssessmentAvailability: RiskAssessmentAvailability, facilityId?: string | null, threadId?: Api.PlatformThreadId | null, unreadPlatformMessages: number, patient: { __typename?: 'Patient', id: Api.PatientId, dob?: any | null, firstName: string, lastName: string, phone?: string | null, phoneType?: PhoneType | null, email?: string | null, emrId: string, birthSex: SexAtBirth, externalHieUrl?: string | null, coverage?: { __typename?: 'PatientCoverage', id: string, status: PatientCoverageStatus } | null, intake?: { __typename?: 'IntakeQuestionaire', id: string } | null, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string } | null }, assessment?: { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, status: ClearanceStatus, priorAuth?: ClearanceStatus | null, clearanceRiskLevel: ClearanceRiskLevel, surgicalRiskLevel: ClearanceRiskLevel, medicalClearance?: ClearanceStatus | null, intakeRiskAssessment?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null } | null, surgeon?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string, fullName: string, organizationId: Api.OrganizationId } | null, documents?: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> | null, facility?: { __typename?: 'Facility', id: Api.OrganizationId, name: string, network: string } | null, pointsOfContact: Array<{ __typename?: 'PointOfContact', id?: Api.UserId | null, firstName?: string | null, lastName?: string | null, email?: string | null, isPrimary?: boolean | null, roleAssignmentId?: Api.RoleAssignmentId | null, targetId?: string | null }> };

export type GetFullSurgeryQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetFullSurgeryQuery = { __typename?: 'Query', surgery?: { __typename?: 'Surgery', id: Api.SurgeryId, referrer: string, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, externalNotes?: string | null, archived: boolean, notes?: string | null, workflow?: SurgeryWorkflow | null, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null, schedulingLink?: string | null, riskAssessmentAvailability: RiskAssessmentAvailability, facilityId?: string | null, threadId?: Api.PlatformThreadId | null, unreadPlatformMessages: number, patient: { __typename?: 'Patient', id: Api.PatientId, dob?: any | null, firstName: string, lastName: string, phone?: string | null, phoneType?: PhoneType | null, email?: string | null, emrId: string, birthSex: SexAtBirth, externalHieUrl?: string | null, coverage?: { __typename?: 'PatientCoverage', id: string, status: PatientCoverageStatus } | null, intake?: { __typename?: 'IntakeQuestionaire', id: string } | null, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string } | null }, assessment?: { __typename?: 'RiskAssessment', id: string, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, status: ClearanceStatus, priorAuth?: ClearanceStatus | null, clearanceRiskLevel: ClearanceRiskLevel, surgicalRiskLevel: ClearanceRiskLevel, medicalClearance?: ClearanceStatus | null, intakeRiskAssessment?: ClearanceStatus | null, specialtyClearance?: ClearanceStatus | null, cardiologyClearance?: ClearanceStatus | null } | null, surgeon?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string, fullName: string, organizationId: Api.OrganizationId } | null, documents?: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> | null, facility?: { __typename?: 'Facility', id: Api.OrganizationId, name: string, network: string } | null, pointsOfContact: Array<{ __typename?: 'PointOfContact', id?: Api.UserId | null, firstName?: string | null, lastName?: string | null, email?: string | null, isPrimary?: boolean | null, roleAssignmentId?: Api.RoleAssignmentId | null, targetId?: string | null }> } | null };

export type UpdateNotesMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  notes: Scalars['String'];
}>;


export type UpdateNotesMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', updateNotes?: { __typename?: 'Surgery', id: Api.SurgeryId, notes?: string | null } | null } | null };

export type UpdateExternalNoteMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  notes: Scalars['String'];
}>;


export type UpdateExternalNoteMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', updateExternalNote?: { __typename?: 'Surgery', id: Api.SurgeryId, externalNotes?: string | null } | null } | null };

export type UpdateSurgeryTypeMutationVariables = Exact<{
  surgery: UpdateSurgeryInput;
}>;


export type UpdateSurgeryTypeMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeryType: string } | null } | null };

export type UpdateSurgeryFacilityMutationVariables = Exact<{
  surgery: UpdateSurgeryInput;
}>;


export type UpdateSurgeryFacilityMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, facilityId?: string | null, facility?: { __typename?: 'Facility', id: Api.OrganizationId, name: string, network: string } | null } | null } | null };

export type UpdateClearanceDocumentsSentMutationVariables = Exact<{
  surgery: UpdateSurgeryInput;
}>;


export type UpdateClearanceDocumentsSentMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, clearanceDocumentsSent: boolean, clearanceDocumentsSentAt?: any | null } | null } | null };

export type UpdatePatientInfoMutationVariables = Exact<{
  patient: UpdatePatientInput;
}>;


export type UpdatePatientInfoMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updatePatient?: { __typename?: 'Patient', id: Api.PatientId, firstName: string, lastName: string, email?: string | null, phone?: string | null, phoneType?: PhoneType | null, dob?: any | null, birthSex: SexAtBirth, address?: { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string } | null } | null } | null };

export type UpdateSurgeryArchivedStatusMutationVariables = Exact<{
  input: UpdateSurgeryArchivedInput;
}>;


export type UpdateSurgeryArchivedStatusMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgeryArchivedStatus?: { __typename?: 'Surgery', id: Api.SurgeryId, archived: boolean } | null } | null };

export type GetPatientIntakeUrlQueryVariables = Exact<{
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
}>;


export type GetPatientIntakeUrlQuery = { __typename?: 'Query', getPatientIntakeUrl?: string | null };

export type GetOpsPatientIntakeUrlQueryVariables = Exact<{
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
}>;


export type GetOpsPatientIntakeUrlQuery = { __typename?: 'Query', getOpsPatientIntakeUrl?: string | null };

export type GetOpenLoopViabilityStatusQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetOpenLoopViabilityStatusQuery = { __typename?: 'Query', getOpenLoopViabilityStatus?: { __typename?: 'OpenLoopViabilityStatus', isViable: boolean, reason: string } | null };

export type GetOpenLoopPrivateNoteEditLinkQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetOpenLoopPrivateNoteEditLinkQuery = { __typename?: 'Query', getOpenLoopPrivateNoteEditLink?: string | null };

export type GetBridgeNoteReviewLinkQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetBridgeNoteReviewLinkQuery = { __typename?: 'Query', getOpenLoopPreChartV2ShadowNoteEditLink?: string | null };

export type GetClinicalReviewCodingCopyQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetClinicalReviewCodingCopyQuery = { __typename?: 'Query', getClinicalReviewCodingCopy?: string | null };

export type GetHiePullStatusQueryVariables = Exact<{
  patientId: Scalars['PatientId'];
}>;


export type GetHiePullStatusQuery = { __typename?: 'Query', hiePullStatus?: { __typename?: 'HieJob', jobStatus?: HieJobStatus | null, createdAt?: Api.DateTimeString | null, updatedAt?: Api.DateTimeString | null, targetCompletionDate?: Api.DateTimeString | null, serviceProviders?: Array<{ __typename?: 'HieServiceProvider', service?: string | null, status?: ServiceProviderJobStatus | null } | null> | null } | null };

export type LogPhoneCallMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  description: Scalars['String'];
}>;


export type LogPhoneCallMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', logEvent?: { __typename?: 'Query', ping?: string | null } | null } | null };

export type GetUsersResponsibleForSurgeryQueryVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
}>;


export type GetUsersResponsibleForSurgeryQuery = { __typename?: 'Query', usersResponsibleForSurgery: Array<{ __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string }> };

export type UpdateRoleAssignmentMutationVariables = Exact<{
  roleAssignment: UpdateRoleAssignment;
}>;


export type UpdateRoleAssignmentMutation = { __typename?: 'Mutation', roleAssignment?: { __typename?: 'RoleAssignmentMutations', updateRole?: { __typename?: 'RoleAssignment', id: Api.RoleAssignmentId, targetId: string, targetType: TargetType, userId: Api.UserId, role: RoleType, isPrimary: boolean, isAvailable: boolean } | null } | null };

export type CreateRoleAssignmentMutationVariables = Exact<{
  roleAssignment: InsertRoleAssignment;
}>;


export type CreateRoleAssignmentMutation = { __typename?: 'Mutation', roleAssignment?: { __typename?: 'RoleAssignmentMutations', insertRole?: { __typename?: 'RoleAssignment', id: Api.RoleAssignmentId, targetId: string, targetType: TargetType, userId: Api.UserId, role: RoleType, isPrimary: boolean, isAvailable: boolean } | null } | null };

export type SendPreopPacketMutationVariables = Exact<{
  roleIds: Array<Scalars['RoleAssignmentId']> | Scalars['RoleAssignmentId'];
  surgeryId: Scalars['SurgeryId'];
}>;


export type SendPreopPacketMutation = { __typename?: 'Mutation', roleAssignment?: { __typename?: 'RoleAssignmentMutations', sendPreopPacket?: boolean | null } | null };

export type UpdateSurgeryWorkflowMutationVariables = Exact<{
  input: UpdateSurgeryInput;
}>;


export type UpdateSurgeryWorkflowMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, workflow?: SurgeryWorkflow | null } | null } | null };

export type AddSurgeryForOrganizationMutationVariables = Exact<{
  surgery: SurgeryInput;
}>;


export type AddSurgeryForOrganizationMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', registerSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeonId?: string | null, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId, facilityId?: string | null } | null } | null };

export type InviteUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', inviteUser?: { __typename?: 'Query', organization?: { __typename?: 'Organization', users: Array<{ __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string }> } | null } | null } | null };

export type EditUserMutationVariables = Exact<{
  user: EditUserInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', editUserInfo?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null } | null };

export type GetUserToEditQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UserId']>;
}>;


export type GetUserToEditQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null };

export type ReplaceSurgeonMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  organizationId: Scalars['ID'];
}>;


export type ReplaceSurgeonMutation = { __typename?: 'Mutation', internalSurgery?: { __typename?: 'InternalSurgeryMutations', replacePrimaryOrganization?: { __typename?: 'Surgery', id: Api.SurgeryId, stakeholders?: Array<{ __typename?: 'Organization', id: Api.OrganizationId, name: string, specialty: OrganizationSpecialty }> | null } | null } | null };

export type UpdateSurgeonMutationVariables = Exact<{
  surgery: UpdateSurgeryInput;
}>;


export type UpdateSurgeonMutation = { __typename?: 'Mutation', provider?: { __typename?: 'ProviderMutations', updateSurgery?: { __typename?: 'Surgery', id: Api.SurgeryId, surgeonId?: string | null, surgeon?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null } | null } | null };

export type GetRedFlagsQueryVariables = Exact<{
  patientId: Scalars['PatientId'];
}>;


export type GetRedFlagsQuery = { __typename?: 'Query', aiAssessment?: { __typename?: 'AiAssessment', redFlags?: Array<{ __typename?: 'RedFlag', id: string, category: string, text: string, fileName: string, documentId: Api.DocumentId, documentUrl: string, noteDate?: Api.DateString | null, evidenceDate?: Api.DateString | null, evidenceType?: string | null, evidenceValue?: string | null, observationCodes: Array<string> }> | null } | null };

export type GetAiRiskAssessmentQueryVariables = Exact<{
  patientId: Scalars['PatientId'];
  documentId: Scalars['DocumentId'];
}>;


export type GetAiRiskAssessmentQuery = { __typename?: 'Query', aiAssessment?: { __typename?: 'AiAssessment', risk?: { __typename?: 'AiRiskAssessment', analysis?: string | null, synthesis?: string | null } | null } | null };

export type GetAiAssessmentDocIdsQueryVariables = Exact<{
  patientId: Scalars['PatientId'];
  riskDocumentId?: InputMaybe<Scalars['DocumentId']>;
  preChartDocumentId?: InputMaybe<Scalars['DocumentId']>;
}>;


export type GetAiAssessmentDocIdsQuery = { __typename?: 'Query', aiAssessment?: { __typename?: 'AiAssessment', allAssessmentDocIds?: Array<Api.DocumentId> | null } | null };

export type AiRiskAssessmentMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  refresh?: InputMaybe<Scalars['Boolean']>;
}>;


export type AiRiskAssessmentMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', aiRiskAssessment?: string | null } | null };

export type TriageDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['DocumentId']> | Scalars['DocumentId'];
}>;


export type TriageDocumentsMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', triageDocuments: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null } | null> } | null };

export type AiPreChartMutationVariables = Exact<{
  surgeryId: Scalars['SurgeryId'];
  refresh?: InputMaybe<Scalars['Boolean']>;
}>;


export type AiPreChartMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', aiPreChart?: string | null } | null };

export type PreChartDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['DocumentId']> | Scalars['DocumentId'];
}>;


export type PreChartDocumentsMutation = { __typename?: 'Mutation', riskAssessment?: { __typename?: 'RiskAssessmentMutations', preChartDocuments: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null } | null> } | null };

export type TaskFragment = { __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['TaskId'];
}>;


export type GetTaskQuery = { __typename?: 'Query', task?: { __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus } | null };

export type GetTasksQueryVariables = Exact<{
  options: TaskOptions;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks?: Array<{ __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus }> | null };

export type GetTasksPaginatedQueryVariables = Exact<{
  options: TaskOptions;
  pageInfo: PageInfoInput;
}>;


export type GetTasksPaginatedQuery = { __typename?: 'Query', tasksPaginated?: { __typename?: 'PaginatedTasks', tasks: Array<{ __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus }>, pageInfo: { __typename?: 'PageInfo', pageSize?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } } | null };

export type InsertTaskMutationVariables = Exact<{
  task: InsertTask;
}>;


export type InsertTaskMutation = { __typename?: 'Mutation', task?: { __typename?: 'TaskMutations', insertTask?: { __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus } | null } | null };

export type MarkTaskViewedMutationVariables = Exact<{
  id: Scalars['TaskId'];
}>;


export type MarkTaskViewedMutation = { __typename?: 'Mutation', task?: { __typename?: 'TaskMutations', markTaskViewed?: { __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus } | null } | null };

export type UpdateTaskMutationVariables = Exact<{
  task: UpdateTask;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', task?: { __typename?: 'TaskMutations', updateTask?: { __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus } | null } | null };

export type ListenForTaskSubscriptionVariables = Exact<{
  assigneeId?: InputMaybe<Scalars['UserId']>;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']>;
}>;


export type ListenForTaskSubscription = { __typename?: 'Subscription', task?: { __typename?: 'Task', id: Api.TaskId, updatedAt: Api.DateTimeString, authorId: Api.UserId, title?: string | null, description?: string | null, surgeryId: Api.SurgeryId, organizationId: Api.OrganizationId, dueDate: any, completedAt?: any | null, assigneeId?: Api.UserId | null, viewedByAssignee?: any | null, deletedAt?: any | null, status: TaskStatus } | null };

export type FindUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type FindUserQuery = { __typename?: 'Query', ping?: string | null };

export type GetUserByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UserId']>;
}>;


export type GetUserByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string } | null };

export type GetSessionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionInfoQuery = { __typename?: 'Query', sessionInfo?: { __typename?: 'SessionInfo', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, organizationId?: Api.OrganizationId | null, organization?: { __typename?: 'Organization', id: Api.OrganizationId, name: string } | null, impersonator?: { __typename?: 'SessionInfo', id: string, firstName: string, lastName: string, organizationId?: Api.OrganizationId | null } | null } | null };

export type IdentifyUserSessionFragment = { __typename?: 'SessionInfo', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, organizationId?: Api.OrganizationId | null, organization?: { __typename?: 'Organization', id: Api.OrganizationId, name: string } | null, impersonator?: { __typename?: 'SessionInfo', id: string, firstName: string, lastName: string, organizationId?: Api.OrganizationId | null } | null };

export type RequestIngestionUploadUrlMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
}>;


export type RequestIngestionUploadUrlMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', bulkUpload?: { __typename?: 'BulkUploadMutations', requestIngestionUploadUrl: { __typename?: 'IngestionUploadUrl', uploadUrl: string, sourceBucket: string, sourceKey: string } } | null } | null };

export type TransformIngestionUploadMutationVariables = Exact<{
  input: TransformIngestionUploadInput;
}>;


export type TransformIngestionUploadMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', bulkUpload?: { __typename?: 'BulkUploadMutations', transformIngestionUpload: { __typename?: 'TransformIngestionResult', rows: Array<string>, resultBucket: string, resultKey: string, totalDataRowCount: number } } | null } | null };

export type CommitIngestionTransformMutationVariables = Exact<{
  input: CommitIngestionTransformInput;
}>;


export type CommitIngestionTransformMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', bulkUpload?: { __typename?: 'BulkUploadMutations', commitIngestionTransform: { __typename?: 'UploadIngestionFileResponse', success: boolean, messages: Array<string>, jobId?: string | null } } | null } | null };

export type ValidateAndIngestUploadMutationVariables = Exact<{
  input: ValidateAndIngestUploadInput;
}>;


export type ValidateAndIngestUploadMutation = { __typename?: 'Mutation', providerOperations?: { __typename?: 'ProviderOperationsMutations', bulkUpload?: { __typename?: 'BulkUploadMutations', validateAndIngestUpload: { __typename?: 'UploadIngestionFileResponse', success: boolean, messages: Array<string>, jobId?: string | null } } | null } | null };

export type BulkUploadIngestionJobQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type BulkUploadIngestionJobQuery = { __typename?: 'Query', ingestionJob?: { __typename?: 'IngestionJob', id: string, status: IngestionJobStatus, totalRows: number, processedRows: number, errorCount: number, messages: Array<string> } | null };

export type UpdateDocumentStatusMutationVariables = Exact<{
  documentId: Scalars['DocumentId'];
  status: DocumentStatus;
}>;


export type UpdateDocumentStatusMutation = { __typename?: 'Mutation', document?: { __typename?: 'DocumentMutations', updateDocumentStatus?: { __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null } | null } | null };

export type GenerateUploadUrlsMutationVariables = Exact<{
  fileNames: Array<Scalars['String']> | Scalars['String'];
}>;


export type GenerateUploadUrlsMutation = { __typename?: 'Mutation', document?: { __typename?: 'DocumentMutations', generateUploadUrls?: Array<{ __typename?: 'GenerateUploadUrlsResponse', uploadUrl: Api.SignedS3UploadUrl, document: { __typename?: 'Document', id: Api.DocumentId, status: DocumentStatus } }> | null } | null };

export type GenerateUploadUrlFragmentFragment = { __typename?: 'GenerateUploadUrlsResponse', uploadUrl: Api.SignedS3UploadUrl, document: { __typename?: 'Document', id: Api.DocumentId, status: DocumentStatus } };

export type StartOcrAnalysisMutationVariables = Exact<{
  documentId: Scalars['DocumentId'];
}>;


export type StartOcrAnalysisMutation = { __typename?: 'Mutation', document?: { __typename?: 'DocumentMutations', startOCRAnalysis?: { __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null } | null } | null };

export type IngestCanvasDocumentReferenceMutationVariables = Exact<{
  patientId: Scalars['PatientId'];
  documentReferenceId?: InputMaybe<Scalars['String']>;
  surgeryId?: InputMaybe<Scalars['SurgeryId']>;
}>;


export type IngestCanvasDocumentReferenceMutation = { __typename?: 'Mutation', document?: { __typename?: 'DocumentMutations', ingestCanvasDocumentReference?: { __typename?: 'CanvasHpIngestResult', status: CanvasHpIngestStatus, document?: { __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null } | null } | null } | null };

export type DocumentAnalysisFragment = { __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null };

export type DocumentFragment = { __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null };

export type FaxFragment = { __typename?: 'Fax', id: Api.FaxId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, patientId?: Api.PatientId | null, surgeryId?: Api.SurgeryId | null, documentId?: Api.DocumentId | null, requestFaxId?: Api.FaxId | null, from: Api.PhoneNumber, to: Api.PhoneNumber, subject?: string | null, requestMetadata?: string | null, status: FaxStatus, name: string, url: string };

export type FullPatientFragment = { __typename?: 'Patient', id: Api.PatientId, emrId: string, firstName: string, lastName: string, dob?: any | null, email?: string | null, intake?: { __typename?: 'IntakeQuestionaire', other: { __typename?: 'TextAnswer', answer: string }, endocrineDisorder: { __typename?: 'TextAnswer', answer: string }, immuneDisorders: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, bloodDisase: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, KidneyDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, liverDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, pulmonaryProblems: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, congestiveHeartFailure: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, neurologicalDisorder: { __typename?: 'NeurologicalDisorder', answer: boolean, description: string, lastStroke: string }, diabetes: { __typename?: 'Diabetes', answer: boolean, description: string, a1cLevel: number, areYouTakingInsulin: boolean }, bodilyMedicalDevies: { __typename?: 'BodilyMedicalDevies', deviceName: string, informationCard: boolean, deviceCheckedInLastYear: boolean }, heartProblems: { __typename?: 'HeartProblems', heartStents: boolean, bloodTinners: boolean, heartRhythmProblems: boolean, faintedInTheLastYear: boolean, canYouClimbTwoFlights: boolean }, anesthesia: { __typename?: 'Anesthesia', answer: boolean, whatType: string, pastProblems: string, issuesIntubating: boolean, malignantHyperthermia: boolean, spineProblems: boolean } } | null, documents: Array<{ __typename?: 'Document', id: Api.DocumentId, createdAt: Api.DateTimeString, updatedAt: Api.DateTimeString, status: DocumentStatus, author?: string | null, name: string, type: FileType, url: string, effectiveAt?: Api.DateTimeString | null, foreignId?: string | null, ocrStatus?: DocumentOcrStatus | null, surgeryId?: Api.SurgeryId | null, analyses?: Array<{ __typename?: 'DocumentAnalysis', id: Api.DocumentAnalysisId, status: JobStatus, type: AnalysisType, documentId: Api.DocumentId, jobId?: string | null } | null> | null }> };

export type FullIntakeFragment = { __typename?: 'IntakeQuestionaire', other: { __typename?: 'TextAnswer', answer: string }, endocrineDisorder: { __typename?: 'TextAnswer', answer: string }, immuneDisorders: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, bloodDisase: { __typename?: 'BooleanAnswer', answer: boolean, description: string }, KidneyDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, liverDisease: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, pulmonaryProblems: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, congestiveHeartFailure: { __typename?: 'SymptomsAnswer', answer: boolean, symptoms: Array<string> }, neurologicalDisorder: { __typename?: 'NeurologicalDisorder', answer: boolean, description: string, lastStroke: string }, diabetes: { __typename?: 'Diabetes', answer: boolean, description: string, a1cLevel: number, areYouTakingInsulin: boolean }, bodilyMedicalDevies: { __typename?: 'BodilyMedicalDevies', deviceName: string, informationCard: boolean, deviceCheckedInLastYear: boolean }, heartProblems: { __typename?: 'HeartProblems', heartStents: boolean, bloodTinners: boolean, heartRhythmProblems: boolean, faintedInTheLastYear: boolean, canYouClimbTwoFlights: boolean }, anesthesia: { __typename?: 'Anesthesia', answer: boolean, whatType: string, pastProblems: string, issuesIntubating: boolean, malignantHyperthermia: boolean, spineProblems: boolean } };

export type SurgeryFragment = { __typename?: 'Surgery', id: Api.SurgeryId, referredOn: any, surgeonName: string, surgeryType: string, dateOfService?: any | null, patientId: Api.PatientId };

export type ObservationPropsFragment = { __typename?: 'Observation', id: Api.ObservationId, patientId: Api.PatientId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, sourceId?: string | null, sourceType?: SourceType | null, sourceUrl?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, encounterDescription?: string | null, overruledByUser?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null };

export type FullObservationFragment = { __typename?: 'Observation', id: Api.ObservationId, patientId: Api.PatientId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, sourceId?: string | null, sourceType?: SourceType | null, sourceUrl?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, encounterDescription?: string | null, observations?: Array<{ __typename?: 'Observation', id: Api.ObservationId, patientId: Api.PatientId, effectiveDate?: Api.DateTimeString | null, system: string, code: string, description: string, value?: number | null, unit?: string | null, sourceId?: string | null, sourceType?: SourceType | null, sourceUrl?: string | null, overruledBy?: Api.UserId | null, overruledType?: OverruledType | null, encounterDescription?: string | null, overruledByUser?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null }> | null, overruledByUser?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null, author?: { __typename?: 'User', id: Api.UserId, firstName: string, lastName: string } | null };

export type FullAddressFragment = { __typename?: 'Address', id: string, address1: string, address2?: string | null, city: string, state: string, zip: string };

export type ConditionPromptFragment = { __typename?: 'Condition', id: Api.ConditionId, primaryCode: string, secondaryCode?: string | null };

export type ConditionFragment = { __typename?: 'Condition', id: Api.ConditionId, deletedAt?: Api.DateTimeString | null, foreignId: string, patientId: Api.PatientId, displayName: string, status: ConditionStatus, lastReconciled?: Api.DateString | null, primarySystem: string, primaryCode: string, secondarySystem?: string | null, secondaryCode?: string | null, onsetDate?: Api.DateString | null, recordedDate?: Api.DateString | null, surgicalRisk: ConditionSurgicalRisk, surgicalRiskReason?: string | null, notes?: string | null };

export type HieJobFragment = { __typename?: 'HieJob', jobStatus?: HieJobStatus | null, createdAt?: Api.DateTimeString | null, updatedAt?: Api.DateTimeString | null, targetCompletionDate?: Api.DateTimeString | null, serviceProviders?: Array<{ __typename?: 'HieServiceProvider', service?: string | null, status?: ServiceProviderJobStatus | null } | null> | null };

export type MedicationPromptFragment = { __typename?: 'Medication', id: Api.MedicationId, displayName: string, activeIngredient?: string | null };

export type MedicationFragment = { __typename?: 'Medication', id: Api.MedicationId, createdAt: Api.DateTimeString, deletedAt?: Api.DateTimeString | null, foreignId: string, activeIngredient?: string | null, activeIngredientCode?: string | null, status: MedicationStatus, lastFilledDate?: Api.DateString | null, lastReconciled?: Api.DateString | null, displayName: string, primarySystem: string, primaryCode: string, confidenceScore?: number | null, confidenceScoreRationale?: string | null, dosageInstructions?: string | null, dosageStart?: Api.DateString | null, dosageEnd?: Api.DateString | null, surgicalRisk: MedicationSurgicalRisk, surgicalRiskReason?: string | null, updatedAt: Api.DateTimeString };

export type CareTeamMemberFragment = { __typename?: 'CareTeamMember', id: string, patientId: string, name: string, specialty: string, phone?: string | null, email?: string | null, fax?: string | null };

export type FullUserFragment = { __typename?: 'User', id: Api.UserId, type: UserType, role: UserRole, firstName: string, lastName: string, email: string, phone: string, status: UserStatus, organizationId: Api.OrganizationId, organizationName: string };

export type BrowserNotificationSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['UserId']>;
  organizationId?: InputMaybe<Scalars['OrganizationId']>;
}>;


export type BrowserNotificationSubscription = { __typename?: 'Subscription', browserNotification?: { __typename?: 'BrowserNotification', id: string, date: Api.DateTimeString, title: string, body: string, url?: string | null } | null };

import * as Api from '~/graphql/api';